export const translations = {
  "My Dashboard": {
    en: "My Dashboard",
    ar: "لوحة التحكم الخاصة بي",
  },
  "My Profile": {
    en: "My Profile",
    ar: "ملفي الشخصي",
  },
  "My Ideas": {
    en: "My Ideas",
    ar: "أفكاري",
  },
  "My Organisation": {
    en: "My Organisation",
    ar: "منظمتي",
  },
  "My Division": {
    en: "My Division",
    ar: "قسم الخاص بي",
  },
  "My Tasks": {
    en: "My Tasks",
    ar: "مهامي",
  },
  "My Projects": {
    en: "My Projects",
    ar: "مشاريعي",
  },
  "My Drawings": {
    en: "My Drawings",
    ar: "رسوماتي",
  },
  "My Notifications": {
    en: "My Notifications",
    ar: "إشعاراتي",
  },
  Notifications: {
    en: "Notifications",
    ar: "الإشعارات",
  },
  "My Inbox": {
    en: "My Inbox",
    ar: "صندوق الوارد الخاص بي",
  },
  Today: {
    en: "Today",
    ar: "اليوم",
  },
  "Today's Task": {
    en: "Today's Task",
    ar: "مهمة اليوم",
  },
  Scheduled: {
    en: "Scheduled",
    ar: "جدول",
  },
  Completed: {
    en: "Completed",
    ar: "تم الانتهاء",
  },
  All: {
    en: "All",
    ar: "الكل",
  },
  "My Approvals": {
    en: "My Approvals",
    ar: "موافقاتي",
  },
  "My Calendar": {
    en: "My Calendar",
    ar: "تقويمي",
  },
  "Generate Idea": {
    en: "Generate Idea",
    ar: "توليد فكرة",
  },
  "Projects Completed": {
    en: "Projects Completed",
    ar: "المشاريع المُنجَزة",
  },
  "Projects Pending": {
    en: "Projects Pending",
    ar: "المشاريع المعلقة",
  },
  "Total Projects": {
    en: "Total Projects",
    ar: "إجمالي المشاريع",
  },
  Home: {
    en: "Home",
    ar: "الرئيسية",
  },
  About: {
    en: "About",
    ar: "حول",
  },
  Contact: {
    en: "Contact",
    ar: "اتصل بنا",
  },
  "Hi, I am Zoro and I will Help you Generate Your Idea Report!": {
    en: "Hi, I am Zoro and I will Help you Generate Your Idea Report!",
    ar: "مرحباً، أنا زورو وسأساعدك في توليد تقرير فكرتك!",
  },
  List: {
    en: "List",
    ar: "قائمة",
  },
  Kanban: {
    en: "Kanban",
    ar: "كانبان",
  },
  Calendar: {
    en: "Calendar",
    ar: "التقويم",
  },
  "Needs Review": {
    en: "Needs Review",
    ar: "يحتاج إلى مراجعة",
  },
  "To Do": {
    en: "To Do",
    ar: "المهام",
  },
  "In Progress": {
    en: "In Progress",
    ar: "قيد التنفيذ",
  },
  "Add Task": {
    en: "Add Task",
    ar: "إضافة مهمة",
  },
  "Apply Filters": {
    en: "Apply Filters",
    ar: "تطبيق الفلاتر",
  },
  "Search your tasks here": {
    en: "Search your tasks here",
    ar: "ابحث في مهامك هنا",
  },
  "Search your projects here": {
    en: "Search your projects here",
    ar: "ابحث عن مشاريعك هنا",
  },
  "Clear Plan": {
    en: "Clear Plan",
    ar: "خطة واضحة",
  },
  Review: {
    en: "Review",
    ar: "مراجعة",
  },
  Planned: {
    en: "Planned",
    ar: "مخطط",
  },
  Archived: {
    en: "Archived",
    ar: "أرشيف",
  },
  "New Improvement Ideas": {
    en: "New Improvement Ideas",
    ar: "أفكار تحسين جديدة",
  },
  "Quick Wins": {
    en: "Quick Wins",
    ar: "انتصارات سريعة",
  },
  "My Team": {
    en: "My Team",
    ar: "فريقي",
  },
  Escalations: {
    en: "Escalations",
    ar: "تصعيدات",
  },
  Celebrations: {
    en: "Celebrations",
    ar: "احتفالات",
  },
  "Team Performance": {
    en: "Team Performance",
    ar: "أداء الفريق",
  },
  Performance: {
    en: "Performance",
    ar: "الأداء",
  },
  "SOLVER Tasks": {
    en: "SOLVER Tasks",
    ar: "مهام SOLVER",
  },
  "IMPROVE Tasks": {
    en: "IMPROVE Tasks",
    ar: "تحسين المهام",
  },
  "Cost Benefit": {
    en: "Cost Benefit",
    ar: "الفائدة مقابل التكلفة",
  },
  "Total Tasks": {
    en: "Total Tasks",
    ar: "إجمالي المهام",
  },
  "Completed Tasks": {
    en: "Completed Tasks",
    ar: "المهام المُنجَزة",
  },
  "Overdue Tasks": {
    en: "Overdue Tasks",
    ar: "المهام المتأخرة",
  },
  "New Drawing": {
    en: "New Drawing",
    ar: "رسم جديد",
  },
  "Your Drawings": {
    en: "Your Drawings",
    ar: "رسوماتك",
  },
  "Filter By": {
    en: "Filter By",
    ar: "تصفية حسب",
  },
  Whiteboard: {
    en: "Whiteboard",
    ar: "السبورة التفاعلية",
  },
  "Project Details": {
    en: "Project Details",
    ar: "تفاصيل المشروع",
  },
  Details: {
    en: "Details",
    ar: "التفاصيل",
  },
  "Milestone & Updates": {
    en: "Milestone & Updates",
    ar: "المعالم والتحديثات",
  },
  "Risks & Issues": {
    en: "Risks & Issues",
    ar: "المخاطر والقضايا",
  },
  Tools: {
    en: "Tools",
    ar: "الأدوات",
  },
  Action: {
    en: "Action",
    ar: "إجراء",
  },
  "Quick Actions": {
    en: "Quick Actions",
    ar: "إجراءات سريعة",
  },
  Votes: {
    en: "Votes",
    ar: "الأصوات",
  },
  "Risk Score": {
    en: "Risk Score",
    ar: "درجة المخاطر",
  },
  Milestones: {
    en: "Milestones",
    ar: "المعالم الرئيسية",
  },
  "Add Raid": {
    en: "Add Raid",
    ar: "إضافة نظام المداهمات",
  },
  "Add Note": {
    en: "Add Note",
    ar: "إضافة ملاحظة",
  },
  "Assign Task": {
    en: "Assign Task",
    ar: "تعيين مهمة",
  },
  Collaborators: {
    en: "Collaborators",
    ar: "المتعاونون",
  },
  "Add Milestones": {
    en: "Add Milestones",
    ar: "إضافة المعالم",
  },
  "View Entire Report": {
    en: "View Entire Report",
    ar: "عرض التقرير الكامل",
  },
  "Filter By Type": {
    en: "Filter By Type",
    ar: "تصفية حسب النوع",
  },
  "Filter By Status": {
    en: "Filter By Status",
    ar: "تصفية حسب الحالة",
  },
  "View Escalations": {
    en: "View Escalations",
    ar: "عرض التصعيدات",
  },
  "Filter By Category": {
    en: "Filter By Category",
    ar: "تصنيف حسب الفئة",
  },
  "Filter By Subcategory": {
    en: "Filter By Subcategory",
    ar: "تصفية حسب الفئة الفرعية",
  },
  "Draw your idea": {
    en: "Draw your idea",
    ar: "يُرجى تقديم فكرتك",
  },
  "Project Drawings": {
    en: "Project Drawings",
    ar: "رسومات المشروع",
  },
  Edit: {
    en: "Edit",
    ar: "تحرير",
  },
  Park: {
    en: "Park",
    ar: "حديقة",
  },
  "Move to Seniors": {
    en: "Move to Seniors",
    ar: "الانتقال إلى كبار السن",
  },
  Logout: {
    en: "Logout",
    ar: "تسجيل الخروج",
  },
  Login: {
    en: "Login",
    ar: "تسجيل الدخول",
  },
  Register: {
    en: "Register",
    ar: "تسجيل",
  },
  Hello: {
    en: "Hello",
    ar: "مرحباً",
  },
  "Create Super Task": {
    en: "Create Super Task",
    ar: "إنشاء مهمة فائقة",
  },
  "Collapse Width?": {
    en: "Collapse Width?",
    ar: "تقليص العرض؟",
  },
  "Full Width?": {
    en: "Full Width?",
    ar: "عرض كامل؟",
  },
  Tomorrow: {
    en: "Tomorrow",
    ar: "غداً",
  },
  "This Month": {
    en: "This Month",
    ar: "هذا الشهر",
  },
  "Sub-Tasks": {
    en: "Subtasks",
    ar: "المهام الفرعية",
  },
  "My Theme": {
    en: "My Theme",
    ar: "موضوعي",
  },
  Theme: {
    en: "Theme",
    ar: "الموضوع",
  },
  "Remove Filters": {
    en: "Remove Filters",
    ar: "إزالة الفلاتر",
  },
  "Clear All": {
    en: "Clear All",
    ar: "مسح الكل",
  },
  "Add Board": {
    en: "Add Board",
    ar: "إضافة لوحة",
  },
  "Add New Task": {
    en: "Add New Task",
    ar: "إضافة مهمة جديدة",
  },
  Generate: {
    en: "Generate",
    ar: "إنشاء",
  },
  "Generate Subtask": {
    en: "Generate Subtask",
    ar: "إنشاء مهمة فرعية",
  },
  Add: {
    en: "Add",
    ar: "إضافة",
  },
  "Get Started": {
    en: "Get Started",
    ar: "ابدأ الآن",
  },
  "Select the category that best suits your project's expected duration:": {
    en: "Select the category that best suits your project's expected duration:",
    ar: "اختر الفئة التي تناسب المدة المتوقعة لمشروعك:",
  },
  "No Projects Available": {
    en: "No Projects Available",
    ar: "لا توجد مشاريع متاحة",
  },
  "No Tasks Available": {
    en: "No Tasks Available",
    ar: "لا توجد مهام متاحة",
  },
  Parked: {
    en: "Parked",
    ar: "مركون",
  },
  "Top Level Priorities": {
    en: "Top Level Priorities",
    ar: "الأولويات العُليا",
  },
  "Annual Objectives": {
    en: "Annual Objectives",
    ar: "الأهداف السنوية",
  },
  "Long Term Objectives": {
    en: "Long Term Objectives",
    ar: "الأهداف طويلة الأمد",
  },
  "Targets to Improve": {
    en: "Targets to Improve",
    ar: "الأهداف للتحسين",
  },
  "Filter By Division": {
    en: "Filter By Division",
    ar: "تصفية حسب القسم",
  },
  "Filter By Department": {
    en: "Filter By Department",
    ar: "تصفية حسب القسم",
  },
  "Go Back": {
    en: "Go Back",
    ar: "العودة",
  },
  Back: {
    en: "Back",
    ar: "عودة",
  },
  "More Details": {
    en: "More Details",
    ar: "المزيد من التفاصيل",
  },
  "Team Members": {
    en: "Team Members",
    ar: "أعضاء الفريق",
  },
  "All Tasks": {
    en: "All Tasks",
    ar: "جميع المهام",
  },
  Tasks: {
    en: "Tasks",
    ar: "المهام",
  },
  Progress: {
    en: "Progress",
    ar: "التقدم",
  },
  "Total Risks": {
    en: "Total Risks",
    ar: "إجمالي المخاطر",
  },
  "No Escalation": {
    en: "No Escalation",
    ar: "لا تصعيد",
  },
  "Milestone Finished": {
    en: "Milestone Finished",
    ar: "تم إنجاز الهدف المرحلي",
  },
  "Nothing here": {
    en: "Nothing here",
    ar: "لا توجد أي بيانات هنا",
  },
  "All Teams": {
    en: "All Teams",
    ar: "جميع الفرق",
  },
  "No Ideas": {
    en: "No Ideas",
    ar: "بدون أفكار",
  },
  "Cost Benefits": {
    en: "Cost Benefits",
    ar: "الفوائد التكلفة",
  },
  "All Comments": {
    en: "All Comments",
    ar: "جميع التعليقات",
  },
  Assign: {
    en: "Assign",
    ar: "تعيين",
  },
  "No Comments": {
    en: "No Comments",
    ar: "• لا توجد تعليقات",
  },
  Comments: {
    en: "Comments",
    ar: "التعليقات",
  },
  "Add your comment": {
    en: "Add your comment",
    ar: "أضف تعليقك",
  },
  "Select User to Assign": {
    en: "Select User to Assign",
    ar: "اختر المستخدم للتعيين",
  },
  "Select Task to Assign": {
    en: "Select Task to Assign",
    ar: "اختيار المهمة لتعيينها",
  },
  "Assign Task to": {
    en: "Assign Task to",
    ar: "تخصيص المهمة إلى",
  },
  "Discuss Escalation": {
    en: "Discuss Escalation",
    ar: "تصعيد الموضوع",
  },
  Read: {
    en: "Read",
    ar: "قراءة",
  },
  Unread: {
    en: "Unread",
    ar: "غير مقروء",
  },
  "Today's Tasks": {
    en: "Today's Tasks",
    ar: "مهام اليوم",
  },
  "No Conversations": {
    en: "No Conversations",
    ar: "عذرًا، لا توجد محادثات متاحة.",
  },
  "Search Conversations": {
    en: "Search Conversations",
    ar: "بحث المحادثات",
  },
  "Add Conversation": {
    en: "Add Conversation",
    ar: "إضافة محادثة",
  },
  Send: {
    en: "Send",
    ar: "إرسال",
  },
  "Add Emoji": {
    en: "Add Emoji",
    ar: "إضافة رمز تعبيري",
  },
  "Please Select a Conversation": {
    en: "Please Select a Conversation",
    ar: "يرجى اختيار محادثة",
  },
  "Sorry, You can't chat with this user!": {
    en: "Sorry, You can't chat with this user!",
    ar: "عذرًا، لا يمكنك الدردشة مع هذا المستخدم!",
  },
  "Enter user email to chat": {
    en: "Enter user email to chat",
    ar: "أدخل البريد الإلكتروني للمستخدم لبدء المحادثة",
  },
  "View Details": {
    en: "View Details",
    ar: "عرض التفاصيل",
  },
  Upvote: {
    en: "Upvote",
    ar: "تأييد",
  },
  Downvote: {
    en: "Downvote",
    ar: "عدم الإعجاب",
  },
  "Invite Collaborators": {
    en: "Invite Collaborators",
    ar: "دعوة المتعاونين",
  },
  Notes: {
    en: "Notes",
    ar: "ملاحظات",
  },
  "Mark as Complete": {
    en: "Mark as Complete",
    ar: "وضع علامة كمنجز",
  },
  "Mark as Incomplete": {
    en: "Mark as Incomplete",
    ar: "وضع علامة كغير مكتمل",
  },
  "Edit Notes": {
    en: "Edit Notes",
    ar: "ملاحظات التحرير",
  },
  "Delete Notes": {
    en: "Delete Notes",
    ar: " حذف الملاحظات",
  },
  "Task Breakdown": {
    en: "Task Breakdown",
    ar: "تفصيل المهام",
  },
  "Edit Milestones": {
    en: "Edit Milestones",
    ar: "تحرير المعالم",
  },
  "Delete Milestones": {
    en: "Delete Milestones",
    ar: "حذف المعالم",
  },
  "Generate Subtasks": {
    en: "Generate Subtasks",
    ar: "إنشاء المهام الفرعية",
  },
  "Show Subtasks": {
    en: "Show Subtasks",
    ar: "عرض المهام الفرعية",
  },
  "No Milstones": {
    en: "No Milstones",
    ar: "بدون معالم",
  },
  "Select a Category": {
    en: "Select a Category",
    ar: "اختر فئة",
  },
  "Select a sub category": {
    en: "Select a sub category",
    ar: "اختر فئة فرعية",
  },
  "View Risks": {
    en: "View Risks",
    ar: "عرض المخاطر",
  },
  Category: {
    en: "Category",
    ar: "الفئة",
  },
  "Sub Category": {
    en: "Sub Category",
    ar: "الفئة الفرعية",
  },
  Mitigate: {
    en: "Mitigate",
    ar: "التخفيف",
  },
  Delegate: {
    en: "Delegate",
    ar: "تفويض",
  },
  escalate: {
    en: "escalate",
    ar: "تصعيد",
  },
  delete: {
    en: "delete",
    ar: "حذف",
  },
  Delete: {
    en: "Delete",
    ar: "حذف",
  },
  Settings: {
    en: "Settings",
    ar: "الإعدادات",
  },
  Mitigation: {
    en: "Mitigation",
    ar: "التخفيف",
  },
  Delegation: {
    en: "Delegation",
    ar: "التفويض",
  },
  "Draw Your Idea": {
    en: "Draw Your Idea",
    ar: "ارسم فكرتك",
  },
  Approve: {
    en: "Approve",
    ar: "موافقة",
  },
  "Select one or more users to Assign": {
    en: "Select one or more users to Assign",
    ar: "اختر مستخدمًا أو أكثر للتعيين",
  },
  "Select a Task to Assign": {
    en: "Select a Task to Assign",
    ar: "اختر مهمة لتعيينها",
  },
  "Why do you want to Delegate this project to Seniors?": {
    en: "Why do you want to Delegate this project to Seniors?",
    ar: "لماذا ترغب في تفويض هذا المشروع إلى كبار الموظفين؟",
  },
  "Delegate to Seniors": {
    en: "Delegate to Seniors",
    ar: "تفويض إلى كبار المسؤولين",
  },
  "Enter Reason to Park": {
    en: "Enter Reason to Park",
    ar: "أدخل سبب الإيقاف",
  },
  "Park Project": {
    en: "Park Project",
    ar: "مشروع المنتزه",
  },
  "Enter Details": {
    en: "Enter Details",
    ar: "أدخل التفاصيل",
  },
  "Need Further Information": {
    en: "Need Further Information",
    ar: "بحاجة إلى مزيد من المعلومات",
  },
  "SubCategory Of Escalation": {
    en: "SubCategory Of Escalation",
    ar: "فئة فرعية للتصعيد",
  },
  "Category Of Escalation": {
    en: "Category Of Escalation",
    ar: "فئة التصعيد",
  },
  "Select the urgency level for this escalation": {
    en: "Select the urgency level for this escalation",
    ar: "اختر مستوى الطوارئ لهذه الترقية",
  },
  "Why do you need to escalate this risk to Seniors?": {
    en: "Why do you need to escalate this risk to Seniors?",
    ar: "لماذا تحتاج إلى تصعيد هذا الخطر إلى الإدارة العليا؟",
  },
  "Enter user email to invite": {
    en: "Enter user email to invite",
    ar: "أدخل بريد المستخدم الإلكتروني للإرسال الدعوة",
  },
  "Send Invite": {
    en: "Send Invite",
    ar: "إرسال دعوة",
  },
  "What is the deadline for addressing this risk?": {
    en: "What is the deadline for addressing this risk?",
    ar: "ما هو الموعد النهائي لمعالجة هذا الخطر؟",
  },
  "What specific actions must the assignee take to manage this risk?": {
    en: "What specific actions must the assignee take to manage this risk?",
    ar: "ما هي الإجراءات الملموسة التي يجب على الشخص المكلف اتخاذها لإدارة هذا الخطر؟",
  },
  "Enter Details here": {
    en: "Enter Details here",
    ar: "أدخل التفاصيل هنا",
  },
  "Who will be responsible for managing this risk?": {
    en: "Who will be responsible for managing this risk?",
    ar: "من سيكون المسؤول عن إدارة هذا المخاطر؟",
  },
  "Start Delegation": {
    en: "Start Delegation",
    ar: "بدء التفويض",
  },
  "Set key milestones and the final deadline for the mitigation process": {
    en: "Set key milestones and the final deadline for the mitigation process",
    ar: "تحديد المعالم الرئيسية والموعد النهائي لإنهاء عملية التخفيف",
  },
  "List resources here": {
    en: "List resources here",
    ar: "قائمة الموارد هنا",
  },
  "Outline the steps necessary to execute the mitigation plan": {
    en: "Outline the steps necessary to execute the mitigation plan",
    ar: "توضيح الخطوات اللازمة لتنفيذ خطة التخفيف من المخاطر",
  },
  "List all resources required to implement the mitigation strategy": {
    en: "List all resources required to implement the mitigation strategy",
    ar: "قائمة جميع الموارد المطلوبة لتنفيذ استراتيجية التخفيف.",
  },
  "Describe your solution here": {
    en: "Describe your solution here",
    ar: "وصف الحل هنا",
  },
  "Describe your proposed strategy to mitigate this risk": {
    en: "Describe your proposed strategy to mitigate this risk",
    ar: "وصف استراتيجيتك المقترحة للتخفيف من هذا الخطر",
  },
  Update: {
    en: "Update",
    ar: "تحديث",
  },
  "Should this be added to the meeting agenda?": {
    en: "Should this be added to the meeting agenda?",
    ar: "هل ينبغي إضافة هذا إلى جدول أعمال الاجتماع؟",
  },
  "Describe your issue here": {
    en: "Describe your issue here",
    ar: "وصف المشكلة هنا",
  },
  "Please provide details about your concern": {
    en: "Please provide details about your concern",
    ar: "يرجى تقديم تفاصيل حول مشكلتك أو استفسارك",
  },
  "Add a General Concern": {
    en: "Add a General Concern",
    ar: "إضافة استفسار عام",
  },
  "Does this need immediate attention from your team manager?": {
    en: "Does this need immediate attention from your team manager?",
    ar: "هل يتطلب هذا اهتمامًا فوريًا من مدير فريقك؟",
  },
  "What have you done to try to resolve this issue?": {
    en: "What have you done to try to resolve this issue?",
    ar: "ماذا فعلت لمحاولة حل هذه المشكلة؟",
  },
  "How is this issue impacting your work or the project?": {
    en: "How is this issue impacting your work or the project?",
    ar: "كيف يؤثر هذه المشكلة على عملك أو المشروع؟",
  },
  "Describe the current problem affecting the project": {
    en: "Describe the current problem affecting the project",
    ar: "يرجى وصف المشكلة الحالية التي تؤثر على المشروع",
  },
  "Add an Issue": {
    en: "Add an Issue",
    ar: "إضافة مشكلة",
  },
  "Likelihood of Risk": {
    en: "Likelihood of Risk",
    ar: "احتمال المخاطر",
  },
  "Describe your suggestion here": {
    en: "Describe your suggestion here",
    ar: "وصف اقتراحك هنا",
  },
  "Do you have any suggestions for how this risk might be mitigated?": {
    en: "Do you have any suggestions for how this risk might be mitigated?",
    ar: "هل لديكم أي اقتراحات حول كيفية التخفيف من هذا الخطر؟",
  },
  "What could be the impact if this risk materializes?": {
    en: "What could be the impact if this risk materializes?",
    ar: "ما هو الأثر المحتمل إذا تحقق هذا الخطر؟",
  },
  "Describe the potential future problem you foresee": {
    en: "Describe the potential future problem you foresee",
    ar: "وصف المشكلة المحتملة في المستقبل التي تتوقعها",
  },
  "Describe your problem here": {
    en: "Describe your problem here",
    ar: "وصف مشكلتك هنا",
  },
  "Add a Risk": {
    en: "Add a Risk",
    ar: "إضافة خطر",
  },
  Risk: {
    en: "Risk",
    ar: "المخاطر",
  },
  Issue: {
    en: "Issue",
    ar: "مشكلة",
  },
  "General Concern": {
    en: "General Concern",
    ar: "قلق عام",
  },
  "Select the type of concern you are reporting": {
    en: "Select the type of concern you are reporting",
    ar: "اختر نوع المشكلة التي ترغب بالإبلاغ عنها",
  },
  Submit: {
    en: "Submit",
    ar: "إرسال",
  },
  Priority: {
    en: "Priority",
    ar: "الأولوية",
  },
  Complexity: {
    en: "Complexity",
    ar: "تعقيد",
  },
  Milestone: {
    en: "Milestone",
    ar: "المرحلة الانجازية",
  },
  "Select Milestone": {
    en: "Select Milestone",
    ar: "اختر المعلم الزمني",
  },
  Status: {
    en: "Status",
    ar: "الحالة",
  },
  "Select Status": {
    en: "Select Status",
    ar: "اختر الحالة",
  },
  "Due Date": {
    en: "Due Date",
    ar: "تاريخ الاستحقاق",
  },
  Title: {
    en: "Title",
    ar: "عنوان",
  },
  Description: {
    en: "Description",
    ar: "الوصف",
  },
  "Edit Milestone": {
    en: "Edit Milestone",
    ar: "تعديل المرحلة الرئيسية",
  },
  "is Completed?": {
    en: "is Completed?",
    ar: "هل اكتمل؟",
  },
  "Enter a note here": {
    en: "Enter a note here",
    ar: "أدخل ملاحظة هنا",
  },
  "Edit Project Note": {
    en: "Edit Project Note",
    ar: "تعديل ملاحظة المشروع",
  },
  "Add Project Note": {
    en: "Add Project Note",
    ar: "إضافة ملاحظة للمشروع",
  },
  "Compelion Innovation Management RaaS Platform": {
    en: "Compelion Innovation Management RaaS Platform",
    ar: "منصة كومبليون لإدارة الابتكار كخدمة (RaaS)",
  },
  "Our RaaS platform leverages advanced AI technologies to streamline and enhance your innovation processes.":
    {
      en: "Our RaaS platform leverages advanced AI technologies to streamline and enhance your innovation processes.",
      ar: "منصة RaaS الخاصة بنا تستفيد من تقنيات الذكاء الاصطناعي المتقدمة لتبسيط وتحسين عمليات الابتكار الخاصة بك.",
    },
  "Compelion: Innovation Management Solutions": {
    en: "Compelion: Innovation Management Solutions",
    ar: "كومبليون: حلول إدارة الابتكار",
  },
  "At Compelion, we offer a dual approach to innovation management through our state-of-the-art RaaS platform and expert consulting services":
    {
      en: "At Compelion, we offer a dual approach to innovation management through our state-of-the-art RaaS platform and expert consulting services",
      ar: "في شركة Compelion، نقدّم نهجًا مزدوجًا لإدارة الابتكار من خلال منصتنا المتطورة RaaS وخدماتنا الاستشارية المتخصصة.",
    },
  "Revolutionising Innovation Management with AI": {
    en: "Revolutionising Innovation Management with AI",
    ar: "إعادة تعريف إدارة الابتكار باستخدام الذكاء الاصطناعي",
  },
  "We can analyse your idea and give you a proper report on that to convert it into reality":
    {
      en: "We can analyse your idea and give you a proper report on that to convert it into reality",
      ar: "يمكننا تحليل فكرتك وتزويدك بتقرير مفصل لتحويلها إلى واقع.",
    },
  "Meet Our": {
    en: "Meet Our",
    ar: "تعرف على فريقنا",
  },
  Bots: {
    en: "Bots",
    ar: "الروبوتات",
  },
  "Compelion's AI bots are at the core of our innovation management platform, designed to assist and automate various aspects of the innovation lifecycle. Here's a closer look at each bot and its role":
    {
      en: "Compelion's AI bots are at the core of our innovation management platform, designed to assist and automate various aspects of the innovation lifecycle. Here's a closer look at each bot and its role",
      ar: "يتمركز روبوتات الذكاء الاصطناعي لشركة Compelion في قلب منصتنا لإدارة الابتكار، والتي تم تصميمها لتقديم المساعدة والأتمتة لمختلف جوانب دورة حياة الابتكار. إليك نظرة أكثر تفصيلًا على كل روبوت ودوره.",
    },
  "Strategic Insight Bot": {
    en: "Strategic Insight Bot",
    ar: "روبوت الرؤية الاستراتيجية",
  },
  "Provides deep insights into strategic alignment and identifies opportunities for innovation":
    {
      en: "Provides deep insights into strategic alignment and identifies opportunities for innovation",
      ar: "يوفر تحليلات متعمقة حول التوافق الاستراتيجي ويحدد فرص الابتكار",
    },
  "Strategic Alignment Analysis": {
    en: "Strategic Alignment Analysis",
    ar: "تحليل التوافق الاستراتيجي",
  },
  "Evaluates how well current and proposed innovation initiatives align with strategic goals":
    {
      en: "Evaluates how well current and proposed innovation initiatives align with strategic goals",
      ar: "يقيم مدى توافق المبادرات الابتكارية الحالية والمقترحة مع الأهداف الاستراتيجية",
    },
  "Gap Identification": {
    en: "Gap Identification",
    ar: "تحديد الفجوات",
  },
  "Detects gaps in strategic alignment and suggests potential areas for innovation":
    {
      en: "Detects gaps in strategic alignment and suggests potential areas for innovation",
      ar: "يرصد الفجوات في التوافق الاستراتيجي ويقترح مجالات محتملة للابتكار",
    },
  "Opportunity Mapping": {
    en: "Opportunity Mapping",
    ar: "رسم خريطة الفرص",
  },
  "Maps out emerging opportunities based on market trends and internal capabilities":
    {
      en: "Maps out emerging opportunities based on market trends and internal capabilities",
      ar: "يرسم فرصًا ناشئة بناءً على توجهات السوق والقدرات الداخلية",
    },
  "Idea Enhancement Bot": {
    en: "Idea Enhancement Bot",
    ar: "روبوت تعزيز الأفكار",
  },
  "Enhances initial ideas into detailed business cases, ensuring viability and strategic alignment":
    {
      en: "Enhances initial ideas into detailed business cases, ensuring viability and strategic alignment",
      ar: "يعزز الأفكار الأولية لتتحول إلى حالات أعمال مفصلة، مما يضمن الجدوى والمواءمة الاستراتيجية.",
    },
  "Business Case Development": {
    en: "Business Case Development",
    ar: "إعداد دراسة الجدوى الاقتصادية",
  },
  "Converts basic ideas into comprehensive business cases, evaluating feasibility and strategic fit":
    {
      en: "Converts basic ideas into comprehensive business cases, evaluating feasibility and strategic fit",
      ar: "يحوِّل الأفكار الأساسية إلى حالات عمل شاملة، ويقيِّم الجدوى والمواءمة الاستراتيجية",
    },
  "Best Practices Application": {
    en: "Best Practices Application",
    ar: "أفضل الممارسات للتطبيق",
  },
  "Utilises frameworks to assess and improve ideas, ensuring alignment with best practices":
    {
      en: "Utilises frameworks to assess and improve ideas, ensuring alignment with best practices",
      ar: "يستفيد من الأطر لتقييم وتحسين الأفكار، مع ضمان التوافق مع أفضل الممارسات",
    },
  "Improvement Recommendations": {
    en: "Improvement Recommendations",
    ar: "توصيات تحسين الأداء",
  },
  "Suggests enhancements based on historical data and successful case studies":
    {
      en: "Suggests enhancements based on historical data and successful case studies",
      ar: "يقترح تحسينات بناءً على البيانات التاريخية ودراسات الحالة الناجحة",
    },
  "Problem-Solving Bot": {
    en: "Problem-Solving Bot",
    ar: "روبوت حل المشكلات",
  },
  "Focuses on diagnosing and addressing the root causes of problems using advanced analytical tools":
    {
      en: "Focuses on diagnosing and addressing the root causes of problems using advanced analytical tools",
      ar: "يركز على تشخيص ومعالجة الأسباب الجذرية للمشكلات باستخدام أدوات تحليلية متقدمة",
    },
  "Ishikawa Diagram Automation": {
    en: "Ishikawa Diagram Automation",
    ar: "أتمتة مخطط إيشيكاوا",
  },
  "Creates cause-and-effect diagrams to help identify the root causes of issues":
    {
      en: "Creates cause-and-effect diagrams to help identify the root causes of issues",
      ar: "يُنشئ مخططات السبب والأثر للمساعدة في تحديد الأسباب الجذرية للمشكلات",
    },
  "Process Mapping": {
    en: "Process Mapping",
    ar: "رسم العمليات",
  },
  "Generates detailed process maps to visualise workflows and identify bottlenecks":
    {
      en: "Generates detailed process maps to visualise workflows and identify bottlenecks",
      ar: "يُنشئ خرائط عملية مفصلة لتوضيح سير العمل وتحديد نقاط الاختناق",
    },
  "Root Cause Analysis": {
    en: "Root Cause Analysis",
    ar: "تحليل الأسباب الجذرية",
  },
  "Uses AI to analyse data and provide insights into potential root causes and solutions":
    {
      en: "Uses AI to analyse data and provide insights into potential root causes and solutions",
      ar: "يستخدم الذكاء الاصطناعي لتحليل البيانات وتوفير رؤى حول الأسباب الجذرية المحتملة والحلول",
    },
  "Project Management Bot": {
    en: "Project Management Bot",
    ar: "روبوت إدارة المشاريع",
  },
  "Acts as a virtual project manager, handling routine tasks and providing insights to keep projects on track":
    {
      en: "Acts as a virtual project manager, handling routine tasks and providing insights to keep projects on track",
      ar: "يعمل كمدير مشروع افتراضي، يدير المهام الروتينية ويوفر رؤى للمحافظة على سير المشاريع بشكل منظم",
    },
  "Task Automation": {
    en: "Task Automation",
    ar: "أتوماتيكية المهام",
  },
  "Automates routine project management tasks, freeing up teams to focus on strategic activities":
    {
      en: "Automates routine project management tasks, freeing up teams to focus on strategic activities",
      ar: "يعمل على أتمتة مهام إدارة المشاريع الروتينية، مما يتيح للفرق التفرغ للتركيز على الأنشطة الاستراتيجية.",
    },
  "Clear Plan Dashboards": {
    en: "Clear Plan Dashboards",
    ar: "لوحات معلومات خطة العمل الواضحة",
  },
  "Offers visual dashboards to align projects with organisational vision and goals":
    {
      en: "Offers visual dashboards to align projects with organisational vision and goals",
      ar: "يوفر لوحات تحكم بصرية لمواءمة المشاريع مع رؤية وأهداف المنظمة",
    },
  "Catchball Communication": {
    en: "Catchball Communication",
    ar: "تواصل التشارك في الأفكار",
  },
  "Facilitates effective communication and feedback loops within project teams":
    {
      en: "Facilitates effective communication and feedback loops within project teams",
      ar: "يعزز التواصل الفعال وآليات التغذية الراجعة داخل فرق العمل بالمشاريع",
    },
  "Kanban and List View": {
    en: "Kanban and List View",
    ar: "عرض كانبان وعرض القائمة",
  },
  "Manages tasks and tracks progress using Kanban boards and list views for focused areas":
    {
      en: "Manages tasks and tracks progress using Kanban boards and list views for focused areas",
      ar: "يدير المهام ويتابع التقدم باستخدام لوحات كانبان وعروض القوائم للمجالات المركزة",
    },
  "Collaboration Bot": {
    en: "Collaboration Bot",
    ar: "بوت التعاون",
  },
  "Enhances team collaboration and ensures alignment among all project participants":
    {
      en: "Enhances team collaboration and ensures alignment among all project participants",
      ar: "يعزز التعاون بين الفرق ويضمن التوافق بين جميع المشاركين في المشروع",
    },
  "Agenda Management": {
    en: "Agenda Management",
    ar: "إدارة الأجندة",
  },
  "Organises and manages project meetings, ensuring all team members are prepared and aligned":
    {
      en: "Organises and manages project meetings, ensuring all team members are prepared and aligned",
      ar: "ينظم ويدير اجتماعات المشروع، مع ضمان استعداد وتوافق جميع أعضاء الفريق",
    },
  "Discussion Tracking": {
    en: "Discussion Tracking",
    ar: "متابعة المناقشات",
  },
  "Keeps track of ongoing discussions and decisions, helping teams stay coordinated":
    {
      en: "Keeps track of ongoing discussions and decisions, helping teams stay coordinated",
      ar: "يتابع المناقشات والقرارات الجارية، مما يساعد الفرق على البقاء منسجمة.",
    },
  "Engagement Monitoring": {
    en: "Engagement Monitoring",
    ar: "مراقبة المشاركة",
  },
  "Monitors team participation and engagement, providing insights into areas needing attention":
    {
      en: "Monitors team participation and engagement, providing insights into areas needing attention",
      ar: "يراقب مشاركة الفريق وتفاعله، ويقدم رؤى حول المجالات التي تحتاج إلى اهتمام",
    },
  "Assurance Bot": {
    en: "Assurance Bot",
    ar: "بوت التأكيد",
  },
  "Provides clarity on the progress and status of projects for executives and project owners":
    {
      en: "Provides clarity on the progress and status of projects for executives and project owners",
      ar: "يوفر وضوحاً حول تقدم وحالة المشاريع للمديرين التنفيذيين ومالكي المشاريع",
    },
  "Progress Tracking": {
    en: "Progress Tracking",
    ar: "متابعة التقدم",
  },
  "Monitors project milestones and delivers real-time updates on progress": {
    en: "Monitors project milestones and delivers real-time updates on progress",
    ar: "يراقب معالم المشروع ويقدم تحديثات فورية حول التقدم المحرز",
  },
  "Risk Management": {
    en: "Risk Management",
    ar: "إدارة المخاطر",
  },
  "Identifies potential risks and issues early, offering recommendations for mitigation":
    {
      en: "Identifies potential risks and issues early, offering recommendations for mitigation",
      ar: "يحدد المخاطر والقضايا المحتملة مبكراً، ويقدم توصيات للتخفيف منها",
    },
  "Performance Reporting": {
    en: "Performance Reporting",
    ar: "تقارير الأداء",
  },
  "Generates detailed reports on project performance, highlighting key achievements and areas for improvement":
    {
      en: "Generates detailed reports on project performance, highlighting key achievements and areas for improvement",
      ar: "يولد تقارير مفصلة حول أداء المشروع، مع تسليط الضوء على الإنجازات الرئيسية ومجالات التحسين",
    },
  "Task Assistant Bot": {
    en: "Task Assistant Bot",
    ar: "مساعد المهام الآلية",
  },
  "Helps users manage their daily tasks and deadlines, providing a clear view of responsibilities":
    {
      en: "Helps users manage their daily tasks and deadlines, providing a clear view of responsibilities",
      ar: "يساعد المستخدمين في إدارة مهامهم اليومية ومواعيدهم النهائية، مما يوفر رؤية واضحة للمسؤوليات",
    },
  "My Day Overview": {
    en: "My Day Overview",
    ar: "نظرة عامة على يومي",
  },
  "Compiles a personalised list of tasks for the day, including scheduled, planned, and pending items":
    {
      en: "Compiles a personalised list of tasks for the day, including scheduled, planned, and pending items",
      ar: "يجمع قائمة مخصصة بالمهام اليومية تشمل العناصر المجدولة والمخططة والمعلقة.",
    },
  "Automated Scheduling": {
    en: "Automated Scheduling",
    ar: "الجدولة الآلية",
  },
  "Assists users in prioritising and scheduling tasks effectively": {
    en: "Assists users in prioritising and scheduling tasks effectively",
    ar: "يساعد المستخدمين في تحديد أولويات المهام وجدولتها بشكل فعال",
  },
  "Notifications and Alerts": {
    en: "Notifications and Alerts",
    ar: "الإشعارات والتنبيهات",
  },
  "Sends reminders and alerts to keep users informed about upcoming deadlines and required actions":
    {
      en: "Sends reminders and alerts to keep users informed about upcoming deadlines and required actions",
      ar: "يرسل التذكيرات والتنبيهات لإبقاء المستخدمين على اطلاع بالمواعيد النهائية القادمة والإجراءات المطلوبة.",
    },
  "Why Choose Us?": {
    en: "Why Choose Us?",
    ar: "لماذا تختارنا؟",
  },
  "Comprehensive Solutions": {
    en: "Comprehensive Solutions",
    ar: "حلول شاملة",
  },
  "We offer both a cutting-edge RaaS platform and expert consulting services, providing a complete solution to your innovation needs":
    {
      en: "We offer both a cutting-edge RaaS platform and expert consulting services, providing a complete solution to your innovation needs",
      ar: "نحن نقدم منصة روبوتات كخدمة (RaaS) متطورة بالإضافة إلى خدمات استشارية متخصصة، لنوفر لكم حلاً شاملاً يلبي احتياجاتكم في مجال الابتكار.",
    },
  "Proven Expertise": {
    en: "Proven Expertise",
    ar: "الخبرة المثبتة",
  },
  "Our team's extensive experience and proven methodologies are backed by success stories from leading companies":
    {
      en: "Our team's extensive experience and proven methodologies are backed by success stories from leading companies",
      ar: "تستند خبرات فريقنا الواسعة ومنهجياتنا المثبتة إلى قصص نجاح من شركات رائدة",
    },
  "Quick Results": {
    en: "Quick Results",
    ar: "نتائج سريعة",
  },
  "Our tools and frameworks are designed for rapid deployment and quick value delivery, helping you see tangible benefits in weeks, not years":
    {
      en: "Our tools and frameworks are designed for rapid deployment and quick value delivery, helping you see tangible benefits in weeks, not years",
      ar: "تم تصميم أدواتنا وإطارات العمل لدينا لتحقيق النشر السريع وتقديم القيمة بسرعة، مما يساعدك على رؤية الفوائد الملموسة في غضون أسابيع، وليس سنوات.",
    },
  "Inclusive Innovation": {
    en: "Inclusive Innovation",
    ar: "الابتكار الشامل",
  },
  "Foster a culture where everyone can contribute to innovation, ensuring diverse inputs and faster breakthroughs":
    {
      en: "Foster a culture where everyone can contribute to innovation, ensuring diverse inputs and faster breakthroughs",
      ar: "تعزيز ثقافة يُمكن فيها للجميع المساهمة في الابتكار، لضمان تنوع المدخلات وتحقيق اكتشافات أسرع.",
    },
  "Our Services": {
    en: "Our Services",
    ar: "خدماتنا",
  },
  "AI-Driven Strategic Insights": {
    en: "AI-Driven Strategic Insights",
    ar: "تحليلات استراتيجية مدفوعة بالذكاء الاصطناعي",
  },
  "Strategic Understanding": {
    en: "Strategic Understanding",
    ar: "الفهم الاستراتيجي",
  },
  "Utilise AI to analyse and understand your organisation's strategic objectives and align innovation initiatives accordingly":
    {
      en: "Utilise AI to analyse and understand your organisation's strategic objectives and align innovation initiatives accordingly",
      ar: "استخدم الذكاء الاصطناعي لتحليل وفهم الأهداف الاستراتيجية لمنظمتك وتوجيه المبادرات الابتكارية بما يتوافق معها",
    },
  "Gap Analysis and Opportunity Identification": {
    en: "Gap Analysis and Opportunity Identification",
    ar: "تحليل الفجوات وتحديد الفرص",
  },
  "Identify strategic gaps and innovation opportunities that align with your business goals and market trends":
    {
      en: "Identify strategic gaps and innovation opportunities that align with your business goals and market trends",
      ar: "تحديد الفجوات الاستراتيجية وفرص الابتكار التي تتماشى مع أهداف عملك واتجاهات السوق.",
    },
  "Intelligent Idea Management": {
    en: "Intelligent Idea Management",
    ar: "إدارة الأفكار الذكية",
  },
  "Automated Idea Elaboration": {
    en: "Automated Idea Elaboration",
    ar: "التطوير الآلي للأفكار",
  },
  "Transform simple ideas into comprehensive business cases using AI-driven best practices, ensuring they are detailed and viable":
    {
      en: "Transform simple ideas into comprehensive business cases using AI-driven best practices, ensuring they are detailed and viable",
      ar: "تحويل الأفكار البسيطة إلى دراسات جدوى شاملة باستخدام ممارسات الذكاء الاصطناعي المثلى لضمان تفاصيلها وقابليتها للتطبيق",
    },
  "Full Lifecycle Management": {
    en: "Full Lifecycle Management",
    ar: "إدارة دورة الحياة الكاملة",
  },
  "Manage the entire idea lifecycle from initial capture through evaluation, development, and execution, ensuring each idea is thoroughly vetted and strategically aligned":
    {
      en: "Manage the entire idea lifecycle from initial capture through evaluation, development, and execution, ensuring each idea is thoroughly vetted and strategically aligned",
      ar: "إدارة دورة حياة الفكرة بالكامل من الالتقاط الأولي وحتى التقييم والتطوير والتنفيذ، لضمان فحص كل فكرة بدقة وتوافقها الاستراتيجي.",
    },
  "Enhanced Collaboration and Engagement": {
    en: "Enhanced Collaboration and Engagement",
    ar: "التعاون والمشاركة المعززة",
  },
  "Crowd Intelligence": {
    en: "Crowd Intelligence",
    ar: "الذكاء الجماعي",
  },
  "Foster a collaborative environment where ideas are enhanced through collective input from diverse teams across the organization":
    {
      en: "Foster a collaborative environment where ideas are enhanced through collective input from diverse teams across the organization",
      ar: "تعزيز بيئة تعاونية حيث تُعزز الأفكار من خلال المدخلات الجماعية من فرق متنوعة عبر المؤسسة",
    },
  "Engagement Tools": {
    en: "Engagement Tools",
    ar: "أدوات التفاعل",
  },
  "Use gamification and engagement strategies to encourage widespread participation and idea contribution":
    {
      en: "Use gamification and engagement strategies to encourage widespread participation and idea contribution",
      ar: "استخدام استراتيجيات التلعيب والتفاعل لتعزيز المشاركة الواسعة والمساهمة بالأفكار",
    },
  "Advanced Validation and Evaluation": {
    en: "Advanced Validation and Evaluation",
    ar: "التحقق المتقدم والتقييم",
  },
  "AI-Powered Validation": {
    en: "AI-Powered Validation",
    ar: "التوثيق المدعوم بتقنية الذكاء الاصطناعي",
  },
  "Automatically evaluate ideas against a set of best practice criteria to ensure they are feasible and aligned with organisational goals":
    {
      en: "Automatically evaluate ideas against a set of best practice criteria to ensure they are feasible and aligned with organisational goals",
      ar: "قم بتقييم الأفكار تلقائيًا وفقًا لمجموعة من المعايير الأفضل للممارسات لضمان أنها قابلة للتنفيذ ومتوافقة مع أهداف المنظمة.",
    },
  "Outcome Simulation": {
    en: "Outcome Simulation",
    ar: "محاكاة النتائج",
  },
  "Predict potential outcomes and impacts of implementing new ideas to make informed decisions":
    {
      en: "Predict potential outcomes and impacts of implementing new ideas to make informed decisions",
      ar: "التنبؤ بالنتائج المحتملة وتأثيرات تطبيق الأفكار الجديدة لاتخاذ قرارات مستنيرة",
    },
  "Seamless Integration": {
    en: "Seamless Integration",
    ar: "التكامل السلس",
  },
  "Easy Onboarding": {
    en: "Easy Onboarding",
    ar: "سهولة الإعداد الأولي",
  },
  "Quickly integrate our platform with your existing systems and processes to start reaping benefits immediately":
    {
      en: "Quickly integrate our platform with your existing systems and processes to start reaping benefits immediately",
      ar: "قم بدمج منصتنا بسرعة مع الأنظمة والعمليات الحالية لديك لبدء الاستفادة الفورية",
    },
  "User-Friendly Interface": {
    en: "User-Friendly Interface",
    ar: "واجهة مستخدم مريحة",
  },
  "Our intuitive platform design ensures ease of use and rapid adoption across all levels of your organization":
    {
      en: "Our intuitive platform design ensures ease of use and rapid adoption across all levels of your organization",
      ar: "يضمن التصميم البديهي لمنصتنا سهولة الاستخدام والتبني السريع على جميع مستويات مؤسستكم",
    },
  "Get Started with Compelion": {
    en: "Get Started with Compelion",
    ar: "ابدأ مع منصة كومبليون",
  },
  "Transform your innovation journey today with Compelion's integrated approach. Schedule a consultation to learn how our RaaS platform and consulting services can help your organization achieve its innovation goals efficiently and effectively":
    {
      en: "Transform your innovation journey today with Compelion's integrated approach. Schedule a consultation to learn how our RaaS platform and consulting services can help your organization achieve its innovation goals efficiently and effectively",
      ar: "حقق تحولاً في مسيرة الابتكار الخاصة بك اليوم مع نهج Compelion المتكامل. احجز استشارة لتتعرف على كيفية مساعدة منصة 'الروبوتات كخدمة' (RaaS) وخدماتنا الاستشارية لمؤسستك على تحقيق أهداف الابتكار بكفاءة وفعالية.",
    },
  "Schedule a Consultation": {
    en: "Schedule a Consultation",
    ar: "جدولة استشارة",
  },
  "Explore Platform": {
    en: "Explore Platform",
    ar: "استكشاف المنصة",
  },
  COMPANY: {
    en: "COMPANY",
    ar: "شركة",
  },
  HELP: {
    en: "HELP",
    ar: "مساعدة",
  },
  "Customer Support": {
    en: "Customer Support",
    ar: "دعم العملاء",
  },
  "Terms & Conditions": {
    en: "Terms & Conditions",
    ar: "الشروط والأحكام",
  },
  "Privacy Policy": {
    en: "Privacy Policy",
    ar: "سياسة الخصوصية",
  },
  "Connect with Us": {
    en: "Connect with Us",
    ar: "اتصل بنا",
  },
  "© Copyright": {
    en: "© Copyright",
    ar: "© حقوق الطبع والنشر",
  },
  "All Rights Reserved by Compelion": {
    en: "All Rights Reserved by Compelion",
    ar: "جميع الحقوق محفوظة لشركة Compelion",
  },
  "Insightful Analytics": {
    en: "Insightful Analytics",
    ar: "تحليلات معمقة",
  },
  "Interactive Analytics": {
    en: "Interactive Analytics",
    ar: "تحليلات تفاعلية",
  },
  Analytics: {
    en: "Analytics",
    ar: "تحليلات",
  },
  "Analyse project, teams, tasks, etc. performance through interactive and insightful charts, graphs, etc":
    {
      en: "Analyse project, teams, tasks, etc. performance through interactive and insightful charts, graphs, etc",
      ar: "تحليل أداء المشاريع والفرق والمهام وما إلى ذلك من خلال الرسوم البيانية التفاعلية والبصرية الوافية",
    },
  "Compelion Consulting Services": {
    en: "Compelion Consulting Services",
    ar: "خدمات استشارات كومبليون",
  },
  "In addition to our cutting-edge RaaS platform, we offer tailored consulting services to help you build and sustain robust innovation capabilities. Our expert team partners with you to address your unique challenges and drive your innovation strategy forward.":
    {
      en: "In addition to our cutting-edge RaaS platform, we offer tailored consulting services to help you build and sustain robust innovation capabilities. Our expert team partners with you to address your unique challenges and drive your innovation strategy forward.",
      ar: "بالإضافة إلى منصتنا المتطورة بنظام الراوبوتات كخدمة (RaaS)، نقدم خدمات استشارية مخصصة لمساعدتك في بناء وتعزيز قدرات الابتكار القوية لديك. يتعاون فريقنا من الخبراء معك لمعالجة التحديات الفريدة التي تواجهك، ودفع استراتيجيتك الابتكارية إلى الأمام.",
    },
  "Comprehensive Innovation Culture Analysis": {
    en: "Comprehensive Innovation Culture Analysis",
    ar: "تحليل شامل لثقافة الابتكار",
  },
  "Insightful Evaluation": {
    en: "Insightful Evaluation",
    ar: "تقييم مُعَمَّق",
  },
  "We analyse how innovation is perceived and practiced across different departments, identifying strengths and areas for improvement.":
    {
      en: "We analyse how innovation is perceived and practiced across different departments, identifying strengths and areas for improvement.",
      ar: "نقوم بتحليل كيفية إدراك الابتكار وممارسته عبر الأقسام المختلفة، بهدف تحديد نقاط القوة ومجالات التحسين.",
    },
  "Opportunity Identification": {
    en: "Opportunity Identification",
    ar: "تحديد الفرص",
  },
  "Discover gaps and potential opportunities for fostering a culture of innovation within your organization.":
    {
      en: "Discover gaps and potential opportunities for fostering a culture of innovation within your organization.",
      ar: "اكتشف الفجوات والفرص المحتملة لتعزيز ثقافة الابتكار داخل مؤسستك.",
    },
  "Individual Profiles": {
    en: "Individual Profiles",
    ar: "الملفات الشخصية الفردية",
  },
  "Assess the innovation potential and tendencies of your team members to leverage their unique capabilities.":
    {
      en: "Assess the innovation potential and tendencies of your team members to leverage their unique capabilities.",
      ar: "قيّم إمكانات الابتكار والميول لأعضاء فريقك لتعظيم الاستفادة من قدراتهم الفريدة.",
    },
  "Strategic Innovation Alignment": {
    en: "Strategic Innovation Alignment",
    ar: "محاذاة الابتكار الاستراتيجي",
  },
  "Value Propositions Development": {
    en: "Value Propositions Development",
    ar: "تطوير مقترحات القيمة",
  },
  "Craft clear and communicable value propositions that resonate with both your employees and customers.":
    {
      en: "Craft clear and communicable value propositions that resonate with both your employees and customers.",
      ar: "قم بصياغة مقترحات قيمة واضحة وقابلة للتواصل، تتماشى مع احتياجات موظفيك وعملائك في آن واحد.",
    },
  "Strategic Fit Assessment": {
    en: "Strategic Fit Assessment",
    ar: "تقييم الملاءمة الاستراتيجية",
  },
  "Ensure your innovation initiatives are aligned with your current goals and future aspirations.":
    {
      en: "Ensure your innovation initiatives are aligned with your current goals and future aspirations.",
      ar: "تأكد من أن مبادرات الابتكار لديك تتوافق مع أهدافك الحالية وتطلعاتك المستقبلية.",
    },
  "Focus Areas Identification": {
    en: "Focus Areas Identification",
    ar: "تحديد مجالات التركيز",
  },
  "Identify critical areas for innovation to streamline idea generation processes.":
    {
      en: "Identify critical areas for innovation to streamline idea generation processes.",
      ar: "تحديد المجالات الحيوية للابتكار لتحسين عمليات توليد الأفكار.",
    },
  "Building Innovation-Enabling Structures": {
    en: "Building Innovation-Enabling Structures",
    ar: "بناء هياكل تمكينية للابتكار",
  },
  "Distributed Innovation": {
    en: "Distributed Innovation",
    ar: "الابتكار الموزع",
  },
  "Embed innovation as a core function across all levels of your organization, not just within a single team.":
    {
      en: "Embed innovation as a core function across all levels of your organization, not just within a single team.",
      ar: "اجعل الابتكار وظيفة أساسية في جميع مستويات مؤسستك، وليس فقط ضمن فريق واحد.",
    },
  "Scalable Structures": {
    en: "Scalable Structures",
    ar: "البُنى القابلة للتوسّع",
  },
  "Create and adapt structures to support various types of innovation—whether enhancing current operations, expanding into new markets, or exploring future possibilities.":
    {
      en: "Create and adapt structures to support various types of innovation—whether enhancing current operations, expanding into new markets, or exploring future possibilities.",
      ar: "إنشاء وتكييف هياكل تدعم أنواع مختلفة من الابتكار—سواء كان لتعزيز العمليات الحالية، التوسع في أسواق جديدة، أو استكشاف إمكانات مستقبلية.",
    },
  "Implementing Agile Innovation Processes": {
    en: "Implementing Agile Innovation Processes",
    ar: "تنفيذ عمليات الابتكار الرشيق",
  },
  "Adaptive Methodologies": {
    en: "Adaptive Methodologies",
    ar: "المنهجيات التكيفية",
  },
  "Introduce agile processes that align with your strategy and allow for rapid response to evolving business needs.":
    {
      en: "Introduce agile processes that align with your strategy and allow for rapid response to evolving business needs.",
      ar: "قدم عمليات أجايل تتماشى مع استراتيجيتك وتتيح الاستجابة السريعة لاحتياجات الأعمال المتغيرة باستمرار.",
    },
  "Effective Idea Implementation": {
    en: "Effective Idea Implementation",
    ar: "تنفيذ الفكرة بشكل فعّال",
  },
  "From ideation to market launch, streamline processes to bring your best ideas to fruition efficiently and effectively.":
    {
      en: "From ideation to market launch, streamline processes to bring your best ideas to fruition efficiently and effectively.",
      ar: "من الفكرة إلى إطلاق السوق، قم بتبسيط العمليات لتحويل أفضل أفكارك إلى واقع بكفاءة وفعالية.",
    },
  "Continuous Monitoring and Evaluation": {
    en: "Continuous Monitoring and Evaluation",
    ar: "المراقبة والتقييم المستمران",
  },
  "Engagement and Participation Tracking": {
    en: "Engagement and Participation Tracking",
    ar: "تتبع التفاعل والمشاركة",
  },
  "Monitor the health of your innovation community to understand participation levels and behaviours.":
    {
      en: "Monitor the health of your innovation community to understand participation levels and behaviours.",
      ar: "راقب صحة مجتمع الابتكار لديك لفهم مستويات المشاركة والسلوكيات.",
    },
  "Performance and Outcome Assessment": {
    en: "Performance and Outcome Assessment",
    ar: "تقييم الأداء والنتائج",
  },
  "Regularly evaluate the impact of your innovation initiatives to ensure they deliver value and align with your strategic goals.":
    {
      en: "Regularly evaluate the impact of your innovation initiatives to ensure they deliver value and align with your strategic goals.",
      ar: "قم بتقييم تأثير مبادرات الابتكار الخاصة بك بانتظام للتأكد من أنها توفر القيمة وتتوافق مع أهدافك الاستراتيجية.",
    },
  "Empowering People to Innovate": {
    en: "Empowering People to Innovate",
    ar: "تمكين الأفراد من الابتكار",
  },
  "Engagement Strategies": {
    en: "Engagement Strategies",
    ar: "استراتيجيات التفاعل",
  },
  "Develop strategies to attract, onboard, and engage employees in your innovation efforts.":
    {
      en: "Develop strategies to attract, onboard, and engage employees in your innovation efforts.",
      ar: "تطوير استراتيجيات لجذب الموظفين وتدشينهم وإشراكهم في جهود الابتكار.",
    },
  "Support and Recognition": {
    en: "Support and Recognition",
    ar: "الدعم والتقدير",
  },
  "Provide clear pathways for contribution and recognise those who add value through innovation.":
    {
      en: "Provide clear pathways for contribution and recognise those who add value through innovation.",
      ar: "وفِّر مسارات واضحة للمساهمة واعترف بالذين يضفون قيمة من خلال الابتكار.",
    },
  "Alignment for Impact": {
    en: "Alignment for Impact",
    ar: "التوافق لتحقيق التأثير",
  },
  "Align individual contributions with organisational goals for maximum impact.":
    {
      en: "Align individual contributions with organisational goals for maximum impact.",
      ar: "محاذاة المساهمات الفردية مع الأهداف التنظيمية لتحقيق أقصى قدر من التأثير.",
    },
  "Innovation Workshops": {
    en: "Innovation Workshops",
    ar: "ورش العمل الابتكارية",
  },
  "Customised Workshops": {
    en: "Customised Workshops",
    ar: "ورش عمل مخصصة",
  },
  "Tailor workshops to meet your specific needs, from sparking creativity and solving complex problems to aligning your team with strategic goals.":
    {
      en: "Tailor workshops to meet your specific needs, from sparking creativity and solving complex problems to aligning your team with strategic goals.",
      ar: "قم بتخصيص ورش العمل لتلبية احتياجاتك المحددة، سواء لتحفيز الإبداع أو لحل المشكلات المعقدة، أو لمواءمة فريقك مع الأهداف الاستراتيجية.",
    },
  "Interactive and Engaging": {
    en: "Interactive and Engaging",
    ar: "تفاعلي وجذاب",
  },
  "Foster active participation and collaboration through hands-on, engaging workshop formats.":
    {
      en: "Foster active participation and collaboration through hands-on, engaging workshop formats.",
      ar: "تعزيز المشاركة الفعالة والتعاون من خلال صيغ ورش العمل التفاعلية والجذابة.",
    },
  "Outcome-Focused": {
    en: "Outcome-Focused",
    ar: "مرتكز على النتائج",
  },
  "Deliver actionable insights and practical solutions that can be implemented immediately.":
    {
      en: "Deliver actionable insights and practical solutions that can be implemented immediately.",
      ar: "توفير رؤى قابلة للتنفيذ وحلول عملية يمكن تنفيذها على الفور.",
    },
  "Is project Approved?": {
    en: "Is project Approved?",
    ar: "هل تم اعتماد المشروع؟",
  },
  "Is project mandatory?": {
    en: "Is project mandatory?",
    ar: "هل المشروع إلزامي؟",
  },
  "Strategic Theme": {
    en: "Strategic Theme",
    ar: "التوجه الإستراتيجي",
  },
  Impact: {
    en: "Impact",
    ar: "الأثر",
  },
  "Enter Project Impact": {
    en: "Enter Project Impact",
    ar: "إدخال تأثير المشروع",
  },
  "Update Project": {
    en: "Update Project",
    ar: "تحديث المشروع",
  },
  "Enter Project Title": {
    en: "Enter Project Title",
    ar: "أدخل عنوان المشروع",
  },
  "Enter Project Description": {
    en: "Enter Project Description",
    ar: "أدخل وصف المشروع",
  },
  Benefits: {
    en: "Benefits",
    ar: "المزايا",
  },
  "Enter Project Benefits": {
    en: "Enter Project Benefits",
    ar: "إدخال فوائد المشروع",
  },
  "No Ideas Found!": {
    en: "No Ideas Found!",
    ar: "لم يتم العثور على أفكار!",
  },
  "At Compelion, we do more than manage ideas—we bring them to life. Powered by AI, precise analytics, and world-class methodologies, we turn bold visions into actionable strategies. Every idea is guided toward measurable success, delivering real results and lasting impact. Where ideas take flight and strategy soars, Compelion is your partner in driving innovation, growth, and strategic excellence":
    {
      en: "At Compelion, we do more than manage ideas—we bring them to life. Powered by AI, precise analytics, and world-class methodologies, we turn bold visions into actionable strategies. Every idea is guided toward measurable success, delivering real results and lasting impact. Where ideas take flight and strategy soars, Compelion is your partner in driving innovation, growth, and strategic excellence",
      ar: "في شركة Compelion، نحن لا نكتفي بإدارة الأفكار—بل نحولها إلى واقع. بفضل تقنيات الذكاء الاصطناعي، والتحليلات الدقيقة، والمنهجيات العالمية، نقوم بتحويل الرؤى الجريئة إلى استراتيجيات عملية. كل فكرة تُوجّه نحو تحقيق نجاح يمكن قياسه، مما يعود بنتائج حقيقية وتأثير مستدام. حيث تُحلق الأفكار وتزدهر الاستراتيجيات، تكون Compelion شريككم في قيادة الابتكار والنمو والتميز الاستراتيجي.",
    },
  "Why Compelion Is Your Premier Choice?": {
    en: "Why Compelion Is Your Premier Choice?",
    ar: "لماذا تعتبر كومبليون خياركم الأمثل؟",
  },
  "By choosing Compelion, you’re not just selecting a platform—you’re partnering with a leader committed to propelling your organisation’s innovation to new heights. Embrace the future with a solution that’s as visionary as your ambitions.":
    {
      en: "By choosing Compelion, you’re not just selecting a platform—you’re partnering with a leader committed to propelling your organisation’s innovation to new heights. Embrace the future with a solution that’s as visionary as your ambitions.",
      ar: "باختياركم لمنصة كومبيليون، أنتم لا تختارون مجرد منصة بل تتعاونون مع قائد ملتزم بدفع ابتكارات مؤسستكم إلى آفاق جديدة. تبنوا المستقبل بحل يتماشى مع طموحاتكم ورؤيتكم المستقبلية.",
    },
  "Pioneering Technology": {
    en: "Pioneering Technology",
    ar: "التكنولوجيا الرائدة",
  },
  "Stay ahead with AI innovations that drive competitive advantage": {
    en: "Stay ahead with AI innovations that drive competitive advantage",
    ar: "ابقَ في الطليعة مع ابتكارات الذكاء الاصطناعي التي تدعم التحول التنافسي",
  },
  "Methodological Excellence": {
    en: "Methodological Excellence",
    ar: "التميز المنهجي",
  },
  "Benefit from best-in-class practices integrated into every facet.": {
    en: "Benefit from best-in-class practices integrated into every facet.",
    ar: "استفد من أفضل الممارسات المتكاملة في كل جانب.",
  },
  "Strategic Precision": {
    en: "Strategic Precision",
    ar: "الدقة الاستراتيجية",
  },
  "Align every initiative with your core objectives for maximum impact.": {
    en: "Align every initiative with your core objectives for maximum impact.",
    ar: "قم بمواءمة كل مبادرة مع أهدافك الأساسية لتحقيق أقصى تأثير.",
  },
  "Unmatched Customisation": {
    en: "Unmatched Customisation",
    ar: "تخصيص لا مثيل له",
  },
  "Adapt the platform to your evolving needs with ease.": {
    en: "Adapt the platform to your evolving needs with ease.",
    ar: "تكيف مع المنصة لتلبية احتياجاتك المتطورة بكل سهولة.",
  },
  "Commitment to Perfection": {
    en: "Commitment to Perfection",
    ar: "الالتزام بالكمال",
  },
  "Experience a solution that embodies the best in technology and methodology.":
    {
      en: "Experience a solution that embodies the best in technology and methodology.",
      ar: "اختبر حلاً يجسد أفضل تقنيات ومنهجيات البرمجيات.",
    },
  "Embark on the Compelion Journey": {
    en: "Embark on the Compelion Journey",
    ar: "ابدأ رحلة Compelion",
  },
  "Spark Innovation": {
    en: "Spark Innovation",
    ar: "ابتكار تشغيلي",
  },
  "Effortless Idea Capture": {
    en: "Effortless Idea Capture",
    ar: "استحواذ الأفكار بسهولة",
  },
  "Share your inspirations anytime, anywhere, through our intuitive platform.":
    {
      en: "Share your inspirations anytime, anywhere, through our intuitive platform.",
      ar: "شارك إلهاماتك في أي وقت ومن أي مكان عبر منصتنا السهلة الاستخدام.",
    },
  "Global Inspirations": {
    en: "Global Inspirations",
    ar: "الإلهامات العالمية",
  },
  "Ignite creativity with insights from Six Sigma, Kaizen, and other world-class methodologies.":
    {
      en: "Ignite creativity with insights from Six Sigma, Kaizen, and other world-class methodologies.",
      ar: "أشعل الإبداع باستخدام رؤى من منهجيات ستة سيجما وكايزن وغيرها من المنهجيات العالمية الرائدة.",
    },
  "Customer Voices": {
    en: "Customer Voices",
    ar: "آراء العملاء",
  },
  "Integrate feedback directly from customers to fuel meaningful innovation.": {
    en: "Integrate feedback directly from customers to fuel meaningful innovation.",
    ar: "تكامل ملاحظات العملاء بشكل مباشر لتحفيز الابتكار الهادف.",
  },
  "Intelligent Idea Evolution": {
    en: "Intelligent Idea Evolution",
    ar: "تطوير الأفكار الذكية",
  },
  "AI Enhancement": {
    en: "AI Enhancement",
    ar: "تحسين الذكاء الاصطناعي",
  },
  "Watch as your ideas are refined and elevated by our intelligent AI for maximum impact.":
    {
      en: "Watch as your ideas are refined and elevated by our intelligent AI for maximum impact.",
      ar: "شاهد كيف تقوم تقنيتنا الذكية بتحسين أفكارك والارتقاء بها لتحقيق أقصى تأثير.",
    },
  "Idea Scorecards": {
    en: "Idea Scorecards",
    ar: "بطاقات تقييم الأفكار",
  },
  "Effortlessly evaluate viability and strategic alignment with AI-generated scorecards.":
    {
      en: "Effortlessly evaluate viability and strategic alignment with AI-generated scorecards.",
      ar: "قم بتقييم الجدوى والمواءمة الاستراتيجية بسلاسة باستخدام البطاقات التقييمية المُولدة بواسطة الذكاء الاصطناعي.",
    },
  "Instant Business Cases": {
    en: "Instant Business Cases",
    ar: "دراسات حالة الأعمال الفورية",
  },
  "Receive comprehensive, ready-to-implement business cases complete with detailed cost-benefit analyses and future projections.":
    {
      en: "Receive comprehensive, ready-to-implement business cases complete with detailed cost-benefit analyses and future projections.",
      ar: "استلم دراسات جدوى شاملة وجاهزة للتنفيذ تتضمن تحليلات تفصيلية للتكلفة والفائدة وتوقعات مستقبلية.",
    },
  "Strategic Planning": {
    en: "Strategic Planning",
    ar: "التخطيط الاستراتيجي",
  },
  "Link short-term actions to the big vision": {
    en: "Link short-term actions to the big vision",
    ar: "ربط الإجراءات قصيرة المدى بالرؤية الكبيرة",
  },
  "Connect every action to your long-term goals using Clear Plan principles, ensuring that your strategy stays on course.":
    {
      en: "Connect every action to your long-term goals using Clear Plan principles, ensuring that your strategy stays on course.",
      ar: "اربط كل إجراء بأهدافك طويلة الأمد باستخدام مبادئ الخطة الواضحة، مضمناً بقاء استراتيجيتك على المسار الصحيح.",
    },
  "Track and achieve goals": {
    en: "Track and achieve goals",
    ar: "تتبع وحقق الأهداف",
  },
  "Keep your team focused and achieve measurable results, making every goal attainable.":
    {
      en: "Keep your team focused and achieve measurable results, making every goal attainable.",
      ar: "حافظ على تركيز فريقك وحقق نتائج قابلة للقياس، مما يجعل كل هدف في متناول اليد.",
    },
  "Confidently implement strategies": {
    en: "Confidently implement strategies",
    ar: "تنفيذ الاستراتيجيات بثقة",
  },
  "Use data-backed strategies and metrics to guide your projects towards success at every step.":
    {
      en: "Use data-backed strategies and metrics to guide your projects towards success at every step.",
      ar: "استخدم استراتيجيات مدعومة بالبيانات ومقاييس ملموسة لتوجيه مشاريعك نحو النجاح في كل خطوة.",
    },
  "Advanced Planning Tools": {
    en: "Advanced Planning Tools",
    ar: "أدوات التخطيط المتقدمة",
  },
  "Visualize processes in real-time": {
    en: "Visualize processes in real-time",
    ar: "تصوّر العمليات في الوقت الفعلي",
  },
  "Plan processes in real-time using AI-powered whiteboards, giving you the ability to see the way ahead clearly.":
    {
      en: "Plan processes in real-time using AI-powered whiteboards, giving you the ability to see the way ahead clearly.",
      ar: "خطط العمليات في الوقت الفعلي باستخدام اللوحات البيضاء المدعومة بالذكاء الاصطناعي، مما يمنحك القدرة على رؤية المستقبل بوضوح.",
    },
  "Predict accurately": {
    en: "Predict accurately",
    ar: "التنبؤ بدقة",
  },
  "Use tools like Monte Carlo simulations and statistical process control charts to anticipate outcomes and mitigate risks.":
    {
      en: "Use tools like Monte Carlo simulations and statistical process control charts to anticipate outcomes and mitigate risks.",
      ar: "استخدم أدوات مثل محاكاة مونت كارلو ومخططات التحكم في العمليات الإحصائية للتنبؤ بالنتائج وتقليل المخاطر.",
    },
  "Proactively address risks": {
    en: "Proactively address risks",
    ar: "التعامل الاستباقي مع المخاطر",
  },
  "Identify and overcome potential obstacles early on through AI-supported risk assessments.":
    {
      en: "Identify and overcome potential obstacles early on through AI-supported risk assessments.",
      ar: "التعرف على العقبات المحتملة والتغلب عليها مسبقاً من خلال تقييمات المخاطر المدعومة بالذكاء الاصطناعي.",
    },
  "Seamless Execution": {
    en: "Seamless Execution",
    ar: "تنفيذ سلس",
  },
  "Automated task management": {
    en: "Automated task management",
    ar: "إدارة المهام المؤتمتة",
  },
  "Let AI handle the details—generating tasks, assigning them to the right people, and syncing them in calendars so nothing falls through the cracks.":
    {
      en: "Let AI handle the details—generating tasks, assigning them to the right people, and syncing them in calendars so nothing falls through the cracks.",
      ar: "دع الذكاء الاصطناعي يتولى التفاصيل – إنشاء المهام، وتوزيعها على الأشخاص المناسبين، ومزامنتها مع الجداول الزمنية لضمان عدم تفويت أي شيء.",
    },
  "Customized reminders": {
    en: "Customized reminders",
    ar: "التذكيرات المخصصة",
  },
  "Stay on track with smart notifications and daily reminders that highlight what matters most.":
    {
      en: "Stay on track with smart notifications and daily reminders that highlight what matters most.",
      ar: "ابقَ على المسار الصحيح مع الإشعارات الذكية والتذكيرات اليومية التي تسلط الضوء على الأمور الأكثر أهمية.",
    },
  "Integrated workflows": {
    en: "Integrated workflows",
    ar: "تكامل سير العمل",
  },
  "Enjoy workflows that adapt to your team's needs, ensuring every project runs smoothly from start to finish.":
    {
      en: "Enjoy workflows that adapt to your team's needs, ensuring every project runs smoothly from start to finish.",
      ar: "استمتع بتدفقات العمل التي تتكيف مع احتياجات فريقك، مما يضمن سلاسة تنفيذ كل مشروع من البداية إلى النهاية.",
    },
  "Understand your team's pulse": {
    en: "Understand your team's pulse",
    ar: "افهم نبض فريقك",
  },
  "Use sentiment analysis to gauge team morale and uncover insights from every note.":
    {
      en: "Use sentiment analysis to gauge team morale and uncover insights from every note.",
      ar: "استخدم تحليل المشاعر لقياس معنويات الفريق واكتشاف الأفكار من كل ملاحظة.",
    },
  "Measure project impact": {
    en: "Measure project impact",
    ar: "قياس تأثير المشروع",
  },
  "Track your innovation's success by evaluating key performance indicators (KPIs) against set objectives.":
    {
      en: "Track your innovation's success by evaluating key performance indicators (KPIs) against set objectives.",
      ar: "تابع نجاح ابتكاراتك من خلال تقييم مؤشرات الأداء الرئيسية (KPIs) مقارنةً بالأهداف المحددة.",
    },
  "Dashboard Visualization": {
    en: "Dashboard Visualization",
    ar: "عرض لوحة التحكم",
  },
  "Visualize complex data easily to identify trends and drive informed decision-making.":
    {
      en: "Visualize complex data easily to identify trends and drive informed decision-making.",
      ar: "تَصَوُّر البيانات المعقدة بسهولة للتعرُّف على الاتجاهات واتخاذ قرارات مبنية على أسس معلوماتية.",
    },
  "Celebrate Achievements": {
    en: "Celebrate Achievements",
    ar: "الاحتفاء بالإنجازات",
  },
  "Recognize contributions": {
    en: "Recognize contributions",
    ar: "تقدير المساهمات",
  },
  "Celebrate each milestone, big or small, to foster a culture of appreciation and motivation.":
    {
      en: "Celebrate each milestone, big or small, to foster a culture of appreciation and motivation.",
      ar: "احتفل بكل إنجاز، كبيراً كان أو صغيراً، لتعزيز ثقافة التقدير والتحفيز.",
    },
  "Share Success Stories": {
    en: "Share Success Stories",
    ar: "قصص النجاح",
  },
  "Inspire your team by sharing success stories and the impact of innovative ideas.":
    {
      en: "Inspire your team by sharing success stories and the impact of innovative ideas.",
      ar: "ألهم فريقك بمشاركة قصص النجاح وأثر الأفكار المبتكرة.",
    },
  "Provide Feedback": {
    en: "Provide Feedback",
    ar: "تقديم الملاحظات",
  },
  "Encourage continuous improvement by providing constructive feedback on all ideas shared.":
    {
      en: "Encourage continuous improvement by providing constructive feedback on all ideas shared.",
      ar: "حث على التحسين المستمر من خلال تقديم ملاحظات بناءة على جميع الأفكار المشتركة.",
    },
  "Your Vision, Our Journey": {
    en: "Your Vision, Our Journey",
    ar: "رؤيتكم، رحلتنا المشتركة",
  },
  "Join us on this exciting journey of innovation.": {
    en: "Join us on this exciting journey of innovation.",
    ar: "انضموا إلينا في هذه الرحلة المثيرة نحو الابتكار.",
  },
  "Clear Plan Alignment": {
    en: "Clear Plan Alignment",
    ar: "محاذاة الخطة بوضوح",
  },
  "Seamlessly link short-term actions with your long-term vision using Clear Plan principles.":
    {
      en: "Seamlessly link short-term actions with your long-term vision using Clear Plan principles.",
      ar: "اربط بين الإجراءات قصيرة الأمد ورؤيتك طويلة الأمد بكل سهولة باستخدام مبادئ الخطة الواضحة.",
    },
  "Goal Tracking": {
    en: "Goal Tracking",
    ar: "تتبع الأهداف",
  },
  "Keep your team aligned with transparent objectives and key results.": {
    en: "Keep your team aligned with transparent objectives and key results.",
    ar: "حافظ على انسجام فريقك من خلال أهداف ونتائج رئيسية واضحة وشفافة.",
  },
  "Dynamic Strategy Deployment": {
    en: "Dynamic Strategy Deployment",
    ar: "نشر الاستراتيجية الديناميكية",
  },
  "Implement clear strategies with defined metrics to ensure success.": {
    en: "Implement clear strategies with defined metrics to ensure success.",
    ar: "قم بتنفيذ استراتيجيات واضحة مع مؤشرات قياس محددة لضمان النجاح.",
  },
  "AI-Powered Whiteboard": {
    en: "AI-Powered Whiteboard",
    ar: "السبورة الذكية المدعومة بالذكاء الاصطناعي",
  },
  "Visualize and map processes effortlessly with AI-generated diagrams and flowcharts.":
    {
      en: "Visualize and map processes effortlessly with AI-generated diagrams and flowcharts.",
      ar: "تصوّر ورسم العمليات بسهولة باستخدام المخططات والرسوم البيانية المدعومة بالذكاء الاصطناعي.",
    },
  "Advanced Forecasting": {
    en: "Advanced Forecasting",
    ar: "التنبؤ المتقدم",
  },
  "Utilize Monte Carlo simulations and SPC charts to predict outcomes and stay on track.":
    {
      en: "Utilize Monte Carlo simulations and SPC charts to predict outcomes and stay on track.",
      ar: "استخدم محاكاة مونتي كارلو ومخططات التحكم الإحصائي في العمليات (SPC) للتنبؤ بالنتائج والحفاظ على المسار السليم.",
    },
  "Risk Assessment": {
    en: "Risk Assessment",
    ar: "تقييم المخاطر",
  },
  "Identify potential challenges early with AI-driven risk analysis.": {
    en: "Identify potential challenges early with AI-driven risk analysis.",
    ar: "التعرف المبكر على التحديات المحتملة باستخدام تحليل المخاطر المدعوم بالذكاء الاصطناعي.",
  },
  "Automated Task Management": {
    en: "Automated Task Management",
    ar: "إدارة المهام الآلية",
  },
  "Let AI generate tasks, assign them to the right people, and sync calendars effortlessly.":
    {
      en: "Let AI generate tasks, assign them to the right people, and sync calendars effortlessly.",
      ar: "دع الذكاء الاصطناعي ينشئ المهام، ويعينها للأشخاص المناسبين، ويزامن الجداول بسهولة.",
    },
  "Smart Notifications": {
    en: "Smart Notifications",
    ar: "الإشعارات الذكية",
  },
  "Stay focused with personalized reminders and “My Day” views highlighting priorities.":
    {
      en: "Stay focused with personalized reminders and “My Day” views highlighting priorities.",
      ar: "ابقَ مركزًا مع التذكيرات المخصصة وواجهات 'يومي' التي تسلط الضوء على الأولويات.",
    },
  "Integrated Workflows": {
    en: "Integrated Workflows",
    ar: "التدفقات العمل المتكاملة",
  },
  "Enjoy smooth operations with processes that adapt dynamically to your needs.":
    {
      en: "Enjoy smooth operations with processes that adapt dynamically to your needs.",
      ar: "استمتع بتشغيل سلس مع عمليات تتكيف بشكل ديناميكي مع احتياجاتك.",
    },
  "Sentiment Analysis": {
    en: "Sentiment Analysis",
    ar: "تحليل الشعور",
  },
  "Gauge team enthusiasm and understand feedback through nuanced language analysis.":
    {
      en: "Gauge team enthusiasm and understand feedback through nuanced language analysis.",
      ar: "قياس حماس الفريق وفهم التغذية الراجعة من خلال تحليل لغوي متقدم.",
    },
  "Performance Metrics": {
    en: "Performance Metrics",
    ar: "مقاييس الأداء",
  },
  "Monitor project progress with real-time data and analytics.": {
    en: "Monitor project progress with real-time data and analytics.",
    ar: "راقب تقدم المشروع باستخدام البيانات والتحليلات في الوقت الفعلي.",
  },
  "Executive Dashboards": {
    en: "Executive Dashboards",
    ar: "لوحة القيادة التنفيذية",
  },
  "Access leaderboards showcasing top performers and insightful reports for informed decision-making.":
    {
      en: "Access leaderboards showcasing top performers and insightful reports for informed decision-making.",
      ar: "الوصول إلى لوحات الصدارة التي تعرض أفضل الأداءين والتقارير المفصلة لاتخاذ قرارات مبنية على معلومات دقيقة.",
    },
  "Empowered Collaboration": {
    en: "Empowered Collaboration",
    ar: "التعاون الفعّال",
  },
  "Unified Communication": {
    en: "Unified Communication",
    ar: "الاتصالات الموحّدة",
  },
  "Collaborate effortlessly across teams with intuitive, seamless tools.": {
    en: "Collaborate effortlessly across teams with intuitive, seamless tools.",
    ar: "تعاون بفعالية بين الفرق باستخدام أدوات سلسة وبديهية.",
  },
  "Comms Bot": {
    en: "Comms Bot",
    ar: "البوت الاتصالي",
  },
  "Share success stories and updates to inspire and inform everyone.": {
    en: "Share success stories and updates to inspire and inform everyone.",
    ar: "مشاركة قصص النجاح والتحديثات لإلهام الجميع وإخطارهم.",
  },
  "Engaging Culture": {
    en: "Engaging Culture",
    ar: "التفاعل الثقافي",
  },
  "Foster a collaborative environment with regular recognition of achievements.":
    {
      en: "Foster a collaborative environment with regular recognition of achievements.",
      ar: "تعزيز بيئة تعاونية مع الاعتراف المنتظم بالإنجازات.",
    },
  "Contact Us": {
    en: "Contact Us",
    ar: "اتصل بنا",
  },
  "We’re here to help you succeed!": {
    en: "We’re here to help you succeed!",
    ar: "نحن هنا لمساعدتك على تحقيق النجاح!",
  },
  "Whether you have a question, want to explore our services, or discuss how we can support your business, we’re ready to connect.":
    {
      en: "Whether you have a question, want to explore our services, or discuss how we can support your business, we’re ready to connect.",
      ar: "سواء كان لديك سؤال، أو ترغب في استكشاف خدماتنا، أو مناقشة كيفية دعم أعمالك، نحن جاهزون للتواصل معك.",
    },
  "Your Full Name": {
    en: "Your Full Name",
    ar: "اسمك الكامل",
  },
  "Please enter your name": {
    en: "Please enter your name",
    ar: "يرجى إدخال اسمك",
  },
  "Please enter a valid name without numbers or symbols.": {
    en: "Please enter a valid name without numbers or symbols.",
    ar: "يرجى إدخال اسم صالح خالٍ من الأرقام أو الرموز.",
  },
  "Your Email Address": {
    en: "Your Email Address",
    ar: "عنوان بريدك الإلكتروني",
  },
  "Please enter your email": {
    en: "Please enter your email",
    ar: "يرجى إدخال بريدك الإلكتروني",
  },
  "Please enter a valid email address": {
    en: "Please enter a valid email address",
    ar: "يرجى إدخال عنوان بريد إلكتروني صالح",
  },
  "Your Phone Number (Optional)": {
    en: "Your Phone Number (Optional)",
    ar: "رقم هاتفك (اختياري)",
  },
  "Please enter a valid phone number.": {
    en: "Please enter a valid phone number.",
    ar: "يرجى إدخال رقم هاتف صالح.",
  },
  "Reason for Contacting": {
    en: "Reason for Contacting",
    ar: "سبب الاتصال",
  },
  "Please select a reason for contacting": {
    en: "Please select a reason for contacting",
    ar: "يرجى اختيار سبب التواصل",
  },
  "Select the reason for contacting us": {
    en: "Select the reason for contacting us",
    ar: "اختر سبب الاتصال بنا",
  },
  "Sales Inquiry": {
    en: "Sales Inquiry",
    ar: "استفسار مبيعات",
  },
  "Partnership Opportunity": {
    en: "Partnership Opportunity",
    ar: "فرصة شراكة",
  },
  "General Question": {
    en: "General Question",
    ar: "سؤال عام",
  },
  "Technical Support": {
    en: "Technical Support",
    ar: "الدعم الفني",
  },
  "Media/Press Inquiry": {
    en: "Media/Press Inquiry",
    ar: "استفسار الوسائط/الصحافة",
  },
  "Event or Speaking Engagement": {
    en: "Event or Speaking Engagement",
    ar: "فعالية أو مشاركة في حدث خطاب",
  },
  Other: {
    en: "Other",
    ar: "أخرى",
  },
  "Tell us more about how we can assist you": {
    en: "Tell us more about how we can assist you",
    ar: "حدثنا أكثر عن كيفية مساعدتنا لك.",
  },
  "Sending...": {
    en: "Sending...",
    ar: "جارٍ الإرسال...",
  },
  "Send Your Message": {
    en: "Send Your Message",
    ar: "إرسال رسالتك",
  },
  "Thank you for getting in touch!": {
    en: "Thank you for getting in touch!",
    ar: "شكرًا لتواصلك معنا!",
  },
  "A member of our team will reach out to you within 24 hours.": {
    en: "A member of our team will reach out to you within 24 hours.",
    ar: "سيتواصل معك أحد أعضاء فريقنا خلال 24 ساعة.",
  },
  "We look forward to helping you achieve your goals with Compelion.": {
    en: "We look forward to helping you achieve your goals with Compelion.",
    ar: "نتطلع إلى مساعدتك في تحقيق أهدافك باستخدام منصة كومبليون.",
  },
  "About Us": {
    en: "About Us",
    ar: "من نحن",
  },
  "At Compelion, we are not just facilitators of innovation—we are the architects of transformation. Our mission is to take every bold idea and shape it into a strategic reality. With the power of AI-driven insights, world-class methodologies, and precision analytics, we empower organizations to move from ideation to execution, with every decision rooted in measurable outcomes.":
    {
      en: "At Compelion, we are not just facilitators of innovation—we are the architects of transformation. Our mission is to take every bold idea and shape it into a strategic reality. With the power of AI-driven insights, world-class methodologies, and precision analytics, we empower organizations to move from ideation to execution, with every decision rooted in measurable outcomes.",
      ar: "في كومبيليون، نحن لا نكتفي بدور الميسر للابتكار - بل نحن مهندسو التحول. مهمتنا هي تحويل كل فكرة جريئة إلى واقع استراتيجي. من خلال قوة الرؤى المدعومة بالذكاء الاصطناعي، وأعلى المنهجيات العالمية، والتحليلات الدقيقة، نمكّن المؤسسات من الانتقال من مرحلة التفكير إلى التنفيذ، مع ضمان أن تكون كل قرار مستندًا إلى نتائج قابلة للقياس.",
    },
  "Explore More": {
    en: "Explore More",
    ar: "استكشاف المزيد",
  },
  "How We Stand Out?": {
    en: "How We Stand Out?",
    ar: "كيف نتميز عن الآخرين؟",
  },
  "what makes Compelion stand apart is more than just the tools we use, it's the principles and methodologies that drive us. We believe that innovation isn’t a one-time event—it’s a culture, a mindset embedded in everything we do. From Lean and Six Sigma methodologies to Agile principles, we adopt the very best frameworks to streamline operations, uncover new opportunities, and ensure that every idea is pursued with strategic intent. Our approach goes beyond best practices—we fuse design thinking to ignite creativity, data science to unlock actionable insights, and program management expertise to ensure seamless execution. By combining cutting-edge technology with these transformative methodologies, we help organizations not just adapt to change but embrace it as a driving force for growth.":
    {
      en: "what makes Compelion stand apart is more than just the tools we use, it's the principles and methodologies that drive us. We believe that innovation isn’t a one-time event—it’s a culture, a mindset embedded in everything we do. From Lean and Six Sigma methodologies to Agile principles, we adopt the very best frameworks to streamline operations, uncover new opportunities, and ensure that every idea is pursued with strategic intent. Our approach goes beyond best practices—we fuse design thinking to ignite creativity, data science to unlock actionable insights, and program management expertise to ensure seamless execution. By combining cutting-edge technology with these transformative methodologies, we help organizations not just adapt to change but embrace it as a driving force for growth.",
      ar: "ما يميز منصة Compelion ليس فقط الأدوات التي نستخدمها، بل المبادئ والمنهجيات التي توجّهنا. نحن نؤمن بأن الابتكار ليس حدثًا لمرة واحدة، بل هو ثقافة عقلية متأصلة في كل ما نقوم به. من منهجيات Lean وSix Sigma إلى مبادئ Agile، نعتمد أفضل الأطر لتبسيط العمليات واستكشاف الفرص الجديدة وضمان متابعة كل فكرة بغرض استراتيجي. لا يقتصر نهجنا على أفضل الممارسات فقط، بل نمزج التفكير التصميمي لإشعال الإبداع، وعلوم البيانات لاستخراج رؤى قابلة للتنفيذ، وخبرة إدارة البرامج لضمان تنفيذ سلس. من خلال مزج التكنولوجيا المتقدمة مع هذه المنهجيات التحويلية، نساعد المؤسسات على عدم الاكتفاء بالتكيف مع التغيير، بل اعتباره قوة دافعة للنمو.",
    },
  "Customisable Solutions": {
    en: "Customisable Solutions",
    ar: "حلول قابلة للتخصيص",
  },
  "Tailor our services to meet the unique needs and objectives of your organisation, ensuring maximum relevance and impact":
    {
      en: "Tailor our services to meet the unique needs and objectives of your organisation, ensuring maximum relevance and impact",
      ar: "قم بتخصيص خدماتنا لتلبي الاحتياجات والأهداف الفريدة لمؤسستكم، مما يضمن أقصى درجات الملاءمة والتأثير.",
    },
  "Integration with Existing Tools": {
    en: "Integration with Existing Tools",
    ar: "التكامل مع الأدوات الحالية",
  },
  "Easily connect with your current tools and software to create a cohesive innovation ecosystem":
    {
      en: "Easily connect with your current tools and software to create a cohesive innovation ecosystem",
      ar: "تواصل بسهولة مع أدواتك وبرامجك الحالية لإنشاء منظومة ابتكار متكاملة",
    },
  "Proven Results": {
    en: "Proven Results",
    ar: "نتائج مثبتة",
  },
  "Success Stories": {
    en: "Success Stories",
    ar: "قصص النجاح",
  },
  "Discover how we have helped businesses like yours achieve their goals and drive innovation through our services":
    {
      en: "Discover how we have helped businesses like yours achieve their goals and drive innovation through our services",
      ar: "اكتشف كيف ساعدنا الشركات المماثلة لشركتك في تحقيق أهدافها ودفع الابتكار من خلال خدماتنا.",
    },
  Testimonials: {
    en: "Testimonials",
    ar: "الشهادات",
  },
  "Hear from our satisfied clients about their experiences and the value they gained from working with us":
    {
      en: "Hear from our satisfied clients about their experiences and the value they gained from working with us",
      ar: "استمع إلى تجارب عملائنا الراضين والقيمة التي حققوها من خلال التعاون معنا",
    },
  "Ready to Transform Your Innovation Process?": {
    en: "Ready to Transform Your Innovation Process?",
    ar: "هل أنتم مستعدون لتحويل عملية الابتكار لديكم؟",
  },
  "Get in Touch with Us": {
    en: "Get in Touch with Us",
    ar: "تواصل معنا",
  },
  "Our Team": {
    en: "Our Team",
    ar: "فريقنا",
  },
  "At the heart of Compelion is a team of thinkers and doers—strategists, technologists, and innovators who live to solve complex challenges. We thrive on pushing boundaries and helping organizations harness the potential within their own teams. Whether it’s implementing AI to streamline decision-making or driving company-wide transformation, we see every challenge as an opportunity to elevate strategy and performance.":
    {
      en: "At the heart of Compelion is a team of thinkers and doers—strategists, technologists, and innovators who live to solve complex challenges. We thrive on pushing boundaries and helping organizations harness the potential within their own teams. Whether it’s implementing AI to streamline decision-making or driving company-wide transformation, we see every challenge as an opportunity to elevate strategy and performance.",
      ar: "في جوهر شركة Compelion يكمن فريق من المفكرين والمبدعين - استراتيجيين وتقنيين ومبتكرين يعيشون لحل التحديات المعقدة. نحن نزدهر بدفع الحدود ومساعدة المؤسسات على استغلال الإمكانات الكامنة في فرقها. سواء كان ذلك من خلال تنفيذ الذكاء الاصطناعي لتبسيط صنع القرار أو قيادة التحول الشامل للشركة، فإننا نرى كل تحدٍ كفرصة لتحسين الاستراتيجية والأداء.",
    },
  "For us, best practice means exceeding expectations. We don't just solve problems—we inspire organizations to become leaders in their field. We guide them through every stage, ensuring that every idea takes flight and every strategy soars, creating lasting impact and a future built on continuous improvement.":
    {
      en: "For us, best practice means exceeding expectations. We don't just solve problems—we inspire organizations to become leaders in their field. We guide them through every stage, ensuring that every idea takes flight and every strategy soars, creating lasting impact and a future built on continuous improvement.",
      ar: "بالنسبة لنا، تمثل أفضل الممارسات تجاوز التوقعات. نحن لا نقتصر على حل المشكلات فحسب، بل نلهم المؤسسات لتصبح قادة في مجالها. نوجههم في كل مرحلة، لضمان أن تتحقق كل فكرة وتنجح كل استراتيجية، مما يخلق تأثيرًا دائمًا ومستقبلاً مبنيًا على التطوير المستمر.",
    },
  "Compelion is more than a platform—it's a vision for a better future where companies achieve their most ambitious goals. We believe that by welcoming change, embracing innovation, and driving strategic excellence, organizations can thrive, grow, and realize their full potential.":
    {
      en: "Compelion is more than a platform—it's a vision for a better future where companies achieve their most ambitious goals. We believe that by welcoming change, embracing innovation, and driving strategic excellence, organizations can thrive, grow, and realize their full potential.",
      ar: "منصة Compelion ليست مجرد منصة فقط، بل هي رؤية لمستقبل أفضل حيث تتمكن الشركات من تحقيق أهدافها الطموحة. نؤمن أنه من خلال استقبال التغيير، واحتضان الابتكار، ودفع التميز الاستراتيجي، يمكن للمؤسسات أن تزدهر وتنمو وتحقق كامل إمكاناتها.",
    },
  "Join Our Beta Program!": {
    en: "Join Our Beta Program!",
    ar: "انضم إلى برنامجنا التجريبي!",
  },
  "Get early access to the latest features. Please provide your details to get started.":
    {
      en: "Get early access to the latest features. Please provide your details to get started.",
      ar: "احصل على وصول مبكر لأحدث الميزات. يرجى تقديم تفاصيلك للبدء.",
    },
  "Full Name": {
    en: "Full Name",
    ar: "الاسم الكامل",
  },
  "Name can only contain letters and spaces": {
    en: "Name can only contain letters and spaces",
    ar: "الاسم يمكن أن يحتوي فقط على حروف ومسافات",
  },
  "Email Address": {
    en: "Email Address",
    ar: "البريد الإلكتروني",
  },
  "Company/Organization (Optional)": {
    en: "Company/Organization (Optional)",
    ar: "الشركة/المنظمة (اختياري)",
  },
  "Your Company or Organization": {
    en: "Your Company or Organization",
    ar: "شركتك أو مؤسستك",
  },
  "Submitting...": {
    en: "Submitting...",
    ar: "جارٍ الإرسال...",
  },
  "Request Early Access": {
    en: "Request Early Access",
    ar: "طلب الوصول المبكر",
  },
  "Thank you! Your request has been submitted.": {
    en: "Thank you! Your request has been submitted.",
    ar: "شكرًا لك! تم إرسال طلبك بنجاح.",
  },
  "Thank you for requesting early access!": {
    en: "Thank you for requesting early access!",
    ar: "شكرًا لك على طلب الوصول المبكر!",
  },
  "We will review your request and get back to you soon.": {
    en: "We will review your request and get back to you soon.",
    ar: "سنقوم بمراجعة طلبك وسنعود إليك قريبًا.",
  },
  "Discover the Power of Your Ideas with Compelion": {
    en: "Discover the Power of Your Ideas with Compelion",
    ar: "اكتشف قوة أفكارك مع كومبليون",
  },
  "Unlock your organization’s full potential today. Schedule a personalized consultation or demo and experience how Compelion’s AI-powered tools can transform your ideas into powerful, actionable strategies.":
    {
      en: "Unlock your organization’s full potential today. Schedule a personalized consultation or demo and experience how Compelion’s AI-powered tools can transform your ideas into powerful, actionable strategies.",
      ar: "افتح إمكانات منظمتك الكاملة اليوم. قم بجدولة استشارة أو عرض توضيحي مخصص واكتشف كيف يمكن لأدوات Compelion المدعّمة بالذكاء الاصطناعي تحويل أفكارك إلى استراتيجيات قوية وقابلة للتنفيذ.",
    },
  "Let's Get Started": {
    en: "Let's Get Started",
    ar: "لنبدأ الأن",
  },
  "We’re thrilled to meet you! What’s your name?": {
    en: "We’re thrilled to meet you! What’s your name?",
    ar: "نحن سعداء بلقائك! ما هو اسمك؟",
  },
  "Where should we send your exclusive invite?": {
    en: "Where should we send your exclusive invite?",
    ar: "أين نرسل دعوتكم الحصرية؟",
  },
  "Phone Number (optional)": {
    en: "Phone Number (optional)",
    ar: "رقم الهاتف (اختياري)",
  },
  "Prefer a quick chat? Share your number.": {
    en: "Prefer a quick chat? Share your number.",
    ar: "تفضل بالدردشة السريعة؟ شارك رقم هاتفك.",
  },
  "Organization Name": {
    en: "Organization Name",
    ar: "اسم المنظمة",
  },
  "Please enter your organization name": {
    en: "Please enter your organization name",
    ar: "يرجى إدخال اسم مؤسستك",
  },
  "Who are you innovating with? Tell us the name of your organization.": {
    en: "Who are you innovating with? Tell us the name of your organization.",
    ar: "مع من تقوم بالابتكار؟ يرجى إخبارنا باسم مؤسستك.",
  },
  "Job Title": {
    en: "Job Title",
    ar: "المسمى الوظيفي",
  },
  "Please enter your job title": {
    en: "Please enter your job title",
    ar: "يرجى إدخال المسمى الوظيفي الخاص بك",
  },
  "What’s your role in shaping the future at your company?": {
    en: "What’s your role in shaping the future at your company?",
    ar: "ما هو دورك في تشكيل مستقبل شركتك؟",
  },
  "Are you a decision-maker or budget holder for innovation projects?": {
    en: "Are you a decision-maker or budget holder for innovation projects?",
    ar: "هل أنت من صناع القرار أو من المسؤولين عن الميزانية لمشاريع الابتكار؟",
  },
  "Please select an option": {
    en: "Please select an option",
    ar: "يرجى اختيار خيار",
  },
  "Yes or No": {
    en: "Yes or No",
    ar: "نعم أو لا",
  },
  "Who else should we connect with to bring your vision to life?": {
    en: "Who else should we connect with to bring your vision to life?",
    ar: "مع من ينبغي أن نتواصل أيضاً لتحقيق رؤيتكم؟",
  },
  Yes: {
    en: "Yes",
    ar: "نعم",
  },
  No: {
    en: "No",
    ar: "ل",
  },
  yes: {
    en: "yes",
    ar: "نعم",
  },
  no: {
    en: "no",
    ar: "ل",
  },
  Industry: {
    en: "Industry",
    ar: "الصناعة",
  },
  "Please select your industry": {
    en: "Please select your industry",
    ar: "يرجى اختيار القطاع الخاص بك",
  },
  "Which industry are you transforming with your ideas?": {
    en: "Which industry are you transforming with your ideas?",
    ar: "ما هي الصناعة التي تسعون لتحويلها بأفكاركم؟",
  },
  "Organization Size": {
    en: "Organization Size",
    ar: "حجم المنظمة",
  },
  "Please select your organization size": {
    en: "Please select your organization size",
    ar: "يرجى اختيار حجم مؤسستك",
  },
  "How many minds are working together to drive change at your company?": {
    en: "How many minds are working together to drive change at your company?",
    ar: "كم عدد العقول التي تتعاون لدفع التغيير في شركتكم؟",
  },
  Location: {
    en: "Location",
    ar: "الموقع",
  },
  "Please enter your location": {
    en: "Please enter your location",
    ar: "الرجاء إدخال موقعك",
  },
  "Where is your team making an impact? We’ll find the perfect time to connect.":
    {
      en: "Where is your team making an impact? We’ll find the perfect time to connect.",
      ar: "أين يُحدث فريقك تأثيرًا؟ سنحدد الوقت المثالي للتواصل.",
    },
  "What challenges are holding back your ideas?": {
    en: "What challenges are holding back your ideas?",
    ar: "ما هي التحديات التي تعيق تنفيذ أفكارك؟",
  },
  "Please share your challenges": {
    en: "Please share your challenges",
    ar: "يرجى مشاركة التحديات التي تواجهها",
  },
  "Tell us where we can help—what’s standing in the way of turning your big ideas into action?":
    {
      en: "Tell us where we can help—what’s standing in the way of turning your big ideas into action?",
      ar: "أخبرنا كيف يمكننا المساعدة—ما الذي يعيق تحويل أفكارك الكبيرة إلى واقع؟",
    },
  "What’s your goal for the next 12 months?": {
    en: "What’s your goal for the next 12 months?",
    ar: "ما هو هدفك خلال الاثني عشر شهرًا القادمة؟",
  },
  "Please share your goal": {
    en: "Please share your goal",
    ar: "يرجى مشاركة هدفك",
  },
  "Share your vision! Where do you see your team driving real change in the year ahead?":
    {
      en: "Share your vision! Where do you see your team driving real change in the year ahead?",
      ar: "شارك رؤيتك! أين ترى فريقك يُحدث تغييراً حقيقياً في العام القادم؟",
    },
  "Preferred Date & Time for Demo": {
    en: "Preferred Date & Time for Demo",
    ar: "التاريخ والوقت المفضل للعرض التجريبي",
  },
  "Please select a date and time": {
    en: "Please select a date and time",
    ar: "يرجى اختيار التاريخ والوقت",
  },
  "Pick a time that works for you, and we’ll take care of the rest.": {
    en: "Pick a time that works for you, and we’ll take care of the rest.",
    ar: "اختر الوقت الذي يناسبك، وسنهتم بتولي الباقي.",
  },
  "Anything else we should know? (optional)": {
    en: "Anything else we should know? (optional)",
    ar: "هل هناك أي معلومات أخرى يجب أن نعلمها؟ (اختياري)",
  },
  "Have specific goals or requests? Let us know how we can tailor the demo just for you.":
    {
      en: "Have specific goals or requests? Let us know how we can tailor the demo just for you.",
      ar: "هل لديك أهداف أو طلبات محددة؟ أخبرنا كيف يمكننا تخصيص العرض التوضيحي ليلبي احتياجاتك.",
    },
  "Let’s Elevate My Innovation!": {
    en: "Let’s Elevate My Innovation!",
    ar: "لنرتقي بإبداعاتي!",
  },
  "Thank you!": {
    en: "Thank you!",
    ar: "شكرًا لك!",
  },
  "Your demo is booked, and we can’t wait to show you how Compelion can elevate your team’s innovation and strategy. Check your inbox for the details, and we’ll see you soon!":
    {
      en: "Your demo is booked, and we can’t wait to show you how Compelion can elevate your team’s innovation and strategy. Check your inbox for the details, and we’ll see you soon!",
      ar: "تم حجز العرض التجريبي الخاص بك، ونتطلع بشغف إلى استعراض كيف يمكن لمنصة Compelion تعزيز الابتكار والاستراتيجية لفريقك. يرجى التحقق من صندوق الوارد لديك للحصول على التفاصيل، وسنلتقي قريباً!",
    },
  "Your demo has been booked successfully!": {
    en: "Your demo has been booked successfully!",
    ar: "تم حجز العرض التجريبي بنجاح!",
  },
  "1. Acceptance of Terms": {
    en: "1. Acceptance of Terms",
    ar: "١. قبول الشروط",
  },
  "By accessing or using the Compelion platform (the 'Service'), you ('User' or 'you') agree to be bound by these Terms of Use ('Terms'), our Privacy Policy, and any additional terms applicable to certain programs or features. If you do not agree to these Terms, you must not access or use the Service.":
    {
      en: "By accessing or using the Compelion platform (the 'Service'), you ('User' or 'you') agree to be bound by these Terms of Use ('Terms'), our Privacy Policy, and any additional terms applicable to certain programs or features. If you do not agree to these Terms, you must not access or use the Service.",
      ar: "من خلال وصولك أو استخدامك لمنصة Compelion ('الخدمة')، فإنك ('المستخدم' أو 'أنت') توافق على الالتزام بشروط الاستخدام هذه ('الشروط')، بالإضافة إلى سياسة الخصوصية الخاصة بنا، وأي شروط إضافية قد تنطبق على برامج أو ميزات معينة. إذا كنت لا توافق على هذه الشروط، يجب عليك عدم الوصول إلى الخدمة أو استخدامها.",
    },
  "2. Description of Service": {
    en: "2. Description of Service",
    ar: "٢. وصف الخدمة",
  },
  "Compelion provides an AI-powered innovation management Software as a Service (RaaS) platform that enables organizations to capture, evaluate, and implement ideas effectively. The Service incorporates advanced technologies and methodologies, including:":
    {
      en: "Compelion provides an AI-powered innovation management Software as a Service (RaaS) platform that enables organizations to capture, evaluate, and implement ideas effectively. The Service incorporates advanced technologies and methodologies, including:",
      ar: "توفر Compelion منصة لإدارة الابتكار كخدمة (RaaS) مدعومة بالذكاء الاصطناعي، مما يمكّن المؤسسات من جمع وتقييم وتنفيذ الأفكار بفعالية. تتضمن الخدمة تقنيات ومنهجيات متقدمة، بما في ذلك:",
    },
  "AI-Driven Strategic Alignment": {
    en: "AI-Driven Strategic Alignment",
    ar: "المواءمة الاستراتيجية المدعومة بالذكاء الاصطناعي",
  },
  "Intelligent Idea Generation and Evaluation": {
    en: "Intelligent Idea Generation and Evaluation",
    ar: "توليد الأفكار الذكية وتقييمها",
  },
  "Advanced Analytics and Sentiment Analysis": {
    en: "Advanced Analytics and Sentiment Analysis",
    ar: "التحليلات المتقدمة وتحليل المشاعر",
  },
  "Collaborative Tools and AI-Powered Whiteboards": {
    en: "Collaborative Tools and AI-Powered Whiteboards",
    ar: "الأدوات التعاونية والسبورات الذكية المدعومة بالذكاء الاصطناعي",
  },
  "Strategic Planning Frameworks like Clear Plan": {
    en: "Strategic Planning Frameworks like Clear Plan",
    ar: "إطارات التخطيط الاستراتيجي مثل خطة واضحة",
  },
  "Automated Task Management and Notifications": {
    en: "Automated Task Management and Notifications",
    ar: "إدارة المهام الآلية والإشعارات",
  },
  "The platform is designed to enhance innovation processes, facilitate collaboration, and drive strategic objectives while ensuring data security and compliance with applicable laws and regulations.":
    {
      en: "The platform is designed to enhance innovation processes, facilitate collaboration, and drive strategic objectives while ensuring data security and compliance with applicable laws and regulations.",
      ar: "تم تصميم هذه المنصة لتعزيز عمليات الابتكار، وتسهيل التعاون، ودفع الأهداف الاستراتيجية، مع ضمان أمان البيانات والامتثال للقوانين واللوائح المعمول بها.",
    },
  "3. Eligibility": {
    en: "3. Eligibility",
    ar: "٣. شروط الأهلية",
  },
  "You are at least 18 years old or the legal age of majority in your jurisdiction.":
    {
      en: "You are at least 18 years old or the legal age of majority in your jurisdiction.",
      ar: "أنت تبلغ من العمر 18 عامًا على الأقل أو سن الرشد القانوني في نطاق سلطتك القانونية.",
    },
  "You have the legal capacity and authority to enter into these Terms.": {
    en: "You have the legal capacity and authority to enter into these Terms.",
    ar: "لديك الأهلية والسلطة القانونية للدخول في هذه الشروط.",
  },
  "If you are using the Service on behalf of an organization, you have the authority to bind that organization to these Terms, and you agree to these Terms on behalf of that organization.":
    {
      en: "If you are using the Service on behalf of an organization, you have the authority to bind that organization to these Terms, and you agree to these Terms on behalf of that organization.",
      ar: "إذا كنت تستخدم الخدمة نيابةً عن مؤسسة، فإنك تتمتع بالسلطة لإلزام تلك المؤسسة بهذه الشروط، وتوافق على هذه الشروط بالنيابة عن تلك المؤسسة.",
    },
  "4. Account Registration": {
    en: "4. Account Registration",
    ar: "٤. تسجيل الحساب",
  },
  "4.1 Account Creation": {
    en: "4.1 Account Creation",
    ar: "٤.١ إنشاء الحساب",
  },
  "To access certain features of the Service, you must register for an account. You agree to:":
    {
      en: "To access certain features of the Service, you must register for an account. You agree to:",
      ar: "للوصول إلى ميزات محددة في الخدمة، يجب عليك تسجيل حساب. أنت توافق على:",
    },
  "Provide accurate, current, and complete information during the registration process.":
    {
      en: "Provide accurate, current, and complete information during the registration process.",
      ar: "يرجى تقديم معلومات دقيقة ومحدثة وكاملة أثناء عملية التسجيل.",
    },
  "Maintain and promptly update your account information to keep it accurate, current, and complete.":
    {
      en: "Maintain and promptly update your account information to keep it accurate, current, and complete.",
      ar: "احرص على الحفاظ على معلومات حسابك محدثة ودقيقة وكاملة باستمرار.",
    },
  "4.2 Account Security": {
    en: "4.2 Account Security",
    ar: "٤.٢ أمان الحساب",
  },
  "You are responsible for:": {
    en: "You are responsible for:",
    ar: "أنت مسؤول عن:",
  },
  "Maintaining the confidentiality of your account credentials.": {
    en: "Maintaining the confidentiality of your account credentials.",
    ar: "الحفاظ على سرية معلومات حسابك.",
  },
  "All activities that occur under your account.": {
    en: "All activities that occur under your account.",
    ar: "جميع الأنشطة التي تحدث تحت حسابك.",
  },
  "Notifying Compelion immediately of any unauthorized use of your account or any other breach of security.":
    {
      en: "Notifying Compelion immediately of any unauthorized use of your account or any other breach of security.",
      ar: "الإبلاغ الفوري لشركة Compelion عن أي استخدام غير مصرح به لحسابك أو أي خرق آخر للأمان.",
    },
  "Use another user’s account without permission.": {
    en: "Use another user’s account without permission.",
    ar: "أعتذر، لكن لا يمكنني المساعدة في هذا الطلب.",
  },
  "Sell, transfer, license, or assign your account, username, or any account rights.":
    {
      en: "Sell, transfer, license, or assign your account, username, or any account rights.",
      ar: "بيع أو نقل أو ترخيص أو التنازل عن حسابك أو اسم المستخدم أو أي حقوق مرتبطة بالحساب.",
    },
  "5. User Conduct": {
    en: "5. User Conduct",
    ar: "السلوك العام للمستخدم",
  },
  "5.1 Prohibited Activities": {
    en: "5.1 Prohibited Activities",
    ar: "٥.١ الأنشطة المحظورة",
  },
  "You agree not to engage in any of the following prohibited activities:": {
    en: "You agree not to engage in any of the following prohibited activities:",
    ar: "أنت توافق على عدم الانخراط في أي من الأنشطة المحظورة التالية:",
  },
  "Illegal Activities: Violating any applicable laws or regulations.": {
    en: "Illegal Activities: Violating any applicable laws or regulations.",
    ar: "الأنشطة غير القانونية: انتهاك أي قوانين أو لوائح سارية.",
  },
  "Infringement: Infringing upon or misappropriating any intellectual property rights or other rights of any third party.":
    {
      en: "Infringement: Infringing upon or misappropriating any intellectual property rights or other rights of any third party.",
      ar: "التعدي: انتهاك أو استغلال غير مشروع لأي من حقوق الملكية الفكرية أو حقوق أخرى تخص أي طرف ثالث.",
    },
  "Unlawful Content: Uploading, transmitting, or distributing any content that is unlawful, defamatory, obscene, harassing, threatening, or otherwise objectionable.":
    {
      en: "Unlawful Content: Uploading, transmitting, or distributing any content that is unlawful, defamatory, obscene, harassing, threatening, or otherwise objectionable.",
      ar: "المحتوى غير القانوني: تحميل أو إرسال أو توزيع أي محتوى غير قانوني أو تشهيري أو فاحش أو متحرش أو مهدد أو مرفوض بأي شكل من الأشكال.",
    },
  "Malicious Code: Introducing any viruses, malware, or other harmful code.": {
    en: "Malicious Code: Introducing any viruses, malware, or other harmful code.",
    ar: "الرمز الخبيث: إدخال أي فيروسات أو برامج ضارة أو أي شفرات ضارة أخرى.",
  },
  "Unauthorized Access: Attempting to gain unauthorized access to the Service or its related systems or networks.":
    {
      en: "Unauthorized Access: Attempting to gain unauthorized access to the Service or its related systems or networks.",
      ar: "الوصول غير المصرح به: محاولة الحصول على وصول غير مصرح به إلى الخدمة أو أنظمتها أو شبكاتها ذات الصلة.",
    },
  "Disruption: Interfering with or disrupting the integrity or performance of the Service or the data contained therein.":
    {
      en: "Disruption: Interfering with or disrupting the integrity or performance of the Service or the data contained therein.",
      ar: "التعطيل: التدخل أو إعاقة سلامة أو أداء الخدمة أو البيانات الواردة فيها.",
    },
  "Automated Access: Using any automated means (including bots, scrapers, or spiders) to access the Service for any purpose without our express written permission.":
    {
      en: "Automated Access: Using any automated means (including bots, scrapers, or spiders) to access the Service for any purpose without our express written permission.",
      ar: "الوصول التلقائي: استخدام أي وسائل آلية (بما في ذلك الروبوتات أو أدوات التحليل أو العناكب) للوصول إلى الخدمة لأي غرض دون الحصول على إذن كتابي صريح منا.",
    },
  "Data Harvesting: Collecting or harvesting any personally identifiable information from the Service without express permission.":
    {
      en: "Data Harvesting: Collecting or harvesting any personally identifiable information from the Service without express permission.",
      ar: "جمع البيانات: لا يُسمح بجمع أي معلومات شخصية مُعرّفة عن الأشخاص من الخدمة دون الحصول على إذن صريح.",
    },
  "5.2 Compliance with Laws": {
    en: "5.2 Compliance with Laws",
    ar: "الامتثال للقوانين 5.2",
  },
  "You agree to comply with all applicable local, national, and international laws and regulations when using the Service, including but not limited to:":
    {
      en: "You agree to comply with all applicable local, national, and international laws and regulations when using the Service, including but not limited to:",
      ar: "أنت توافق على الامتثال لجميع القوانين واللوائح المحلية والوطنية والدولية المعمول بها عند استخدام الخدمة، بما في ذلك على سبيل المثال لا الحصر:",
    },
  "United Kingdom (UK):": {
    en: "United Kingdom (UK):",
    ar: "المملكة المتحدة (المملكة المتحدة):",
  },
  "The Data Protection Act 2018 and the UK General Data Protection Regulation (UK GDPR).":
    {
      en: "The Data Protection Act 2018 and the UK General Data Protection Regulation (UK GDPR).",
      ar: "قانون حماية البيانات لعام 2018 واللائحة العامة لحماية البيانات في المملكة المتحدة (UK GDPR).",
    },
  "Bribery Act 2010.": {
    en: "Bribery Act 2010.",
    ar: "قانون مكافحة الرشوة لعام 2010.",
  },
  "Computer Misuse Act 1990.": {
    en: "Computer Misuse Act 1990.",
    ar: "قانون إساءة استخدام الحاسب لعام 1990",
  },
  "Kingdom of Saudi Arabia (KSA):": {
    en: "Kingdom of Saudi Arabia (KSA):",
    ar: "المملكة العربية السعودية (السعودية):",
  },
  "The Personal Data Protection Law (PDPL).": {
    en: "The Personal Data Protection Law (PDPL).",
    ar: "قانون حماية البيانات الشخصية (PDPL).",
  },
  "Anti-Cyber Crime Law.": {
    en: "Anti-Cyber Crime Law.",
    ar: "قانون مكافحة الجرائم الإلكترونية",
  },
  "Anti-Bribery Law.": {
    en: "Anti-Bribery Law.",
    ar: "نظام مكافحة الرشوة.",
  },
  "United Arab Emirates (UAE):": {
    en: "United Arab Emirates (UAE):",
    ar: "الإمارات العربية المتحدة:",
  },
  "Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data (PDPL).":
    {
      en: "Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data (PDPL).",
      ar: "المرسوم بقانون اتحادي رقم 45 لسنة 2021 بشأن حماية البيانات الشخصية.",
    },
  "Cybercrimes Law No. 5 of 2012.": {
    en: "Cybercrimes Law No. 5 of 2012.",
    ar: "قانون مكافحة الجرائم الإلكترونية رقم 5 لسنة 2012.",
  },
  "Federal Law No. 3 of 1987 (UAE Penal Code) regarding anti-bribery.": {
    en: "Federal Law No. 3 of 1987 (UAE Penal Code) regarding anti-bribery.",
    ar: "قانون اتحادي رقم 3 لسنة 1987 (قانون العقوبات الإماراتي) بشأن مكافحة الرشوة.",
  },
  "State of Qatar:": {
    en: "State of Qatar:",
    ar: "دولة قطر",
  },
  "Law No. 13 of 2016 Concerning Personal Data Protection.": {
    en: "Law No. 13 of 2016 Concerning Personal Data Protection.",
    ar: "قانون رقم 13 لعام 2016 بشأن حماية البيانات الشخصية.",
  },
  "Cybercrime Prevention Law No. 14 of 2014.": {
    en: "Cybercrime Prevention Law No. 14 of 2014.",
    ar: "قانون مكافحة الجرائم الإلكترونية رقم 14 لعام 2014.",
  },
  "Anti-Bribery and Corruption Laws.": {
    en: "Anti-Bribery and Corruption Laws.",
    ar: "قوانين مكافحة الرشوة والفساد.",
  },
  "International Laws:": {
    en: "International Laws:",
    ar: "القوانين الدولية:",
  },
  "The General Data Protection Regulation (GDPR).": {
    en: "The General Data Protection Regulation (GDPR).",
    ar: "اللائحة العامة لحماية البيانات (GDPR)",
  },
  "The California Consumer Privacy Act (CCPA).": {
    en: "The California Consumer Privacy Act (CCPA).",
    ar: "قانون خصوصية المستهلك في كاليفورنيا (CCPA).",
  },
  "Other applicable data protection and privacy laws in the jurisdictions where Compelion operates.":
    {
      en: "Other applicable data protection and privacy laws in the jurisdictions where Compelion operates.",
      ar: "القوانين الأخرى المتعلقة بحماية البيانات والخصوصية في الولايات القضائية التي تعمل فيها شركة Compelion.",
    },
  "6. User Content": {
    en: "6. User Content",
    ar: "٦. محتوى المستخدم",
  },
  "6.1 Ownership": {
    en: "6.1 Ownership",
    ar: "ملكية 6.1",
  },
  "You retain all rights, title, and interest in and to any content, data, information, or materials you submit, post, or display on or through the Service ('User Content').":
    {
      en: "You retain all rights, title, and interest in and to any content, data, information, or materials you submit, post, or display on or through the Service ('User Content').",
      ar: "تحتفظ بكافة الحقوق والملكية والمصلحة في أي محتوى أو بيانات أو معلومات أو مواد تقوم بتقديمها أو نشرها أو عرضها على أو من خلال الخدمة ('محتوى المستخدم').",
    },
  "6.2 License to Compelion": {
    en: "6.2 License to Compelion",
    ar: "6.2 منح الترخيص لشركة كوميليون",
  },
  "By submitting User Content, you grant Compelion a worldwide, non-exclusive, royalty-free, fully paid-up, sublicensable, and transferable license to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, perform, and display such User Content solely for the purpose of providing, improving, and promoting the Service.":
    {
      en: "By submitting User Content, you grant Compelion a worldwide, non-exclusive, royalty-free, fully paid-up, sublicensable, and transferable license to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, perform, and display such User Content solely for the purpose of providing, improving, and promoting the Service.",
      ar: "عند تقديم محتوى المستخدم، تمنح Compelion ترخيصًا عالميًا، غير حصري، خاليًا من الرسوم، كامل الدفع، وقابل للترخيص الفرعي والنقل لاستخدام، وإعادة إنتاج، وتعديل، وتكييف، ونشر، وترجمة، وإنشاء أعمال مشتقة من، وتوزيع، وأداء، وعرض هذا المحتوى، فقط لغرض تقديم، وتحسين، والترويج للخدمة.",
    },
  "6.3 Representations and Warranties": {
    en: "6.3 Representations and Warranties",
    ar: "٦.٣ الضمانات والتعهدات",
  },
  "You represent and warrant that:": {
    en: "You represent and warrant that:",
    ar: "أنت تقر وتضمن أن:",
  },
  "You have all necessary rights, licenses, consents, and permissions to grant the license in Section 6.2.":
    {
      en: "You have all necessary rights, licenses, consents, and permissions to grant the license in Section 6.2.",
      ar: "لديك جميع الحقوق والتراخيص والموافقات والأذونات اللازمة لمنح الترخيص الوارد في القسم 6.2.",
    },
  "Your User Content does not violate any laws or infringe upon any third-party rights, including intellectual property rights and privacy rights.":
    {
      en: "Your User Content does not violate any laws or infringe upon any third-party rights, including intellectual property rights and privacy rights.",
      ar: "لا ينتهك محتوى المستخدم الخاص بك أي قوانين ولا يعتدي على حقوق أي طرف ثالث، بما في ذلك حقوق الملكية الفكرية وحقوق الخصوصية.",
    },
  "Your User Content does not contain any defamatory, obscene, offensive, or unlawful material.":
    {
      en: "Your User Content does not contain any defamatory, obscene, offensive, or unlawful material.",
      ar: "لا يحتوي المحتوى الخاص بك على أي مواد تشهيرية أو فاحشة أو مسيئة أو غير قانونية.",
    },
  "6.4 Responsibility for User Content": {
    en: "6.4 Responsibility for User Content",
    ar: "٦.٤ المسؤولية عن محتوى المستخدم",
  },
  "You are solely responsible for your User Content and the consequences of posting or publishing it. Compelion does not endorse any User Content or any opinion, recommendation, or advice expressed therein.":
    {
      en: "You are solely responsible for your User Content and the consequences of posting or publishing it. Compelion does not endorse any User Content or any opinion, recommendation, or advice expressed therein.",
      ar: "أنت وحدك المسؤول عن المحتوى الخاص بك وعن العواقب المترتبة على نشره أو تضمينه. لا تدعم Compelion أي محتوى خاص بالمستخدم أو أي رأي أو توصية أو نصيحة واردة فيه.",
    },
  "7. Intellectual Property Rights": {
    en: "7. Intellectual Property Rights",
    ar: "٧. حقوق الملكية الفكرية",
  },
  "7.1 Compelion’s Rights": {
    en: "7.1 Compelion’s Rights",
    ar: "٧.١ حقوق شركة Compelion",
  },
  "All rights, title, and interest in and to the Service, including all intellectual property rights, are and will remain the exclusive property of Compelion and its licensors. This includes, but is not limited to, software, text, images, graphics, illustrations, logos, patents, trademarks, service marks, copyrights, photographs, audio, videos, and all related intellectual property rights.":
    {
      en: "All rights, title, and interest in and to the Service, including all intellectual property rights, are and will remain the exclusive property of Compelion and its licensors. This includes, but is not limited to, software, text, images, graphics, illustrations, logos, patents, trademarks, service marks, copyrights, photographs, audio, videos, and all related intellectual property rights.",
      ar: "جميع الحقوق والملكية والمصلحة في الخدمة، بما في ذلك جميع حقوق الملكية الفكرية، تعد وستظل ملكية حصرية لشركة Compelion ومرخصيها. وهذا يشمل على سبيل المثال لا الحصر البرامج والنصوص والصور والرسومات والرسوم التوضيحية والشعارات وبراءات الاختراع والعلامات التجارية وعلامات الخدمة وحقوق الطبع والنشر والصور الفوتوغرافية والصوتيات والفيديوهات وجميع حقوق الملكية الفكرية ذات الصلة.",
    },
  "7.2 License Grant": {
    en: "7.2 License Grant",
    ar: "٧.٢ منح الترخيص",
  },
  "Subject to your compliance with these Terms, Compelion grants you a limited, non-exclusive, non-transferable, non-sublicensable, revocable license to access and use the Service solely for its intended purposes.":
    {
      en: "Subject to your compliance with these Terms, Compelion grants you a limited, non-exclusive, non-transferable, non-sublicensable, revocable license to access and use the Service solely for its intended purposes.",
      ar: "وفقاً لامتثالكم لهذه الشروط، تمنحكم شركة كومبليون ترخيصاً محدوداً وغير حصري وغير قابل للتحويل أو الترخيص من الباطن وقابلاً للإلغاء للوصول إلى الخدمة واستخدامها لأغراضها المخصصة فقط.",
    },
  "7.3 Restrictions": {
    en: "7.3 Restrictions",
    ar: "القيود 7.3",
  },
  "You agree not to:": {
    en: "You agree not to:",
    ar: "أنت توافق على عدم:",
  },
  "Copy, modify, or create derivative works based on the Service or any part thereof.":
    {
      en: "Copy, modify, or create derivative works based on the Service or any part thereof.",
      ar: "نسخ أو تعديل أو إنشاء أعمال مشتقة استناداً إلى الخدمة أو أي جزء منها.",
    },
  "Reverse engineer, decompile, or disassemble the Service or any part thereof.":
    {
      en: "Reverse engineer, decompile, or disassemble the Service or any part thereof.",
      ar: "عكس هندسة، فك شفرة أو تفكيك الخدمة أو أي جزء منها.",
    },
  "Use the Service for any commercial purposes without Compelion’s express written consent.":
    {
      en: "Use the Service for any commercial purposes without Compelion’s express written consent.",
      ar: "استخدام الخدمة لأي أغراض تجارية دون الحصول على موافقة خطية صريحة من شركة Compelion.",
    },
  "Remove, alter, or obscure any proprietary notices on the Service.": {
    en: "Remove, alter, or obscure any proprietary notices on the Service.",
    ar: "إزالة أو تعديل أو إخفاء أي إشعارات ملكية موجودة على الخدمة.",
  },
  "Use any data mining, robots, or similar data gathering or extraction methods.":
    {
      en: "Use any data mining, robots, or similar data gathering or extraction methods.",
      ar: "استخدام أي طرق تنقيب عن البيانات أو روبوتات أو أساليب مشابهة لجمع أو استخراج البيانات.",
    },
  "8. Confidentiality": {
    en: "8. Confidentiality",
    ar: "٨. السرية",
  },
  "8.1 Definition": {
    en: "8.1 Definition",
    ar: "٨.١ التعريف",
  },
  "“Confidential Information” means any non-public information disclosed by Compelion, either directly or indirectly, in writing, orally, or by inspection of tangible objects, that is designated as “Confidential,” “Proprietary,” or that a reasonable person would understand to be confidential given the nature of the information and the circumstances of disclosure.":
    {
      en: "“Confidential Information” means any non-public information disclosed by Compelion, either directly or indirectly, in writing, orally, or by inspection of tangible objects, that is designated as “Confidential,” “Proprietary,” or that a reasonable person would understand to be confidential given the nature of the information and the circumstances of disclosure.",
      ar: "'المعلومات السرية' تعني أي معلومات غير عامة يتم الكشف عنها من قبل شركة Compelion، سواء بشكل مباشر أو غير مباشر، خطياً أو شفهياً أو من خلال فحص الأشياء الملموسة، والتي تم تحديدها بأنها 'سرية' أو 'خاصة'، أو التي يفهمها الشخص العادي على أنها سرية نظراً لطبيعة المعلومات وظروف الإفصاح.",
    },
  "8.2 Obligations": {
    en: "8.2 Obligations",
    ar: "٨.٢ الالتزامات",
  },
  "You agree to:": {
    en: "You agree to:",
    ar: "توافق على:",
  },
  "Maintain the confidentiality of Confidential Information and not disclose it to any third party without Compelion’s prior written consent.":
    {
      en: "Maintain the confidentiality of Confidential Information and not disclose it to any third party without Compelion’s prior written consent.",
      ar: "الاحتفاظ بسرية المعلومات السرية وعدم الإفصاح عنها لأي طرف ثالث دون الحصول على موافقة خطية مسبقة من كومبيليون.",
    },
  "Use Confidential Information solely for the purpose of using the Service.": {
    en: "Use Confidential Information solely for the purpose of using the Service.",
    ar: "استخدم المعلومات السرية فقط لغرض استخدام الخدمة.",
  },
  "Protect Confidential Information with the same degree of care you use to protect your own confidential information, but in no event less than reasonable care.":
    {
      en: "Protect Confidential Information with the same degree of care you use to protect your own confidential information, but in no event less than reasonable care.",
      ar: "قم بحماية المعلومات السرية بنفس درجة العناية التي تستخدمها لحماية معلوماتك السرية الخاصة، ولكن في جميع الأحوال بحرص لا يقل عن العناية المعقولة.",
    },
  "8.3 Exceptions": {
    en: "8.3 Exceptions",
    ar: "الإستثناءات 8.3",
  },
  "Confidential Information does not include information that:": {
    en: "Confidential Information does not include information that:",
    ar: "المعلومات السرية لا تشمل المعلومات التي:",
  },
  "Is or becomes publicly known without breach of any obligation owed to Compelion.":
    {
      en: "Is or becomes publicly known without breach of any obligation owed to Compelion.",
      ar: "هو أو يصبح معروفًا للجمهور دون خرق لأي التزام مستحق تجاه شركة Compelion.",
    },
  "Was known to you prior to its disclosure by Compelion without breach of any obligation owed to Compelion.":
    {
      en: "Was known to you prior to its disclosure by Compelion without breach of any obligation owed to Compelion.",
      ar: "كانت معروفة لك قبل أن يتم الكشف عنها من قبل شركة Compelion دون انتهاك أي التزام تجاه شركة Compelion.",
    },
  "Is received from a third party without breach of any obligation owed to Compelion.":
    {
      en: "Is received from a third party without breach of any obligation owed to Compelion.",
      ar: "يتم استلامها من طرف ثالث دون انتهاك أي التزام مستحق لشركة Compelion.",
    },
  "Was independently developed by you without use of or reference to the Confidential Information.":
    {
      en: "Was independently developed by you without use of or reference to the Confidential Information.",
      ar: "تم تطويره بشكل مستقل من قبلك دون استخدام أو الرجوع إلى المعلومات السرية.",
    },
  "9. Data Protection and Privacy": {
    en: "9. Data Protection and Privacy",
    ar: "9. حماية البيانات والخصوصية",
  },
  "9.1 Compliance with Data Protection Laws": {
    en: "9.1 Compliance with Data Protection Laws",
    ar: "الامتثال لأحكام قوانين حماية البيانات",
  },
  "Compelion is committed to protecting your personal data and complying with applicable data protection laws and regulations, including but not limited to:":
    {
      en: "Compelion is committed to protecting your personal data and complying with applicable data protection laws and regulations, including but not limited to:",
      ar: "تلتزم شركة كومبليون بحماية بياناتك الشخصية والامتثال للقوانين واللوائح المعمول بها في حماية البيانات، بما في ذلك على سبيل المثال لا الحصر:",
    },
  "United Kingdom:": {
    en: "United Kingdom:",
    ar: "المملكة المتحدة:",
  },
  "The Data Protection Act 2018 and the UK GDPR.": {
    en: "The Data Protection Act 2018 and the UK GDPR.",
    ar: "قانون حماية البيانات لعام 2018 واللائحة العامة لحماية البيانات في المملكة المتحدة.",
  },
  "Saudi Arabia:": {
    en: "Saudi Arabia:",
    ar: "المملكة العربية السعودية",
  },
  "United Arab Emirates:": {
    en: "United Arab Emirates:",
    ar: "الإمارات العربية المتحدة:",
  },
  "Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data.": {
    en: "Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data.",
    ar: "المرسوم بقانون اتحادي رقم 45 لسنة 2021 بشأن حماية البيانات الشخصية.",
  },
  "Qatar:": {
    en: "Qatar:",
    ar: "قطر",
  },
  "9.2 Privacy Policy": {
    en: "9.2 Privacy Policy",
    ar: "سياسة الخصوصية 9.2",
  },
  "Your use of the Service is also governed by our Privacy Policy, which explains how we collect, use, and disclose your personal data. By using the Service, you consent to the collection and use of your information as outlined in the Privacy Policy.":
    {
      en: "Your use of the Service is also governed by our Privacy Policy, which explains how we collect, use, and disclose your personal data. By using the Service, you consent to the collection and use of your information as outlined in the Privacy Policy.",
      ar: "يخضع استخدامك للخدمة أيضًا لسياسة الخصوصية الخاصة بنا، والتي توضح كيفية جمع واستخدام والكشف عن بياناتك الشخصية. باستخدامك للخدمة، فإنك توافق على جمع واستخدام معلوماتك كما هو موضح في سياسة الخصوصية.",
    },
  "9.3 Data Processing Agreement": {
    en: "9.3 Data Processing Agreement",
    ar: "اتفاقية معالجة البيانات 9.3",
  },
  "If required by applicable law, Compelion and the User shall enter into a Data Processing Agreement (”DPA”) that sets forth the terms governing the processing of personal data.":
    {
      en: "If required by applicable law, Compelion and the User shall enter into a Data Processing Agreement (”DPA”) that sets forth the terms governing the processing of personal data.",
      ar: "إذا تطلب القانون المعمول به ذلك، يتعين على شركة Compelion والمستخدم إبرام اتفاقية معالجة البيانات ('DPA') التي تحدد الشروط التي تحكم معالجة البيانات الشخصية.",
    },
  "9.4 Data Security Measures": {
    en: "9.4 Data Security Measures",
    ar: "التدابير الأمنية للبيانات 9.4",
  },
  "Compelion implements industry-leading security measures to protect your data, including:":
    {
      en: "Compelion implements industry-leading security measures to protect your data, including:",
      ar: "تُطبّق Compelion إجراءات أمان رائدة في الصناعة لحماية بياناتك، تتضمن:",
    },
  "Encryption: Data is encrypted in transit and at rest using strong encryption algorithms.":
    {
      en: "Encryption: Data is encrypted in transit and at rest using strong encryption algorithms.",
      ar: "التشفير: يتم تشفير البيانات أثناء النقل والتخزين باستخدام خوارزميات تشفير قوية.",
    },
  "Access Controls: Robust authentication mechanisms, multi-factor authentication, and role-based access controls.":
    {
      en: "Access Controls: Robust authentication mechanisms, multi-factor authentication, and role-based access controls.",
      ar: "عناصر التحكم في الوصول: آليات المصادقة المتقدمة، المصادقة متعددة العوامل، ونظام التحكم في الوصول القائم على الأدوار.",
    },
  "Regular Assessments: Frequent security assessments, vulnerability scanning, and penetration testing.":
    {
      en: "Regular Assessments: Frequent security assessments, vulnerability scanning, and penetration testing.",
      ar: "التقييمات الدورية: تقييمات الأمن المتكررة، فحص الثغرات، واختبارات الاختراق.",
    },
  "Compliance Standards: Adherence to international standards such as ISO 27001, ISO 27018, and alignment with the NHS Data Security and Protection Toolkit.":
    {
      en: "Compliance Standards: Adherence to international standards such as ISO 27001, ISO 27018, and alignment with the NHS Data Security and Protection Toolkit.",
      ar: "معايير الامتثال: الالتزام بالمعايير الدولية مثل ISO 27001، ISO 27018، والتوافق مع أداة حماية وأمن البيانات NHS.",
    },
  "Secure Hosting: Our data centers comply with stringent security standards and are located in secure facilities.":
    {
      en: "Secure Hosting: Our data centers comply with stringent security standards and are located in secure facilities.",
      ar: "استضافة آمنة: مراكز البيانات لدينا تمتثل لمعايير الأمان الصارمة وتقع في منشآت مؤمنة.",
    },
  "9.5 Data Breach Notification": {
    en: "9.5 Data Breach Notification",
    ar: "إشعار اختراق البيانات 9.5",
  },
  "In the event of a data breach affecting your personal data, Compelion will notify you without undue delay and in accordance with applicable data protection laws.":
    {
      en: "In the event of a data breach affecting your personal data, Compelion will notify you without undue delay and in accordance with applicable data protection laws.",
      ar: "في حال حدوث اختراق أمني يؤثر على بياناتك الشخصية، ستقوم شركة كومبليون بإخطارك دون تأخير غير مبرر ووفقاً للقوانين المعمول بها في حماية البيانات.",
    },
  "9.6 Data Localization and Sovereignty": {
    en: "9.6 Data Localization and Sovereignty",
    ar: "9.6 توطين البيانات والسيادة عليها",
  },
  "Compelion complies with data localization requirements where applicable. Your data may be stored and processed in data centers located within your jurisdiction to comply with local laws and regulations, including NHS data residency requirements.":
    {
      en: "Compelion complies with data localization requirements where applicable. Your data may be stored and processed in data centers located within your jurisdiction to comply with local laws and regulations, including NHS data residency requirements.",
      ar: "تلتزم Compelion بمتطلبات توطين البيانات حسب الاقتضاء. قد يتم تخزين ومعالجة بياناتك في مراكز بيانات تقع داخل نطاق سلطتك القضائية للامتثال للقوانين واللوائح المحلية، بما في ذلك متطلبات إقامة البيانات الخاصة بالخدمة الصحية الوطنية (NHS).",
    },
  "9.7 International Data Transfers": {
    en: "9.7 International Data Transfers",
    ar: "٩.٧ نقل البيانات الدولية",
  },
  "By using the Service, you acknowledge that your personal data may be transferred to, stored, and processed in countries outside of your country of residence, including countries that may have different data protection laws than those in your country. Compelion ensures that such transfers comply with applicable data protection laws and that appropriate safeguards are in place.":
    {
      en: "By using the Service, you acknowledge that your personal data may be transferred to, stored, and processed in countries outside of your country of residence, including countries that may have different data protection laws than those in your country. Compelion ensures that such transfers comply with applicable data protection laws and that appropriate safeguards are in place.",
      ar: "باستخدامك للخدمات، فإنك تقر بأن بياناتك الشخصية قد يتم نقلها إلى، وتخزينها ومعالجتها في دول خارج بلد إقامتك، بما في ذلك الدول التي قد تكون قوانين حماية البيانات فيها مختلفة عن تلك في بلدك. تضمن شركة Compelion أن تلتزم هذه التحويلات بقوانين حماية البيانات المعمول بها وأن يتم وضع الضمانات المناسبة لضمان حماية بياناتك.",
    },
  "10. Third-Party Services": {
    en: "10. Third-Party Services",
    ar: "١٠. الخدمات من الأطراف الثالثة",
  },
  "10.1 Integration with Third-Party Services": {
    en: "10.1 Integration with Third-Party Services",
    ar: "10.1 التكامل مع الخدمات الخارجية",
  },
  "The Service may integrate with or provide links to third-party applications, websites, or services (”Third-Party Services”). These Third-Party Services are provided for your convenience and do not signify our endorsement of such services.":
    {
      en: "The Service may integrate with or provide links to third-party applications, websites, or services (”Third-Party Services”). These Third-Party Services are provided for your convenience and do not signify our endorsement of such services.",
      ar: "قد تتكامل الخدمة مع تطبيقات أو مواقع ويب أو خدمات جهات خارجية أو توفر روابط لها ('خدمات الجهات الخارجية'). يتم توفير هذه الخدمات لراحتك ولا تشير إلى تأييدنا لتلك الخدمات.",
    },
  "10.2 Use of Third-Party Services": {
    en: "10.2 Use of Third-Party Services",
    ar: "١٠.٢ استخدام خدمات الطرف الثالث",
  },
  "Your use of Third-Party Services is subject to the terms and conditions and privacy policies of those third parties. Compelion is not responsible for the content, functionality, or availability of any Third-Party Services.":
    {
      en: "Your use of Third-Party Services is subject to the terms and conditions and privacy policies of those third parties. Compelion is not responsible for the content, functionality, or availability of any Third-Party Services.",
      ar: "يخضع استخدامك لخدمات الطرف الثالث لشروط وأحكام وسياسات الخصوصية الخاصة بتلك الأطراف. لا تتحمل منصة Compelion أي مسؤولية عن محتوى أو وظائف أو توفر أي من خدمات الطرف الثالث.",
    },
  "10.3 No Liability": {
    en: "10.3 No Liability",
    ar: "١٠.٣ عدم المسؤولية",
  },
  "Compelion shall not be liable for any damages or losses arising from your use of Third-Party Services.":
    {
      en: "Compelion shall not be liable for any damages or losses arising from your use of Third-Party Services.",
      ar: "لا تتحمل شركة Compelion أي مسؤولية عن أي أضرار أو خسائر تنجم عن استخدامك للخدمات المقدمة من أطراف ثالثة.",
    },
  "11. Fees and Payment": {
    en: "11. Fees and Payment",
    ar: "١١. الرسوم والدفع",
  },
  "11.1 Subscription Plans": {
    en: "11.1 Subscription Plans",
    ar: "١١.١ خطط الاشتراك",
  },
  "Access to certain features of the Service requires payment of fees as specified in the applicable subscription plan. By selecting a subscription plan, you agree to pay all fees associated with that plan.":
    {
      en: "Access to certain features of the Service requires payment of fees as specified in the applicable subscription plan. By selecting a subscription plan, you agree to pay all fees associated with that plan.",
      ar: "يتطلب الوصول إلى ميزات معينة في الخدمة سداد الرسوم كما هو محدد في خطة الاشتراك المعنية. من خلال اختيار خطة الاشتراك، فإنك توافق على دفع جميع الرسوم المرتبطة بتلك الخطة.",
    },
  "11.2 Payment Terms": {
    en: "11.2 Payment Terms",
    ar: "شروط الدفع 11.2",
  },
  "Billing: Fees are billed in advance on a monthly or annual basis, as per your subscription plan.":
    {
      en: "Billing: Fees are billed in advance on a monthly or annual basis, as per your subscription plan.",
      ar: "الفوترة: يتم خصم الرسوم مسبقًا على أساس شهري أو سنوي وفقًا لخطة الاشتراك الخاصة بك.",
    },
  "Payment Methods: You must provide valid and current payment information. By providing payment information, you authorize Compelion to charge the applicable fees to your payment method.":
    {
      en: "Payment Methods: You must provide valid and current payment information. By providing payment information, you authorize Compelion to charge the applicable fees to your payment method.",
      ar: "طرق الدفع: يجب عليك تقديم معلومات دفع صحيحة وحالية. من خلال تقديم معلومات الدفع، فإنك تمنح شركة كومبليون التفويض بخصم الرسوم المعمول بها من وسيلة الدفع الخاصة بك.",
    },
  "Auto-Renewal: Your subscription will automatically renew at the end of each billing cycle unless you cancel your subscription before the renewal date.":
    {
      en: "Auto-Renewal: Your subscription will automatically renew at the end of each billing cycle unless you cancel your subscription before the renewal date.",
      ar: "التجديد التلقائي: سيتم تجديد اشتراكك تلقائيًا في نهاية كل دورة فواتير ما لم تقم بإلغاء الاشتراك قبل تاريخ التجديد.",
    },
  "Late Payments: Late payments may result in the suspension or termination of your access to the Service.":
    {
      en: "Late Payments: Late payments may result in the suspension or termination of your access to the Service.",
      ar: "التأخيرات في الدفع: قد تؤدي التأخيرات في سداد المدفوعات إلى تعليق أو إنهاء وصولكم إلى الخدمة.",
    },
  "11.3 Taxes": {
    en: "11.3 Taxes",
    ar: "١١.٣ الضرائب",
  },
  "All fees are exclusive of taxes. You are responsible for paying any applicable taxes, including VAT, sales tax, or other governmental assessments.":
    {
      en: "All fees are exclusive of taxes. You are responsible for paying any applicable taxes, including VAT, sales tax, or other governmental assessments.",
      ar: "جميع الرسوم لا تشمل الضرائب. تتحمل أنت مسؤولية دفع أي ضرائب واجبة، بما في ذلك ضريبة القيمة المضافة، أو ضريبة المبيعات، أو أي رسوم حكومية أخرى.",
    },
  "11.4 Refunds": {
    en: "11.4 Refunds",
    ar: "١١.٤ استرداد المبالغ المدفوعة",
  },
  "Fees are non-refundable except as required by law or expressly stated in these Terms.":
    {
      en: "Fees are non-refundable except as required by law or expressly stated in these Terms.",
      ar: "الرسوم غير قابلة للاسترداد إلا وفقاً لما يقتضيه القانون أو كما هو منصوص عليه صراحةً في هذه الشروط.",
    },
  "11.5 Purchase Orders": {
    en: "11.5 Purchase Orders",
    ar: "أوامر الشراء 11.5",
  },
  "If you require the use of a purchase order or purchase order number, you must provide it at the time of purchase. Any terms and conditions on your purchase order will not apply and are null and void.":
    {
      en: "If you require the use of a purchase order or purchase order number, you must provide it at the time of purchase. Any terms and conditions on your purchase order will not apply and are null and void.",
      ar: "إذا كنت تحتاج إلى استخدام أمر شراء أو رقم أمر شراء، يجب تقديمه وقت الشراء. أي شروط وأحكام مرفقة بأمر الشراء الخاص بك لن تُطبَّق وتُعتبر لاغية وباطلة.",
    },
  "12. Service Availability and Support": {
    en: "12. Service Availability and Support",
    ar: "توفر الخدمة والدعم",
  },
  "12.1 Service Levels": {
    en: "12.1 Service Levels",
    ar: "١٢.١ مستويات الخدمة",
  },
  "Compelion will use commercially reasonable efforts to make the Service available 24 hours a day, 7 days a week, excluding:":
    {
      en: "Compelion will use commercially reasonable efforts to make the Service available 24 hours a day, 7 days a week, excluding:",
      ar: "ستبذل شركة Compelion جهودًا تجارية معقولة لجعل الخدمة متوفرة على مدار 24 ساعة في اليوم، وسبعة أيام في الأسبوع، باستثناء:",
    },
  "Planned Downtime: We will provide at least 24 hours’ notice via the Service or email for scheduled maintenance.":
    {
      en: "Planned Downtime: We will provide at least 24 hours’ notice via the Service or email for scheduled maintenance.",
      ar: "التوقف المخطط له: سنقوم بإعلامكم قبل 24 ساعة على الأقل من خلال الخدمة أو عبر البريد الإلكتروني عن أي صيانة مجدولة.",
    },
  "Emergency Maintenance: In the event of emergency maintenance, we will make reasonable efforts to provide notice as soon as practicable.":
    {
      en: "Emergency Maintenance: In the event of emergency maintenance, we will make reasonable efforts to provide notice as soon as practicable.",
      ar: "صيانة طارئة: في حالة إجراء صيانة طارئة، سنبذل جهودًا معقولة لتقديم إشعار في أقرب وقت ممكن.",
    },
  "Force Majeure Events: Any unavailability caused by circumstances beyond our reasonable control.":
    {
      en: "Force Majeure Events: Any unavailability caused by circumstances beyond our reasonable control.",
      ar: "حالات القوة القاهرة: أي تعذر في الخدمة بسبب ظروف خارجة عن نطاق سيطرتنا المعقولة.",
    },
  "12.2 Support Services": {
    en: "12.2 Support Services",
    ar: "خدمات الدعم 12.2",
  },
  "Compelion provides support services as specified in your subscription plan. Support can be accessed by contacting us at support@compelion.com.":
    {
      en: "Compelion provides support services as specified in your subscription plan. Support can be accessed by contacting us at support@compelion.com.",
      ar: "توفر منصة كيوبليون خدمات الدعم كما هو محدد في خطة اشتراكك. يمكن الوصول إلى الدعم من خلال التواصل معنا على البريد الإلكتروني: support@compelion.com.",
    },
  "13. Termination": {
    en: "13. Termination",
    ar: "١٣. الإنهاء",
  },
  "13.1 Termination by User": {
    en: "13.1 Termination by User",
    ar: "١٣.١ إنهاء الاستخدام من قبل المستخدم",
  },
  "You may terminate your account at any time by following the account termination procedures provided in the Service.":
    {
      en: "You may terminate your account at any time by following the account termination procedures provided in the Service.",
      ar: "يمكنك إنهاء حسابك في أي وقت باتباع إجراءات إنهاء الحساب المتوفرة ضمن الخدمة.",
    },
  "13.2 Termination by Compelion": {
    en: "13.2 Termination by Compelion",
    ar: "١٣.٢ إنهاء العقد من قبل شركة Compelion",
  },
  "Compelion may suspend or terminate your access to the Service immediately, without prior notice or liability, for any reason, including if:":
    {
      en: "Compelion may suspend or terminate your access to the Service immediately, without prior notice or liability, for any reason, including if:",
      ar: "قد تقوم منصة Compelion بتعليق أو إنهاء وصولك إلى الخدمة فورًا، دون إشعار مسبق أو تحمل أي مسؤولية، وذلك لأي سبب، بما في ذلك إذا:",
    },
  "You breach any provision of these Terms.": {
    en: "You breach any provision of these Terms.",
    ar: "تخالف أي بند من بنود هذه الشروط.",
  },
  "Compelion is required to do so by law.": {
    en: "Compelion is required to do so by law.",
    ar: "يتوجب على Compelion القيام بذلك بموجب القانون.",
  },
  "Providing the Service to you is no longer commercially viable.": {
    en: "Providing the Service to you is no longer commercially viable.",
    ar: "لم يعد تقديم الخدمة لك ذا جدوى تجارية.",
  },
  "13.3 Effect of Termination": {
    en: "13.3 Effect of Termination",
    ar: "تأثير الإنهاء 13.3",
  },
  "Upon termination:": {
    en: "Upon termination:",
    ar: "عند الإنهاء:",
  },
  "All licenses granted to you under these Terms will cease.": {
    en: "All licenses granted to you under these Terms will cease.",
    ar: "جميع التراخيص الممنوحة لك بموجب هذه الشروط ستتوقف.",
  },
  "You must immediately cease all use of the Service.": {
    en: "You must immediately cease all use of the Service.",
    ar: "يجب عليكم التوقف فوراً عن استخدام الخدمة.",
  },
  "Compelion will, upon your request, return or delete your User Content in accordance with applicable laws and our data retention policies.":
    {
      en: "Compelion will, upon your request, return or delete your User Content in accordance with applicable laws and our data retention policies.",
      ar: "ستقوم كومبيليون، بناءً على طلبك، بإعادة أو حذف المحتوى الخاص بك وفقاً للقوانين المعمول بها وسياساتنا للاحتفاظ بالبيانات.",
    },
  "14. Warranties and Disclaimers": {
    en: "14. Warranties and Disclaimers",
    ar: "١٤. الضمانات وإخلاء المسؤولية",
  },
  "14.1 Disclaimer of Warranties": {
    en: "14.1 Disclaimer of Warranties",
    ar: "إخلاء المسؤولية عن الضمانات 14.1",
  },
  "To the maximum extent permitted by applicable law, the Service is provided “AS IS” and “AS AVAILABLE,” without warranties of any kind, whether express, implied, statutory, or otherwise, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, title, and non-infringement.":
    {
      en: "To the maximum extent permitted by applicable law, the Service is provided “AS IS” and “AS AVAILABLE,” without warranties of any kind, whether express, implied, statutory, or otherwise, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, title, and non-infringement.",
      ar: "إلى أقصى حد يسمح به القانون المعمول به، يتم تقديم الخدمة 'كما هي' و'حسب توفرها'، دون أي ضمانات من أي نوع، سواء كانت صريحة أو ضمنية أو قانونية أو غير ذلك، بما في ذلك، على سبيل المثال لا الحصر، الضمانات الضمنية بالتسويق، الملاءمة لغرض معين، الملكية وعدم الانتهاك.",
    },
  "14.2 No Guarantee": {
    en: "14.2 No Guarantee",
    ar: "١٤.٢ لا يوجد ضمان",
  },
  "Compelion does not warrant that:": {
    en: "Compelion does not warrant that:",
    ar: "لا تضمن شركة Compelion أن:",
  },
  "The Service will meet your requirements.": {
    en: "The Service will meet your requirements.",
    ar: "سوف تلبي الخدمة متطلباتكم.",
  },
  "The Service will be uninterrupted, timely, secure, or error-free.": {
    en: "The Service will be uninterrupted, timely, secure, or error-free.",
    ar: "ستكون الخدمة دون انقطاع، ووفق الجدول الزمني، وآمنة، وخالية من الأخطاء.",
  },
  "The results obtained from the use of the Service will be accurate or reliable.":
    {
      en: "The results obtained from the use of the Service will be accurate or reliable.",
      ar: "النتائج المحصلة من استخدام الخدمة ستكون دقيقة أو موثوقة.",
    },
  "Any errors in the Service will be corrected.": {
    en: "Any errors in the Service will be corrected.",
    ar: "سيتم تصحيح أي أخطاء في الخدمة.",
  },
  "15. Limitation of Liability": {
    en: "15. Limitation of Liability",
    ar: "١٥. حدود المسؤولية",
  },
  "15.1 Exclusion of Certain Damages": {
    en: "15.1 Exclusion of Certain Damages",
    ar: "استثناء بعض الأضرار",
  },
  "To the maximum extent permitted by applicable law, in no event shall Compelion, its affiliates, directors, employees, agents, or licensors be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, revenue, data, or data use, incurred by you or any third party, whether in an action in contract or tort, arising from your access to, or use of, the Service.":
    {
      en: "To the maximum extent permitted by applicable law, in no event shall Compelion, its affiliates, directors, employees, agents, or licensors be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, revenue, data, or data use, incurred by you or any third party, whether in an action in contract or tort, arising from your access to, or use of, the Service.",
      ar: "إلى الحد الأقصى الذي يسمح به القانون المعمول به، لن تكون Compelion أو الشركات التابعة لها أو مدراؤها أو موظفوها أو وكلاؤها أو المرخصون مسؤولين عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو جزائية، بما في ذلك على سبيل المثال لا الحصر خسارة الأرباح أو العوائد أو البيانات أو استخدامها، التي قد تتكبدها أنت أو أي طرف ثالث، سواء في دعوى عقدية أو تقصيرية، والناتجة عن وصولك إلى الخدمة أو استخدامها.",
    },
  "15.2 Limitation of Liability": {
    en: "15.2 Limitation of Liability",
    ar: "١٥.٢ تحديد المسؤولية",
  },
  "To the maximum extent permitted by applicable law, Compelion's total liability to you for any claim arising out of or relating to these Terms or the Service shall not exceed the total amount paid by you to Compelion for the Service during the twelve (12) months preceding the claim.":
    {
      en: "To the maximum extent permitted by applicable law, Compelion's total liability to you for any claim arising out of or relating to these Terms or the Service shall not exceed the total amount paid by you to Compelion for the Service during the twelve (12) months preceding the claim.",
      ar: "إلى أقصى حد مسموح به بموجب القانون المعمول به، لا تتجاوز المسؤولية الكاملة لشركة Compelion تجاهكم عن أي مطالبة ناتجة عن أو تتعلق بهذه الشروط أو الخدمة المبلغ الإجمالي الذي دفعتموه لشركة Compelion مقابل الخدمة خلال الاثني عشر (12) شهرًا التي تسبق المطالبة.",
    },
  "16. Indemnification": {
    en: "16. Indemnification",
    ar: "التعويضات",
  },
  "You agree to defend, indemnify, and hold harmless Compelion, its affiliates, directors, officers, employees, agents, and licensors from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising from:":
    {
      en: "You agree to defend, indemnify, and hold harmless Compelion, its affiliates, directors, officers, employees, agents, and licensors from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising from:",
      ar: "أنت توافق على الدفاع عن شركة Compelion وفروعها ومديريها ومسؤوليها وموظفيها ووكلائها والمرخصين لديها وتعويضهم وحمايتهم من أي وجميع المطالبات والمسؤوليات والأضرار والخسائر والتكاليف والنفقات أو الرسوم (بما في ذلك أتعاب المحاماة المعقولة) الناشئة عن:",
    },
  "Your use or misuse of the Service.": {
    en: "Your use or misuse of the Service.",
    ar: "استخدامك أو سوء استخدامك للخدمة.",
  },
  "Your violation of these Terms.": {
    en: "Your violation of these Terms.",
    ar: "مخالفتك لهذه الشروط.",
  },
  "Your violation of any rights of a third party, including intellectual property rights or privacy rights.":
    {
      en: "Your violation of any rights of a third party, including intellectual property rights or privacy rights.",
      ar: "انتهاكك لأي حقوق لطرف ثالث، بما في ذلك حقوق الملكية الفكرية أو حقوق الخصوصية.",
    },
  "Your violation of any applicable laws, rules, or regulations.": {
    en: "Your violation of any applicable laws, rules, or regulations.",
    ar: "مخالفتك لأي قوانين أو أنظمة أو لوائح سارية.",
  },
  "17. Governing Law and Dispute Resolution": {
    en: "17. Governing Law and Dispute Resolution",
    ar: "القانون المنظم وتسوية النزاعات",
  },
  "17.1 Governing Law": {
    en: "17.1 Governing Law",
    ar: "١٧.١ القانون السائد",
  },
  "These Terms shall be governed by and construed in accordance with the laws of England and Wales, without regard to its conflict of laws principles.":
    {
      en: "These Terms shall be governed by and construed in accordance with the laws of England and Wales, without regard to its conflict of laws principles.",
      ar: ":ستُحكم هذه الشروط وتُفسر وفقًا لقوانين إنجلترا وويلز، دون اعتبار لمبادئ تنازع القوانين الخاصة بها",
    },
  "17.2 Dispute Resolution": {
    en: "17.2 Dispute Resolution",
    ar: "حل النزاعات 17.2",
  },
  "17.2.1 Negotiation": {
    en: "17.2.1 Negotiation",
    ar: "١٧.٢.١ التفاوض",
  },
  "In the event of any dispute, controversy, or claim arising out of or relating to these Terms or the breach, termination, or validity thereof (“Dispute”), the parties shall first attempt to resolve the Dispute through good-faith negotiations.":
    {
      en: "In the event of any dispute, controversy, or claim arising out of or relating to these Terms or the breach, termination, or validity thereof (“Dispute”), the parties shall first attempt to resolve the Dispute through good-faith negotiations.",
      ar: "في حال نشوء أي نزاع أو خلاف أو مطالبة تتعلق بهذه الشروط أو بخرقها أو إنهائها أو صحتها 'النزاع')، يتعين على الأطراف أولاً محاولة حل النزاع من خلال مفاوضات مبنية على حسن النية.",
    },
  "17.2.2 Mediation": {
    en: "17.2.2 Mediation",
    ar: "الوساطة 17.2.2",
  },
  "If the Dispute is not resolved within thirty (30) days of initiating negotiations, the parties agree to attempt to settle the Dispute by mediation administered by a recognized mediation institution in the applicable jurisdiction.":
    {
      en: "If the Dispute is not resolved within thirty (30) days of initiating negotiations, the parties agree to attempt to settle the Dispute by mediation administered by a recognized mediation institution in the applicable jurisdiction.",
      ar: "إذا لم يتم حل النزاع خلال ثلاثين (30) يومًا من بدء المفاوضات، يتفق الأطراف على محاولة تسوية النزاع عن طريق الوساطة التي تديرها مؤسسة وساطة معترف بها في الولاية القضائية المعنية.",
    },
  "17.2.3 Arbitration": {
    en: "17.2.3 Arbitration",
    ar: "التحكيم 17.2.3",
  },
  "If the Dispute is not resolved through mediation within sixty (60) days, it shall be finally settled by binding arbitration in accordance with the arbitration rules of the applicable institution:":
    {
      en: "If the Dispute is not resolved through mediation within sixty (60) days, it shall be finally settled by binding arbitration in accordance with the arbitration rules of the applicable institution:",
      ar: "إذا لم يتم حل النزاع من خلال الوساطة خلال ستين (60) يومًا، فإنه يتم حله نهائيًا عن طريق التحكيم الملزم وفقًا لقواعد التحكيم الخاصة بالمؤسسة المعنية:",
    },
  "United Kingdom: London Court of International Arbitration (LCIA).": {
    en: "United Kingdom: London Court of International Arbitration (LCIA).",
    ar: "المملكة المتحدة: المحكمة الدولية للتحكيم في لندن (LCIA).",
  },
  "Saudi Arabia: Saudi Center for Commercial Arbitration (SCCA).": {
    en: "Saudi Arabia: Saudi Center for Commercial Arbitration (SCCA).",
    ar: "المملكة العربية السعودية: المركز السعودي للتحكيم التجاري (SCCA).",
  },
  "United Arab Emirates: Dubai International Arbitration Centre (DIAC).": {
    en: "United Arab Emirates: Dubai International Arbitration Centre (DIAC).",
    ar: "الإمارات العربية المتحدة: مركز دبي للتحكيم الدولي (DIAC).",
  },
  "Qatar: Qatar International Court and Dispute Resolution Centre (QICDRC).": {
    en: "Qatar: Qatar International Court and Dispute Resolution Centre (QICDRC).",
    ar: "قطر: محكمة قطر الدولية ومركز تسوية المنازعات (QICDRC).",
  },
  "17.2.4 Class Action Waiver": {
    en: "17.2.4 Class Action Waiver",
    ar: "17.2.4 التنازل عن الدعاوى الجماعية",
  },
  "You agree that any Dispute shall be resolved on an individual basis and not as a class, consolidated, or representative action.":
    {
      en: "You agree that any Dispute shall be resolved on an individual basis and not as a class, consolidated, or representative action.",
      ar: "أنت توافق على أن أي نزاع سيتم حله على أساس فردي وليس كإجراء جماعي أو موحد أو تمثيلي.",
    },
  "17.2.5 Jurisdiction": {
    en: "17.2.5 Jurisdiction",
    ar: "17.2.5 الاختصاص القضائي",
  },
  "Each party irrevocably submits to the exclusive jurisdiction of the courts located in the applicable jurisdiction for the enforcement of any arbitration award.":
    {
      en: "Each party irrevocably submits to the exclusive jurisdiction of the courts located in the applicable jurisdiction for the enforcement of any arbitration award.",
      ar: "تلتزم كل جهة بشكل غير قابل للإلغاء بالاختصاص القضائي الحصري للمحاكم الموجودة في الاختصاص القضائي المعني لتنفيذ أي قرار تحكيم.",
    },
  "17.3 Time Limitation on Claims": {
    en: "17.3 Time Limitation on Claims",
    ar: "١٧.٣ الحد الزمني لتقديم المطالبات",
  },
  "Any claim arising out of or relating to these Terms must be filed within one (1) year after such claim arose; otherwise, the claim is permanently barred.":
    {
      en: "Any claim arising out of or relating to these Terms must be filed within one (1) year after such claim arose; otherwise, the claim is permanently barred.",
      ar: "أي مطالبة تنشأ عن هذه الشروط أو تتعلق بها يجب تقديمها خلال سنة واحدة من تاريخ نشوء تلك المطالبة؛ وإلا فإن هذه المطالبة ستكون محظورة بشكل دائم.",
    },
  "18. Compliance with Export Controls and Sanctions": {
    en: "18. Compliance with Export Controls and Sanctions",
    ar: "الامتثال لضوابط التصدير والعقوبات",
  },
  "You agree to comply with all applicable export control and sanctions laws and regulations, including but not limited to those of the United Kingdom, United States, European Union, and other jurisdictions. You represent and warrant that you are not located in, under the control of, or a national or resident of any country or territory that is subject to economic sanctions or trade embargoes.":
    {
      en: "You agree to comply with all applicable export control and sanctions laws and regulations, including but not limited to those of the United Kingdom, United States, European Union, and other jurisdictions. You represent and warrant that you are not located in, under the control of, or a national or resident of any country or territory that is subject to economic sanctions or trade embargoes.",
      ar: "أنت توافق على الامتثال لجميع قوانين ولوائح مراقبة الصادرات والعقوبات السارية، بما في ذلك، على سبيل المثال لا الحصر، تلك التابعة للمملكة المتحدة، والولايات المتحدة، والاتحاد الأوروبي، والسلطات القضائية الأخرى. أنت تقر وتضمن أنك لست موجودًا في، تحت سيطرة، أو مواطن أو مقيم في أي بلد أو إقليم يخضع لعقوبات اقتصادية أو حظر تجاري.",
    },
  "19. Anti-Bribery and Corruption": {
    en: "19. Anti-Bribery and Corruption",
    ar: "مكافحة الرشوة والفساد",
  },
  "You represent and warrant that you shall comply with all applicable anti-bribery and anti-corruption laws, including but not limited to:":
    {
      en: "You represent and warrant that you shall comply with all applicable anti-bribery and anti-corruption laws, including but not limited to:",
      ar: "أنت تقر وتتعهد بأنك ستلتزم بجميع القوانين المعمول بها لمكافحة الرشوة والفساد، بما في ذلك على سبيل المثال لا الحصر:",
    },
  "United Kingdom: Bribery Act 2010.": {
    en: "United Kingdom: Bribery Act 2010.",
    ar: "المملكة المتحدة: قانون مكافحة الرشوة لعام 2010.",
  },
  "Saudi Arabia: Anti-Bribery Law.": {
    en: "Saudi Arabia: Anti-Bribery Law.",
    ar: "قانون مكافحة الرشوة في المملكة العربية السعودية.",
  },
  "United Arab Emirates: Federal Law No. 3 of 1987 (UAE Penal Code).": {
    en: "United Arab Emirates: Federal Law No. 3 of 1987 (UAE Penal Code).",
    ar: "الإمارات العربية المتحدة: قانون العقوبات الاتحادي رقم 3 لعام الإمارات العربية المتحدة: قانون اتحادي رقم 3 لسنة 1987 (قانون العقوبات الإماراتي).",
  },
  "Qatar: Anti-Bribery and Corruption Laws.": {
    en: "Qatar: Anti-Bribery and Corruption Laws.",
    ar: "قطر: قوانين مكافحة الرشوة والفساد",
  },
  "International Laws: U.S. Foreign Corrupt Practices Act (FCPA).": {
    en: "International Laws: U.S. Foreign Corrupt Practices Act (FCPA).",
    ar: "القوانين الدولية: قانون الممارسات الفاسدة الأجنبية الأمريكي (FCPA).",
  },
  "You agree not to offer, promise, give, or receive any bribes or other improper payments or benefits in connection with your use of the Service.":
    {
      en: "You agree not to offer, promise, give, or receive any bribes or other improper payments or benefits in connection with your use of the Service.",
      ar: "تتعهد بعدم تقديم أو التعهد بتقديم أو منح أو قبول أي رشوة أو مبالغ أو مزايا غير مشروعة فيما يتعلق باستخدامك للخدمة.",
    },
  "20. Intellectual Property Infringement Claims": {
    en: "20. Intellectual Property Infringement Claims",
    ar: "٢٠. دعاوى انتهاك الملكية الفكرية",
  },
  "20.1 Reporting Claims": {
    en: "20.1 Reporting Claims",
    ar: "التقارير عن المطالبات 20.1",
  },
  "If you believe that any content on the Service infringes your intellectual property rights, please notify us promptly at legal@compelion.com with the following information:":
    {
      en: "If you believe that any content on the Service infringes your intellectual property rights, please notify us promptly at legal@compelion.com with the following information:",
      ar: "إذا كنت تعتقد أن أي محتوى على الخدمة ينتهك حقوق الملكية الفكرية الخاصة بك، فنرجو منك إشعارنا على الفور عن طريق البريد الإلكتروني legal@compelion.com مع تزويدنا بالمعلومات التالية:",
    },
  "A description of the intellectual property rights you claim have been infringed.":
    {
      en: "A description of the intellectual property rights you claim have been infringed.",
      ar: "وصف حقوق الملكية الفكرية التي تزعمون أنها قد تم التعدي عليها.",
    },
  "A description of the content on the Service that you claim is infringing.": {
    en: "A description of the content on the Service that you claim is infringing.",
    ar: "وصف المحتوى على الخدمة الذي تدعي أنه ينتهك الحقوق.",
  },
  "Your contact information, including address, telephone number, and email address.":
    {
      en: "Your contact information, including address, telephone number, and email address.",
      ar: "معلومات الاتصال الخاصة بك، بما في ذلك العنوان، ورقم الهاتف، وعنوان البريد الإلكتروني.",
    },
  "A statement by you that you have a good-faith belief that the disputed use is not authorized by the rights owner, its agent, or the law.":
    {
      en: "A statement by you that you have a good-faith belief that the disputed use is not authorized by the rights owner, its agent, or the law.",
      ar: "بيان منكم يؤكد اعتقادكم الصادق بأن الاستخدام المتنازع عليه لم يُصرح به من قبل مالك الحقوق أو وكيله أو القانون.",
    },
  "A statement by you, made under penalty of perjury, that the above information is accurate and that you are the rights owner or authorized to act on the rights owner’s behalf.":
    {
      en: "A statement by you, made under penalty of perjury, that the above information is accurate and that you are the rights owner or authorized to act on the rights owner’s behalf.",
      ar: "بيان صادر عنك، تحت عقوبة الحنث باليمين، الذي يوضح أن المعلومات المذكورة أعلاه دقيقة وأنك مالك الحقوق أو مخول بالتصرف نيابة عن مالك الحقوق.",
    },
  "20.2 Response": {
    en: "20.2 Response",
    ar: "استجابة 20.2",
  },
  "Compelion will respond to valid notices of alleged infringement in accordance with applicable laws and regulations.":
    {
      en: "Compelion will respond to valid notices of alleged infringement in accordance with applicable laws and regulations.",
      ar: "ستقوم منصة Compelion بالاستجابة للإشعارات الصحيحة المتعلقة بالانتهاكات المزعومة وفقًا للقوانين واللوائح المعمول بها.",
    },
  "21. Force Majeure": {
    en: "21. Force Majeure",
    ar: "٢١. القوة القاهرة",
  },
  "Compelion shall not be liable for any failure or delay in performance to the extent caused by circumstances beyond its reasonable control, including but not limited to acts of God, natural disasters, war, terrorism, civil unrest, labor shortages or disputes, internet or telecommunications failures, or governmental actions.":
    {
      en: "Compelion shall not be liable for any failure or delay in performance to the extent caused by circumstances beyond its reasonable control, including but not limited to acts of God, natural disasters, war, terrorism, civil unrest, labor shortages or disputes, internet or telecommunications failures, or governmental actions.",
      ar: "لا تتحمل شركة Compelion أي مسؤولية عن أي فشل أو تأخير في الأداء ناتج عن ظروف خارجة عن نطاق سيطرتها المعقولة، بما في ذلك على سبيل المثال لا الحصر، الكوارث الطبيعية، الحروب، الإرهاب، الاضطرابات المدنية، نقص أو نزاعات العمل، انقطاعات الإنترنت أو الاتصالات، أو الإجراءات الحكومية.",
    },
  "22. Miscellaneous": {
    en: "22. Miscellaneous",
    ar: "٢٢. متفرقات",
  },
  "22.1 Entire Agreement": {
    en: "22.1 Entire Agreement",
    ar: "٢٢.١ الاتفاقية الكاملة",
  },
  "These Terms, together with the Privacy Policy and any applicable DPA, constitute the entire agreement between you and Compelion regarding the Service and supersede all prior or contemporaneous communications, agreements, and understandings, whether oral or written.":
    {
      en: "These Terms, together with the Privacy Policy and any applicable DPA, constitute the entire agreement between you and Compelion regarding the Service and supersede all prior or contemporaneous communications, agreements, and understandings, whether oral or written.",
      ar: "تشكل هذه الشروط، جنبًا إلى جنب مع سياسة الخصوصية وأية اتفاقية معالجة بيانات قابلة للتطبيق (DPA)، الاتفاق الكامل بينك وبين شركة Compelion فيما يتعلق بالخدمة، وتلغي جميع الاتصالات والاتفاقيات والتفاهمات السابقة أو الآنية، سواء كانت شفهية أو مكتوبة.",
    },
  "22.2 Amendments": {
    en: "22.2 Amendments",
    ar: "٢٢.٢ التعديلات",
  },
  "Compelion may modify these Terms at any time by posting the amended Terms on the Service or by notifying you via email. Changes will be effective upon posting or as specified in the notice. Your continued use of the Service after the effective date constitutes your acceptance of the amended Terms.":
    {
      en: "Compelion may modify these Terms at any time by posting the amended Terms on the Service or by notifying you via email. Changes will be effective upon posting or as specified in the notice. Your continued use of the Service after the effective date constitutes your acceptance of the amended Terms.",
      ar: "قد تقوم شركة كومبيليون بتعديل هذه الشروط في أي وقت من خلال نشر الشروط المعدلة على الخدمة أو بإخطاركم عبر البريد الإلكتروني. ستكون التعديلات سارية المفعول اعتباراً من تاريخ النشر أو كما هو محدد في الإشعار. يعد استمراركم في استخدام الخدمة بعد تاريخ السريان قبولاً منكم لهذه الشروط المعدلة.",
    },
  "22.3 Severability": {
    en: "22.3 Severability",
    ar: "الفصل 22.3: قابلية الانفصال",
  },
  "If any provision of these Terms is found to be invalid or unenforceable under applicable law, such provision shall be modified to the minimum extent necessary to make it valid and enforceable, and the remaining provisions shall remain in full force and effect.":
    {
      en: "If any provision of these Terms is found to be invalid or unenforceable under applicable law, such provision shall be modified to the minimum extent necessary to make it valid and enforceable, and the remaining provisions shall remain in full force and effect.",
      ar: "إذا تم اعتبار أي بند من هذه الأحكام باطلاً أو غير قابل للتنفيذ بموجب القانون المعمول به، فسيتم تعديل هذا البند بالحد الأدنى اللازم لجعله صالحاً وقابلاً للتنفيذ، وستظل الأحكام المتبقية سارية المفعول بشكل كامل.",
    },
  "22.4 Waiver": {
    en: "22.4 Waiver",
    ar: "٢٢.٤ التنازل",
  },
  "No waiver of any provision of these Terms shall be effective unless in writing and signed by an authorized representative of Compelion. Failure to enforce any provision of these Terms shall not constitute a waiver of future enforcement of that or any other provision.":
    {
      en: "No waiver of any provision of these Terms shall be effective unless in writing and signed by an authorized representative of Compelion. Failure to enforce any provision of these Terms shall not constitute a waiver of future enforcement of that or any other provision.",
      ar: "لا يُعتبر أي إعفاء من أي بند من بنود هذه الشروط ساريًا إلا إذا كان مكتوبًا وموقعًا من قبل ممثل مخول من شركة كومبليون. إن عدم تنفيذ أي بند من هذه الشروط لا يُعتبر تنازلاً عن فرض هذا البند أو أي بند آخر في المستقبل.",
    },
  "22.5 Assignment": {
    en: "22.5 Assignment",
    ar: "التعيين 22.5",
  },
  "You may not assign or transfer these Terms or any rights or obligations hereunder without Compelion’s prior written consent. Compelion may assign or transfer these Terms, in whole or in part, at any time without notice.":
    {
      en: "You may not assign or transfer these Terms or any rights or obligations hereunder without Compelion’s prior written consent. Compelion may assign or transfer these Terms, in whole or in part, at any time without notice.",
      ar: "لا يحق لك التنازل عن هذه الشروط أو نقل أي من الحقوق أو الالتزامات المنصوص عليها هنا دون الحصول على موافقة خطية مسبقة من شركة Compelion. يحق لشركة Compelion التنازل عن هذه الشروط أو نقلها، كلياً أو جزئياً، في أي وقت دون إشعار.",
    },
  "22.6 Language": {
    en: "22.6 Language",
    ar: "لغة النظام",
  },
  "These Terms are drafted in English. If these Terms are translated into another language, the English version shall prevail in the event of any conflict or discrepancy.":
    {
      en: "These Terms are drafted in English. If these Terms are translated into another language, the English version shall prevail in the event of any conflict or discrepancy.",
      ar: "تم صياغة هذه الشروط باللغة الإنجليزية. وإذا تم ترجمة هذه الشروط إلى لغة أخرى، فإن النسخة الإنجليزية هي التي تسود في حال حدوث أي تعارض أو تناقض.",
    },
  "22.7 Notices": {
    en: "22.7 Notices",
    ar: "الإشعارات 22.7",
  },
  "All notices or other communications required or permitted under these Terms shall be in writing and delivered to Compelion at legal@compelion.com.":
    {
      en: "All notices or other communications required or permitted under these Terms shall be in writing and delivered to Compelion at legal@compelion.com.",
      ar: "يجب أن تكون جميع الإشعارات أو الاتصالات الأخرى المطلوبة أو المسموح بها بموجب هذه الشروط مكتوبة وموجهة إلى كومبليون عبر البريد الإلكتروني legal@compelion.com.",
    },
  "23. Territorial Restrictions": {
    en: "23. Territorial Restrictions",
    ar: "٢٣. القيود الإقليمية",
  },
  "The Service is intended for users worldwide. However, Compelion makes no representations that the Service is appropriate or available for use in all countries or territories. Users who access or use the Service are responsible for compliance with local laws and regulations.":
    {
      en: "The Service is intended for users worldwide. However, Compelion makes no representations that the Service is appropriate or available for use in all countries or territories. Users who access or use the Service are responsible for compliance with local laws and regulations.",
      ar: "تم تصميم الخدمة لتكون متاحة للمستخدمين في جميع أنحاء العالم. ومع ذلك، لا تقدم شركة Compelion أي تأكيدات بأن الخدمة ملائمة أو متاحة للاستخدام في جميع البلدان أو الأقاليم. يتحمل المستخدمون الذين يصلون إلى الخدمة أو يستخدمونها مسؤولية الامتثال للقوانين واللوائح المحلية.",
    },
  "24. Export Control": {
    en: "24. Export Control",
    ar: "التحكم في الصادرات",
  },
  "Software and content related to the Service may be subject to export controls under the laws of the United Kingdom, United States, and other jurisdictions. You agree to comply with all applicable export laws and regulations.":
    {
      en: "Software and content related to the Service may be subject to export controls under the laws of the United Kingdom, United States, and other jurisdictions. You agree to comply with all applicable export laws and regulations.",
      ar: "قد يكون البرنامج والمحتوى المتعلق بالخدمة خاضعاً لرقابة التصدير وفقًا لقوانين المملكة المتحدة والولايات المتحدة وولايات قضائية أخرى. توافق على الالتزام بجميع قوانين وأنظمة التصدير المعمول بها.",
    },
  "25. NHS and Healthcare Compliance": {
    en: "25. NHS and Healthcare Compliance",
    ar: "الامتثال لأنظمة الرعاية الصحية والخدمات الصحية الوطنية (NHS)",
  },
  "If you are a part of the National Health Service (NHS) or any healthcare organization, you acknowledge and agree that:":
    {
      en: "If you are a part of the National Health Service (NHS) or any healthcare organization, you acknowledge and agree that:",
      ar: "إذا كنت جزءًا من الخدمة الصحية الوطنية (NHS) أو أي منظمة رعاية صحية أخرى، فإنك تقر وتوافق على ما يلي:",
    },
  "Data Protection: Compelion complies with the NHS Data Security and Protection Toolkit and implements necessary measures to protect patient data and confidential information.":
    {
      en: "Data Protection: Compelion complies with the NHS Data Security and Protection Toolkit and implements necessary measures to protect patient data and confidential information.",
      ar: "حماية البيانات: تلتزم كومبيليون بأداة 'أمن وحماية البيانات' الخاصة بالهيئة الوطنية للخدمات الصحية (NHS) وتنفذ الإجراءات اللازمة لحماية بيانات المرضى والمعلومات السرية.",
    },
  "Confidentiality: All patient-related data is treated as Confidential Information as per Section 8.":
    {
      en: "Confidentiality: All patient-related data is treated as Confidential Information as per Section 8.",
      ar: "السرية: يتم التعامل مع جميع البيانات المتعلقة بالمرضى على أنها معلومات سرية وفقًا للمادة 8.",
    },
  "Compliance with Healthcare Regulations: Compelion adheres to all applicable healthcare laws and regulations, including but not limited to the Health and Social Care Act 2012 (UK) and equivalent regulations in other jurisdictions.":
    {
      en: "Compliance with Healthcare Regulations: Compelion adheres to all applicable healthcare laws and regulations, including but not limited to the Health and Social Care Act 2012 (UK) and equivalent regulations in other jurisdictions.",
      ar: "الامتثال للوائح الرعاية الصحية: تتبع Compelion جميع القوانين واللوائح المعمول بها في قطاع الرعاية الصحية، بما في ذلك على سبيل المثال لا الحصر قانون الصحة والرعاية الاجتماعية لعام 2012 (المملكة المتحدة) واللوائح المماثلة في الولايات القضائية الأخرى.",
    },
  "Data Processing Agreement: A separate Data Processing Agreement may be required to address specific data handling and processing obligations under healthcare laws.":
    {
      en: "Data Processing Agreement: A separate Data Processing Agreement may be required to address specific data handling and processing obligations under healthcare laws.",
      ar: "اتفاقية معالجة البيانات: قد تكون هناك حاجة إلى إبرام اتفاقية معالجة بيانات منفصلة لمعالجة التزامات معينة تتعلق بمعالجة البيانات والتعامل معها بموجب القوانين الصحية.",
    },
  "26. Contact Information": {
    en: "26. Contact Information",
    ar: "٢٦. معلومات التواصل",
  },
  "If you have any questions about these Terms or wish to contact us for any reason, please reach out to us at legal@compelion.com.":
    {
      en: "If you have any questions about these Terms or wish to contact us for any reason, please reach out to us at legal@compelion.com.",
      ar: "إذا كان لديك أي استفسارات بشأن هذه الشروط أو ترغب في التواصل معنا لأي سبب كان، يُرجى الاتصال بنا عبر البريد الإلكتروني: legal@compelion.com.",
    },
  "Add Metric Data": {
    en: "Add Metric Data",
    ar: "إضافة بيانات القياس",
  },
  "Invite Member": {
    en: "Invite Member",
    ar: "دعوة عضو جديد",
  },
  "Scheduled Tasks": {
    en: "Scheduled Tasks",
    ar: "المهام المجدولة",
  },
  "All Approvals": {
    en: "All Approvals",
    ar: "كافة الموافقات",
  },
  "Department ": {
    en: "Department",
    ar: "القسم",
  },
  Department: {
    en: "Department",
    ar: "القسم",
  },
  "Division ": {
    en: "Division",
    ar: "القسم",
  },
  Division: {
    en: "Division",
    ar: "التقسيم",
  },
  "Roles ": {
    en: "Roles",
    ar: "الأدوار",
  },
  "Designation ": {
    en: "Designation",
    ar: "التعيين",
  },
  Designation: {
    en: "Designation",
    ar: "تعيين",
  },
  "Member Email": {
    en: "Member Email",
    ar: "البريد الإلكتروني للعضو",
  },
  "First Name": {
    en: "First Name",
    ar: "الاسم الأول",
  },
  "Last Name": {
    en: "Last Name",
    ar: "اللقب",
  },
  "Select a Project": {
    en: "Select a Project",
    ar: "اختر مشروعًا",
  },
  "Select a Metric": {
    en: "Select a Metric",
    ar: "اختر مقياساً",
  },
  "Date Occurred": {
    en: "Date Occurred",
    ar: "تاريخ الحدوث",
  },
  "Value ": {
    en: "Value",
    ar: "قيمة",
  },
  "Add Data Point": {
    en: "Add Data Point",
    ar: "إضافة نقطة بيانات",
  },
  "Task Title: ": {
    en: "Task Title: ",
    ar: "عنوان المهمة:",
  },
  "Task Description: ": {
    en: "Task Description: ",
    ar: "وصف المهمة:",
  },
  "Due: ": {
    en: "Due: ",
    ar: "تاريخ الاستحقاق:",
  },
  "Status: ": {
    en: "Status: ",
    ar: "الحالة:",
  },
  "Complexity: ": {
    en: "Complexity: ",
    ar: "التعقيد:",
  },
  "Priority: ": {
    en: "Priority: ",
    ar: "الأولوية:",
  },
  "Send Super Task To: ": {
    en: "Send Super Task To:: ",
    ar: "إرسال المهمة الفائقة إلى:",
  },
  Leaderboard: {
    en: "Leaderboard",
    ar: "لوحة المتصدرين",
  },
  User: {
    en: "User",
    ar: "المستخدم",
  },
  Guide: {
    en: "Guide",
    ar: "إرشادات",
  },
  "Your Roadmap to Getting Started": {
    en: "Your Roadmap to Getting Started",
    ar: "خارطة طريقك للبدء",
  },
  "Step 1: Generate an Idea": {
    en: "Step 1: Generate an Idea",
    ar: "الخطوة 1: ابتكر فكرة",
  },
  "Click the": {
    en: "Click the",
    ar: "اضغط على",
  },
  "button in either :": {
    en: "button in either :",
    ar: "زر إما في :",
  },
  "The My Dashboard": {
    en: "The My Dashboard",
    ar: "لوحة التحكم الخاصة بي",
  },
  "The My Ideas section": {
    en: "The My Ideas section",
    ar: "قسم أفكاري",
  },
  "This will open a form that needs to be filled out.": {
    en: "This will open a form that needs to be filled out.",
    ar: "سيتم فتح نموذج يتوجب ملؤه.",
  },
  "Step 2: Fill Out the Form": {
    en: "Step 2: Fill Out the Form",
    ar: "الخطوة 2: تعبئة النموذج",
  },
  "Complete the form with the required details.": {
    en: "Complete the form with the required details.",
    ar: "قم بتعبئة النموذج بالمعلومات المطلوبة.",
  },
  "After submitting": {
    en: "After submitting",
    ar: "بعد الإرسال",
  },
  "a Report Scorecard": {
    en: "a Report Scorecard",
    ar: "بطاقة تقرير الأداء",
  },
  "will be generated and displayed.": {
    en: "will be generated and displayed.",
    ar: "سيتم إنشاؤه وعرضه.",
  },
  "On the scorecard page, you’ll find a button labelled": {
    en: "On the scorecard page, you’ll find a button labelled",
    ar: "على صفحة بطاقة الأداء، ستجد زرًا يحمل التسمية",
  },
  "Report Template": {
    en: "Report Template",
    ar: "نموذج التقرير",
  },
  "You can choose to:": {
    en: "You can choose to:",
    ar: "يمكنك الاختيار:",
  },
  "Proceed immediately to the Report Template page": {
    en: "Proceed immediately to the Report Template page",
    ar: "يرجى الانتقال فوراً إلى صفحة قالب التقرير",
  },
  "by clicking the button. On this page, you can submit your idea for approval using the":
    {
      en: "by clicking the button. On this page, you can submit your idea for approval using the",
      ar: "من خلال النقر على الزر. في هذه الصفحة، يمكنك تقديم فكرتك للموافقة باستخدام الـ",
    },
  "Submit Your Idea": {
    en: "Submit Your Idea",
    ar: "قدّم فكرتك",
  },
  "button.": {
    en: "button.",
    ar: "زر.",
  },
  "Exit the screen": {
    en: "Exit the screen",
    ar: "الخروج من الشاشة",
  },
  "by navigating to another section of the app if you need more time to think.":
    {
      en: "by navigating to another section of the app if you need more time to think.",
      ar: "بإمكانك الانتقال إلى قسم آخر من التطبيق إذا كنت بحاجة إلى المزيد من الوقت للتفكير.",
    },
  "Step 3: Return to Your Idea Later": {
    en: "Step 3: Return to Your Idea Later",
    ar: "الخطوة 3: العود إلى فكرتك لاحقًا",
  },
  "If you decide not to submit your idea immediately, don’t worry!": {
    en: "If you decide not to submit your idea immediately, don’t worry!",
    ar: "إذا قررت عدم تقديم فكرتك فورًا، لا تقلق!",
  },
  "You can find your idea in the": {
    en: "You can find your idea in the",
    ar: "يمكنك العثور على فكرتك في",
  },
  "section.": {
    en: "section.",
    ar: "الجزء.",
  },
  "The Scorecard Page": {
    en: "The Scorecard Page",
    ar: "صفحة بطاقة الأداء",
  },
  "The Report Template Page": {
    en: "The Report Template Page",
    ar: "صفحة نموذج التقرير",
  },
  "where you’ll have the option to submit your idea for approval.": {
    en: "where you’ll have the option to submit your idea for approval.",
    ar: "حيث سيكون لديك الخيار لتقديم فكرتك للموافقة عليها.",
  },
  "Step 4: Submit Your Idea": {
    en: "Step 4: Submit Your Idea",
    ar: "الخطوة 4: إرسال فكرتك",
  },
  "the Report Template Page": {
    en: "the Report Template Page",
    ar: "صفحة قالب التقرير",
  },
  On: {
    en: "On",
    ar: "تشغيل",
  },
  "use the": {
    en: "use the",
    ar: "استخدام الـ",
  },
  "button to submit your idea for approval.": {
    en: "button to submit your idea for approval.",
    ar: "زر لتقديم فكرتك للموافقة عليها.",
  },
  "You’ll then be prompted to:": {
    en: "You’ll then be prompted to:",
    ar: "سيتم توجيهك للقيام بما يلي:",
  },
  "Create a team": {
    en: "Create a team",
    ar: "إنشاء فريق",
  },
  "by adding colleagues.": {
    en: "by adding colleagues.",
    ar: "من خلال إضافة الزملاء.",
  },
  "Select an existing team": {
    en: "Select an existing team",
    ar: "اختر فريقاً موجوداً",
  },
  "if one is already available.": {
    en: "if one is already available.",
    ar: "إذا كان متاحًا بالفعل.",
  },
  "Note :": {
    en: "Note :",
    ar: "ملاحظة:",
  },
  "If no colleagues are added to your organization yet, you can create a team with just yourself and proceed.":
    {
      en: "If no colleagues are added to your organization yet, you can create a team with just yourself and proceed.",
      ar: "إذا لم تتم إضافة زملاء إلى شركتك بعد، يمكنك إنشاء فريق يضم نفسك فقط ومتابعة الإجراءات.",
    },
  "Step 5: Project Approval": {
    en: "Step 5: Project Approval",
    ar: "الخطوة الخامسة: اعتماد المشروع",
  },
  "Once submitted, your project will appear in the": {
    en: "Once submitted, your project will appear in the",
    ar: "بمجرد الإرسال، سيظهر مشروعك في لوحة المعلومات الخاصة بـ",
  },
  "category under the": {
    en: "category under the",
    ar: "فئة تحت الـ",
  },
  "tab.": {
    en: "tab.",
    ar: "زر.",
  },
  "While waiting for approval, click": {
    en: "While waiting for approval, click",
    ar: "بينما تنتظر الموافقة، اضغط",
  },
  "the eye icon": {
    en: "the eye icon",
    ar: "أيقونة العين",
  },
  "to view project details.": {
    en: "to view project details.",
    ar: "لعرض تفاصيل المشروع.",
  },
  "If your project is": {
    en: "If your project is",
    ar: "إذا كان مشروعك",
  },
  "you can find it in the": {
    en: "you can find it in the",
    ar: "تستطيع العثور عليه في",
  },
  "category in the": {
    en: "category in the",
    ar: "الفئة في الـ",
  },
  "Step 6: Start Once Approved": {
    en: "Step 6: Start Once Approved",
    ar: "الخطوة 6: ابدأ حالما يتم الحصول على الموافقة",
  },
  "Approved projects will move to the": {
    en: "Approved projects will move to the",
    ar: "سيتم نقل المشاريع المعتمدة إلى",
  },
  "Tasks will be assigned to team members.": {
    en: "Tasks will be assigned to team members.",
    ar: "سيتم تعيين المهام لأعضاء الفريق.",
  },
  "Check the": {
    en: "Check the",
    ar: "تحقق من الـ",
  },
  "section under the": {
    en: "section under the",
    ar: "الجزء تحت الـ",
  },
  "category for tasks assigned to you.": {
    en: "category for tasks assigned to you.",
    ar: "فئة المهام الموكلة إليك.",
  },
  "Step 7: Project Status Tracking": {
    en: "Step 7: Project Status Tracking",
    ar: "الخطوة 7: تتبّع حالة المشروع",
  },
  "In Progress:": {
    en: "In Progress:",
    ar: "قيد التنفيذ:",
  },
  "Once the first task for your project is completed, the project moves to the":
    {
      en: "Once the first task for your project is completed, the project moves to the",
      ar: "بمجرد الانتهاء من المهمة الأولى لمشروعك، ينتقل المشروع إلى المرحلة التالية.",
    },
  "When all assigned tasks are completed, the project moves to the": {
    en: "When all assigned tasks are completed, the project moves to the",
    ar: "عند الانتهاء من جميع المهام المسندة، ينتقل المشروع إلى مرحلة",
  },
  "7 days post-completion, the project automatically moves to the": {
    en: "7 days post-completion, the project automatically moves to the",
    ar: "بعد مرور 7 أيام على إكمال المشروع، سيتم نقله تلقائيًا إلى",
  },
  "Completed:": {
    en: "Completed:",
    ar: "الانتهاء:",
  },
  "Archived:": {
    en: "Archived:",
    ar: "مؤرشف:",
  },
  "category.": {
    en: "category.",
    ar: "الفئة",
  },
  "Feel free to refer to this guide anytime! Explore, experiment, and reach out if you need assistance.":
    {
      en: "Feel free to refer to this guide anytime! Explore, experiment, and reach out if you need assistance.",
      ar: "يمكنك الرجوع إلى هذا الدليل في أي وقت! استكشف، جرّب، وتواصل معنا إذا كنت بحاجة إلى مساعدة.",
    },
  "Let’s turn your ideas into action!": {
    en: "Let’s turn your ideas into action!",
    ar: "لنحوّل أفكارك إلى أفعال!",
  },
  "Scorecard updated successfully!": {
    en: "Scorecard updated successfully!",
    ar: "تم تحديث بطاقة الأداء بنجاح!",
  },
  "Failed to update scorecard!": {
    en: "Failed to update scorecard!",
    ar: "فشل في تحديث بطاقة الأداء!",
  },
  "New Team Created Successfully!": {
    en: "New Team Created Successfully!",
    ar: "تم إنشاء الفريق بنجاح!",
  },
  "Please wait while project is being converted!": {
    en: "Please wait while project is being converted!",
    ar: "يرجى الانتظار بينما يتم تحويل المشروع!",
  },
  "Successfully added the team for this project!": {
    en: "Successfully added the team for this project!",
    ar: "تمت إضافة الفريق إلى هذا المشروع بنجاح!",
  },
  "Please wait while project is converted!": {
    en: "Please wait while project is converted!",
    ar: "يرجى الانتظار بينما يتم تحويل المشروع!",
  },
  "Thank you for your feedback!": {
    en: "Thank you for your feedback!",
    ar: "شكرًا لكم على ملاحظاتكم!",
  },
  "Your idea added to Dashboard!": {
    en: "Your idea added to Dashboard!",
    ar: "تمت إضافة فكرتك إلى لوحة التحكم!",
  },
  "Updated Successfully": {
    en: "Updated Successfully",
    ar: "تم التحديث بنجاح",
  },
  "Some Error Occured": {
    en: "Some Error Occured",
    ar: "حدث خطأ ما",
  },
  "For projects completed in under 2 months": {
    en: "For projects completed in under 2 months",
    ar: "للمشاريع المكتملة في أقل من شهرين",
  },
  "Medium Term": {
    en: "Medium Term",
    ar: "الأجل المتوسط",
  },
  "For projects taking 2-12 months": {
    en: "For projects taking 2-12 months",
    ar: "للمشاريع التي تستغرق من 2 إلى 12 شهرًا",
  },
  "Extended Initiatives": {
    en: "Extended Initiatives",
    ar: "المبادرات الممتدة",
  },
  "For projects requiring more than 1 year to complete": {
    en: "For projects requiring more than 1 year to complete",
    ar: "للمشروعات التي تتطلب أكثر من سنة لإتمامها",
  },
  "Problem Statement": {
    en: "Problem Statement",
    ar: "عنوان المشكلة",
  },
  "Idea Impact": {
    en: "Idea Impact",
    ar: "أثر الفكرة",
  },
  "Waiting Room": {
    en: "Waiting Room",
    ar: "غرفة الانتظار",
  },
  Cancel: {
    en: "Cancel",
    ar: "إلغاء",
  },
  "Add Manual Subtask": {
    en: "Add Manual Subtask",
    ar: "إضافة مهمة فرعية يدوية",
  },
  Save: {
    en: "Save",
    ar: "حفظ",
  },
  "Explain your idea": {
    en: "Explain your idea",
    ar: "أرجو منك توضيح فكرتك",
  },
  "Can you describe your idea, focusing on what it is and the specific impact you envision it having?":
    {
      en: "Can you describe your idea, focusing on what it is and the specific impact you envision it having?",
      ar: "يرجى وصف فكرتك، مع التركيز على ماهيتها والتأثير المحدد الذي تتوقع أن تحققه.",
    },
  "The Problem statement includes what is being affected": {
    en: "The Problem statement includes what is being affected",
    ar: "بيان المشكلة يشمل ما يتأثر به الوضع الحالي",
  },
  "In a few sentence, Please Describe what the project is about and how will it will help improve The organisation. Be specific, focus on the What not the Why.":
    {
      en: "In a few sentence, Please Describe what the project is about and how will it will help improve The organisation. Be specific, focus on the What not the Why.",
      ar: "هذا المشروع يركز على تطوير منصة SaaS لتحسين كفاءة العمليات الداخلية للمنظمة. من خلال تبني نظام داشبورد متكامل وواجهة مستخدم محدثة، يمكن للمستخدمين الوصول بسهولة إلى إعدادات الحساب، وتخصيص الأذونات، وإدارة المشاريع والبرامج الاستراتيجية بكفاءة. يوفر المشروع أدوات إشعار وتعليمات موجهة للمستخدمين، ما يسهم في تسهيل عمليات التوجيه وتأمين التدفق السلس للعمل.",
    },
  Where: {
    en: "Where",
    ar: "أين",
  },
  "The Problem statement includes where the problem is occuring (space, location or the point of cause in the process)":
    {
      en: "The Problem statement includes where the problem is occuring (space, location or the point of cause in the process)",
      ar: "يتضمن بيان المشكلة تحديد مكان حدوث المشكلة (المكان، الموقع أو نقطة السبب في العملية)",
    },
  When: {
    en: "When",
    ar: "عندما",
  },
  "Includes a pattern of occurence over time. Includes the specific dates and times. States when the problem was discovered.":
    {
      en: "Includes a pattern of occurence over time. Includes the specific dates and times. States when the problem was discovered.",
      ar: "يتضمن نمط وقوع على مر الزمن. يشمل التواريخ والأوقات المحددة. يوضح متى تم اكتشاف المشكلة.",
    },
  Who: {
    en: "Who",
    ar: "من",
  },
  "Includes who is being affected by this problem, Use title or responsibilities (not individual names)":
    {
      en: "Includes who is being affected by this problem, Use title or responsibilities (not individual names)",
      ar: "يتضمن من يتأثر بهذه المشكلة، استخدم الألقاب أو المسؤوليات (وليس الأسماء الفردية).",
    },
  Consequences: {
    en: "Consequences",
    ar: "عواقب",
  },
  "States actual or potential consequences if the problem is not fixed (Impact on quality, cost, staff, patients, etc)":
    {
      en: "States actual or potential consequences if the problem is not fixed (Impact on quality, cost, staff, patients, etc)",
      ar: "يبين الآثار الفعلية أو المحتملة إذا لم يتم حل المشكلة (التأثير على الجودة، التكلفة، الموظفين، المرضى، إلخ).",
    },
  Frequency: {
    en: "Frequency",
    ar: "التكرار",
  },
  "How Often or How many quantifies the actual number of occurences": {
    en: "How Often or How many quantifies the actual number of occurences",
    ar: "كم مرة أو كم هو العدد الفعلي لحدوث ذلك؟",
  },
  "Proposed Solution": {
    en: "Proposed Solution",
    ar: "الحل المقترح",
  },
  "Explain your proposed solution here...": {
    en: "Explain your proposed solution here...",
    ar: "اقترح حلك هنا...",
  },
  Hide: {
    en: "Hide",
    ar: "إخفاء",
  },
  "Kind reminder: We count an attempt when you click this button, even if the rest of the form isn't fully completed and submitted. This helps us maintain a balanced and effective usage of our AI features. Thank you!":
    {
      en: "Kind reminder: We count an attempt when you click this button, even if the rest of the form isn't fully completed and submitted. This helps us maintain a balanced and effective usage of our AI features. Thank you!",
      ar: "تذكير لطيف: نعتبر الضغط على هذا الزر محاولة، حتى إذا لم يتم استكمال وإرسال النموذج بالكامل. يساعدنا ذلك في الحفاظ على استخدام متوازن وفعال لميزات الذكاء الاصطناعي الخاصة بنا. شكرًا لكم!",
    },
  "Please Wait": {
    en: "Please Wait",
    ar: "يرجى الانتظار",
  },
  "My Problem Statement looks correct": {
    en: "My Problem Statement looks correct",
    ar: "تبدو صياغة مشكلة العمل الخاصة بي صحيحة",
  },
  Next: {
    en: "Next",
    ar: "التالي",
  },
  "Choose a Strategic Theme": {
    en: "Choose a Strategic Theme",
    ar: "اختر موضوعًا استراتيجيًا",
  },
  "Select the strategic theme that best aligns with the goals and impact of your project or idea. Choosing the right theme ensures that your work drives meaningful progress toward our organization’s overall vision and priorities.":
    {
      en: "Select the strategic theme that best aligns with the goals and impact of your project or idea. Choosing the right theme ensures that your work drives meaningful progress toward our organization’s overall vision and priorities.",
      ar: "اختر الإطار الاستراتيجي الذي يتوافق بشكل أفضل مع أهداف وتأثير مشروعك أو فكرتك. يساهم اختيار الإطار المناسب في دفع التقدم الحيوي نحو الرؤية والأولويات العامة لمؤسستنا.",
    },
  "Select the strategic theme that best aligns with the goals and impact of your project or idea. Choosing the right theme ensures that your work drives meaningful progress toward our organization's overall vision and priorities.":
    {
      en: "Select the strategic theme that best aligns with the goals and impact of your project or idea. Choosing the right theme ensures that your work drives meaningful progress toward our organization's overall vision and priorities.",
      ar: "اختر الموضوع الاستراتيجي الذي يتماشى بشكل أفضل مع أهداف وتأثير مشروعك أو فكرتك. اختيار الموضوع المناسب يضمن أن عملك يسهم في تحقيق تقدم ملموس نحو رؤية وأولويات منظمتنا الشاملة.",
    },
  "Please Select Metrics:": {
    en: "Please Select Metrics:",
    ar: "الرجاء اختيار المقاييس:",
  },
  "Select Metric": {
    en: "Select Metric",
    ar: "اختيار المقياس",
  },
  "Is your project or idea driven by any statutory or mandatory requirements?":
    {
      en: "Is your project or idea driven by any statutory or mandatory requirements?",
      ar: "هل مشروعك أو فكرتك مدفوعة بأي اشتراطات قانونية أو إلزامية؟",
    },
  "Impact Assessment": {
    en: "Impact Assessment",
    ar: "تقييم الأثر",
  },
  "Who or What Does Your Idea Affect?": {
    en: "Who or What Does Your Idea Affect?",
    ar: "من يؤثر عليه فكرتك؟ أو ما الذي تؤثر عليه فكرتك؟",
  },
  "Will the implementation of this idea change workflows, workload, job satisfaction, or staff training requirements?":
    {
      en: "Will the implementation of this idea change workflows, workload, job satisfaction, or staff training requirements?",
      ar: "هل سيؤدي تنفيذ هذه الفكرة إلى تغيير في سير العمل، عبء العمل، الرضا الوظيفي، أو متطلبات تدريب الموظفين؟",
    },
  "Is there a direct effect on patient care, experience, outcomes, or satisfaction levels?":
    {
      en: "Is there a direct effect on patient care, experience, outcomes, or satisfaction levels?",
      ar: "هل هناك تأثير مباشر على رعاية المرضى، تجربتهم، نتائجهم، أو مستويات رضاهم؟",
    },
  "Does this idea involve the usage of physical assets, financial investment, or changes to current resource allocation?":
    {
      en: "Does this idea involve the usage of physical assets, financial investment, or changes to current resource allocation?",
      ar: "هل تتضمن هذه الفكرة استخدام الأصول المادية، أو الاستثمار المالي، أو تغييرات في تخصيص الموارد الحالية؟",
    },
  "Enter Total no. Users affected": {
    en: "Enter Total no. Users affected",
    ar: "أدخل إجمالي عدد المستخدمين المتأثرين",
  },
  "How many no. of users are affected by this idea?": {
    en: "How many no. of users are affected by this idea?",
    ar: "ما هو عدد المستخدمين المتأثرين بهذه الفكرة؟",
  },
  Staff: {
    en: "Staff",
    ar: "الموظفون",
  },
  Patients: {
    en: "Patients",
    ar: "المرضى",
  },
  "To help us understand the financial impact of your idea, please consider the following key areas. Your estimates will guide our assessment ( Atleast one is mandatory):":
    {
      en: "To help us understand the financial impact of your idea, please consider the following key areas. Your estimates will guide our assessment ( Atleast one is mandatory):",
      ar: "لمساعدتنا في فهم الأثر المالي لفكرتك، يُرجى النظر في المجالات الرئيسية التالية. ستوجّه تقديراتك تقييمنا (يجب تزويدنا بواحدة على الأقل):",
    },
  "Budgeting Process": {
    en: "Budgeting Process",
    ar: "عملية إعداد الميزانية",
  },
  "Select Cost Type": {
    en: "Select Cost Type",
    ar: "اختر نوع التكلفة",
  },
  "Financial Assessment:": {
    en: "Financial Assessment:",
    ar: "التقييم المالي:",
  },
  Resources: {
    en: "Resources",
    ar: "الموارد",
  },
  "Select Categories": {
    en: "Select Categories",
    ar: "اختر الفئات",
  },
  "Review and Finalize": {
    en: "Review and Finalize",
    ar: "مراجعة وتأكيد",
  },
  "Non Recurring Cost": {
    en: "Non Recurring Cost",
    ar: "التكلفة غير المتكررة",
  },
  "This is a one-time or infrequent expense that a business incurs and is not expected to pay again in the future.":
    {
      en: "This is a one-time or infrequent expense that a business incurs and is not expected to pay again in the future.",
      ar: "هذه نفقات تحدث لمرة واحدة أو نادرة تواجهها الشركات وليس من المتوقع دفعها مرة أخرى في المستقبل.",
    },
  "Select Category": {
    en: "Select Category",
    ar: "اختر الفئة",
  },
  "Select a category": {
    en: "Select a category",
    ar: "اختر فئة",
  },
  "Sub-Categories": {
    en: "Sub-Categories",
    ar: "الفئات الفرعية",
  },
  "Select a subcategory": {
    en: "Select a subcategory",
    ar: "اختر فئة فرعية",
  },
  Amount: {
    en: "Amount",
    ar: "المبلغ",
  },
  "Enter amount": {
    en: "Enter amount",
    ar: "أدخل المبلغ",
  },
  Quantity: {
    en: "Quantity",
    ar: "الكمية",
  },
  "Enter quantity": {
    en: "Enter quantity",
    ar: "اختر الكمية",
  },
  Subcategory: {
    en: "Subcategory",
    ar: "الفئة الفرعية",
  },
  "Total Cost": {
    en: "Total Cost",
    ar: "التكلفة الإجمالية",
  },
  OK: {
    en: "OK",
    ar: "حسنًا",
  },
  "Grand Total": {
    en: "Grand Total",
    ar: "الإجمالي الكلي",
  },
  "Recurring Cost": {
    en: "Recurring Cost",
    ar: "التكلفة المتكررة",
  },
  "Non-Recurring": {
    en: "Non-Recurring",
    ar: "غير متكرر",
  },
  "Suggested Related Cost:": {
    en: "Suggested Related Cost:",
    ar: "التكلفة المقترحة ذات الصلة:",
  },
  "Add Cost": {
    en: "Add Cost",
    ar: "إضافة تكلفة",
  },
  "Would you like to add Non Recurring Costs?": {
    en: "Would you like to add Non Recurring Costs?",
    ar: "هل ترغب في إضافة التكاليف غير المتكررة؟",
  },
  "This is a cost that occurs on a regular basis and is necessary for the ongoing operation of a business":
    {
      en: "This is a cost that occurs on a regular basis and is necessary for the ongoing operation of a business",
      ar: "هذا تكلفة منتظمة ضرورية لاستمرارية تشغيل الأعمال.",
    },
  "Would you like to add Recurring Cost?": {
    en: "Would you like to add Recurring Cost?",
    ar: "هل ترغب في إضافة تكلفة متكررة؟",
  },
  Cost: {
    en: "Cost",
    ar: "التكلفة",
  },
  "Cost Overview": {
    en: "Cost Overview",
    ar: "نظرة عامة على التكلفة",
  },
  Subtotal: {
    en: "Subtotal",
    ar: "الإجمالي الفرعي",
  },
  "Review your selected costs and quantities. If any typical costs are missing, Please Update that, you will not be able to change it again.":
    {
      en: "Review your selected costs and quantities. If any typical costs are missing, Please Update that, you will not be able to change it again.",
      ar: "يرجى مراجعة التكاليف والكميات التي اخترتها. في حال كانت هناك أي تكاليف نموذجية مفقودة، يرجى تحديثها. لن تتمكن من تعديلها مرة أخرى.",
    },
  "Benefits Process": {
    en: "Benefits Process",
    ar: "عملية المزايا",
  },
  "Select Benefit Type": {
    en: "Select Benefit Type",
    ar: "اختر نوع الفائدة",
  },
  "Operational Enhancements": {
    en: "Operational Enhancements",
    ar: "تحسينات تشغيلية",
  },
  "Financial Gains": {
    en: "Financial Gains",
    ar: "الأرباح المالية",
  },
  "The excess of revenues over outlays in a given period of time. It can also refer to the receipt or expectation of receiving anything of value.":
    {
      en: "The excess of revenues over outlays in a given period of time. It can also refer to the receipt or expectation of receiving anything of value.",
      ar: "الفائض في الإيرادات مقارنة بالنفقات خلال فترة زمنية محددة. ويمكن أن يشير أيضًا إلى تلقي أو توقع تلقي أي شيء ذو قيمة.",
    },
  "The process of actively improving and optimizing the day-to-day operations of a business or organization":
    {
      en: "The process of actively improving and optimizing the day-to-day operations of a business or organization",
      ar: "عملية تحسين وتعزيز العمليات اليومية للشركة أو المؤسسة بشكل فعال",
    },
  "Extra Benefits": {
    en: "Extra Benefits",
    ar: "المزايا الإضافية",
  },
  "Benefit Amount": {
    en: "Benefit Amount",
    ar: "مبلغ الاستحقاق",
  },
  "Suggested Related Benefits:": {
    en: "Suggested Related Benefits:",
    ar: "الفوائد الموصى بها ذات الصلة:",
  },
  "Factor To Determine Benefit:": {
    en: "Factor To Determine Benefit:",
    ar: "عامل تحديد الفائدة:",
  },
  "Time Analysis": {
    en: "Time Analysis",
    ar: "تحليل الوقت",
  },
  "Cost Analysis": {
    en: "Cost Analysis",
    ar: "تحليل التكاليف",
  },
  "Efficiency Analysis": {
    en: "Efficiency Analysis",
    ar: "تحليل الكفاءة",
  },
  "Time Savings": {
    en: "Time Savings",
    ar: "توفير الوقت",
  },
  "Cost Benefit Analysis": {
    en: "Cost Benefit Analysis",
    ar: "تحليل التكلفة والفائدة",
  },
  "What percentage of our current expenses could your idea reduce? For example, if your idea could cut a specific ₤10,000 annual expense by 10%, we'd save ₤1,000 per year.":
    {
      en: "What percentage of our current expenses could your idea reduce? For example, if your idea could cut a specific ₤10,000 annual expense by 10%, we'd save ₤1,000 per year.",
      ar: "ما هي النسبة المئوية التي يمكن أن تقلل بها فكرتك من نفقاتنا الحالية؟ على سبيل المثال، إذا كان بإمكان فكرتك تقليص مصروف سنوي محدد بقيمة 10,000 جنيه بنسبة 10٪، فإننا سنوفر 1,000 جنيه سنويًا.",
    },
  "Efficiency Gains": {
    en: "Efficiency Gains",
    ar: "تحقيق مكاسب الكفاءة",
  },
  "Estimate the potential increase in output or revenue. For example, if your idea could boost product output by 5%, and our annual revenue from that product is ₤100,000, we could see an additional ₤5,000 in revenue.":
    {
      en: "Estimate the potential increase in output or revenue. For example, if your idea could boost product output by 5%, and our annual revenue from that product is ₤100,000, we could see an additional ₤5,000 in revenue.",
      ar: "تقدير الزيادة المحتملة في الإنتاج أو الإيرادات. على سبيل المثال، إذا كانت فكرتكم يمكن أن تعزز إنتاج المنتج بنسبة 5%، وكانت إيراداتنا السنوية من ذلك المنتج ₤100,000، فسوف نشهد زيادة قدرها ₤5,000 في الإيرادات الإضافية.",
    },
  Tag: {
    en: "Tag",
    ar: "ضع علامة",
  },
  Time: {
    en: "Time",
    ar: "الوقت",
  },
  Efficiency: {
    en: "Efficiency",
    ar: "الكفاءة",
  },
  "Would you like to add Operations Enhancements?": {
    en: "Would you like to add Operations Enhancements?",
    ar: "هل تود إضافة تحسينات على العمليات؟",
  },
  "Would you like to add Financial Gains?": {
    en: "Would you like to add Financial Gains?",
    ar: "هل تود إضافة المكاسب المالية؟",
  },
  "Review your selected benefits. If any typical benefits are missing, they will be suggested.":
    {
      en: "Review your selected benefits. If any typical benefits are missing, they will be suggested.",
      ar: "راجع المزايا المختارة لديك. في حال فقدان أي من المزايا المعتادة، سيتم اقتراحها.",
    },
  "Let's Wait": {
    en: "Let's Wait",
    ar: "لننتظر",
  },
  "4 / 4": {
    en: "4 / 4",
    ar: "٤/٤",
  },
  "Read Ideas": {
    en: "Read Ideas",
    ar: "قراءة الأفكار",
  },
  "While Bots are Working you can explore:": {
    en: "While Bots are Working you can explore:",
    ar: "بينما تعمل الروبوتات، يمكنك الاستكشاف:",
  },
  Videos: {
    en: "Videos",
    ar: "الفيديوهات",
  },
  "Play Game": {
    en: "Play Game",
    ar: "العب اللعبة",
  },
  "Below Are Some Ideas You can read:": {
    en: "Below Are Some Ideas You can read:",
    ar: "فيما يلي بعض الأفكار التي يُمكنك قراءتها:",
  },
  "Read Other Articles": {
    en: "Read Other Articles",
    ar: "قراءة مقالات أخرى",
  },
  "Read More": {
    en: "Read More",
    ar: "اقرأ المزيد",
  },
  "Below Are Some Videos You can watch:": {
    en: "Below Are Some Videos You can watch:",
    ar: "فيما يلي بعض الفيديوهات التي يمكنك مشاهدتها:",
  },
  "50:50 Lifeline": {
    en: "50:50 Lifeline",
    ar: "شريان الحياة 50:50",
  },
  "Congrats! You Win": {
    en: "Congrats! You Win",
    ar: "تهانينا! لقد فزت",
  },
  "Sorry! You Loose": {
    en: "Sorry! You Loose",
    ar: "عذرًا! لقد فشلت.",
  },
  "Target Score:": {
    en: "Target Score:",
    ar: "النتيجة المستهدفة:",
  },
  "Your Score:": {
    en: "Your Score:",
    ar: "نتيجتك:",
  },
  "Out of:": {
    en: "Out of:",
    ar: "خارج من",
  },
  "Restart Quiz": {
    en: "Restart Quiz",
    ar: "إعادة تشغيل الاختبار",
  },
  "Correct Answer:": {
    en: "Correct Answer:",
    ar: "إجابة صحيحة:",
  },
  Question: {
    en: "Question",
    ar: "سؤال",
  },
  "Score:": {
    en: "Score",
    ar: "المجموع",
  },
  "Game Rules": {
    en: "Game Rules",
    ar: "قواعد اللعبة",
  },
  "Start Quiz": {
    en: "Start Quiz",
    ar: "ابدأ الاختبار",
  },
  "You will be asked MCQ questions. You have to select the correct option and beat the average score to win.":
    {
      en: "You will be asked MCQ questions. You have to select the correct option and beat the average score to win.",
      ar: "سيتم طرح أسئلة اختيار من متعدد عليك. عليك اختيار الخيار الصحيح وتجاوز متوسط النقاط للفوز.",
    },
  "Explore Others": {
    en: "Explore Others",
    ar: "استكشاف الخيارات الأخرى",
  },
  Overview: {
    en: "Overview",
    ar: "نظرة عامة",
  },
  "Total Benefits": {
    en: "Total Benefits",
    ar: "إجمالي الفوائد",
  },
  "Quick Feedback Survey": {
    en: "Quick Feedback Survey",
    ar: "استطلاع سريع للتغذية الراجعة",
  },
  "Thank you for using our system. Your feedback is valuable to us. Please take a moment to answer these brief questions":
    {
      en: "Thank you for using our system. Your feedback is valuable to us. Please take a moment to answer these brief questions",
      ar: "نشكركم على استخدام نظامنا. تغذية رأيكم تهمنا. نرجو منكم تخصيص بعض الوقت للإجابة على هذه الأسئلة القصيرة.",
    },
  "Overall Experience": {
    en: "Overall Experience",
    ar: "التجربة الشاملة",
  },
  Excellent: {
    en: "Excellent",
    ar: "ممتاز",
  },
  Good: {
    en: "Good",
    ar: "جيد",
  },
  Average: {
    en: "Average",
    ar: "متوسط",
  },
  "Below Average": {
    en: "Below Average",
    ar: "أقل من المتوسط",
  },
  Poor: {
    en: "Poor",
    ar: "ضعيف",
  },
  "Ease of Use": {
    en: "Ease of Use",
    ar: "سهولة الاستخدام",
  },
  "Did our system help you refine your idea effectively?": {
    en: "Did our system help you refine your idea effectively?",
    ar: "هل ساعدك نظامنا في تحسين فكرتك بفعالية؟",
  },
  "Very Easy": {
    en: "Very Easy",
    ar: "بسيط جداً",
  },
  Easy: {
    en: "Easy",
    ar: "سهل",
  },
  Neutral: {
    en: "Neutral",
    ar: "محايد",
  },
  Difficult: {
    en: "Difficult",
    ar: "صعب",
  },
  "Very Difficult": {
    en: "Very Difficult",
    ar: "صعب جدًا",
  },
  Helpfulness: {
    en: "Helpfulness",
    ar: "المساعدة",
  },
  "Yes, Significantly": {
    en: "Yes, Significantly",
    ar: "نعم، بشكل كبير",
  },
  "Yes, Somewhat": {
    en: "Yes, Somewhat",
    ar: "نعم، إلى حد ما.",
  },
  "No, Not really": {
    en: "No, Not really",
    ar: "عذرًا، لا يمكنني إتمام هذا الطلب.",
  },
  "No, Not at all": {
    en: "No, Not at all",
    ar: "كلا، على الإطلاق",
  },
  "What improvements or additional features would you suggest for our system?":
    {
      en: "What improvements or additional features would you suggest for our system?",
      ar: "ما التحسينات أو الميزات الإضافية التي تود اقتراحها لنظامنا؟",
    },
  "Write your suggested features here...": {
    en: "Write your suggested features here...",
    ar: "اكتب ميزاتك المقترحة هنا...",
  },
  "Thank you for sharing your idea!": {
    en: "Thank you for sharing your idea!",
    ar: "شكرًا لك على مشاركتك الفكرة!",
  },
  Dear: {
    en: "Dear",
    ar: "عزيزي/عزيزتي",
  },
  "We are deeply grateful to you for sharing your idea with us. As a patient, your insights and experiences are incredibly valuable in guiding our continuous efforts to innovate and improve.":
    {
      en: "We are deeply grateful to you for sharing your idea with us. As a patient, your insights and experiences are incredibly valuable in guiding our continuous efforts to innovate and improve.",
      ar: "نحن ممتنون للغاية لمشاركتك فكرتك معنا. كونك مستخدمًا، تُعد رؤاك وتجاربك ذات قيمة كبيرة في توجيه جهودنا المستمرة للابتكار والتحسين.",
    },
  "Your suggestion is currently undergoing a detailed review by our team. We are committed to evaluating its potential to enhance our services and align with our strategic goals. Our dedication to the Kaizen philosophy of continuous improvement is strengthened by contributions like yours.":
    {
      en: "Your suggestion is currently undergoing a detailed review by our team. We are committed to evaluating its potential to enhance our services and align with our strategic goals. Our dedication to the Kaizen philosophy of continuous improvement is strengthened by contributions like yours.",
      ar: "اقتراحك يخضع حاليًا لمراجعة دقيقة من قبل فريقنا. نحن ملتزمون بتقييم إمكانيته لتعزيز خدماتنا وتوافقه مع أهدافنا الاستراتيجية. تساهم اقتراحاتك في تعزيز التزامنا بفلسفة الكايزن للتحسين المستمر.",
    },
  "After completing our assessment, we plan to reach out to you for further discussion. Your involvement is crucial, not only in the ideation phase but also in realizing the potential of your idea. We believe in the power of collaboration to turn promising concepts into meaningful improvements.":
    {
      en: "After completing our assessment, we plan to reach out to you for further discussion. Your involvement is crucial, not only in the ideation phase but also in realizing the potential of your idea. We believe in the power of collaboration to turn promising concepts into meaningful improvements.",
      ar: "بعد الانتهاء من تقييمنا، نعتزم التواصل معك لمناقشة الأمور بشكل أعمق. تعتبر مشاركتك أساسية، ليس فقط في مرحلة الإبداع، ولكن أيضًا في تحقيق الإمكانات الكاملة لفكرتك. نحن نؤمن بقوة التعاون في تحويل المفاهيم الواعدة إلى تحسينات ذات قيمة.",
    },
  "Your input is more than just a suggestion; it represents a significant step towards positive change and innovation in patient care. We encourage all our patients to share their ideas, as each one contributes to our collective journey towards excellence in healthcare.":
    {
      en: "Your input is more than just a suggestion; it represents a significant step towards positive change and innovation in patient care. We encourage all our patients to share their ideas, as each one contributes to our collective journey towards excellence in healthcare.",
      ar: "مدخلاتك ليست مجرد اقتراح؛ إنها تمثل خطوة هامة نحو التغيير الإيجابي والابتكار في رعاية المرضى. نحن نشجع جميع مرضانا على تقديم أفكارهم، حيث أن كل فكرة تسهم في رحلتنا الجماعية نحو التميز في الرعاية الصحية.",
    },
  "Thank you once again for your invaluable contribution. It is the perspectives and innovative thinking of patients like you that drive us forward, enabling us to deliver better care and services.":
    {
      en: "Thank you once again for your invaluable contribution. It is the perspectives and innovative thinking of patients like you that drive us forward, enabling us to deliver better care and services.",
      ar: "شكراً مرة أخرى لمساهمتك القيمة. إن الآراء والتفكير المبتكر الذي تقدمه المرضى، أمثالك، هو ما يدفعنا للتقدم ويُمكّننا من تقديم رعاية وخدمات أفضل.",
    },
  "Looking forward to making a difference together.": {
    en: "Looking forward to making a difference together.",
    ar: "نتطلع إلى إحداث فرق معاً.",
  },
  "Thank you for your idea submission!": {
    en: "Thank you for your idea submission!",
    ar: "شكرًا على تقديم فكرتك!",
  },
  "As a team committed to innovation and excellence, we want to extend our heartfelt thanks to you for submitting your idea. Every idea is a vital contribution towards our continuous journey of improvement and achieving our strategic goals.":
    {
      en: "As a team committed to innovation and excellence, we want to extend our heartfelt thanks to you for submitting your idea. Every idea is a vital contribution towards our continuous journey of improvement and achieving our strategic goals.",
      ar: "كفريق ملتزم بالابتكار والتميز، نود أن نعرب عن خالص شكرنا لتقديم فكرتك. كل فكرة تعد مساهمة مهمة نحو رحلتنا المستمرة للتحسين وتحقيق أهدافنا الاستراتيجية.",
    },
  "Currently, your idea is undergoing a thorough evaluation process. This is to ensure that we explore its potential to the fullest and align it effectively with our strategic objectives. Embracing the Kaizen philosophy, we are dedicated to continuous improvement and value every suggestion that comes our way.":
    {
      en: "Currently, your idea is undergoing a thorough evaluation process. This is to ensure that we explore its potential to the fullest and align it effectively with our strategic objectives. Embracing the Kaizen philosophy, we are dedicated to continuous improvement and value every suggestion that comes our way.",
      ar: "في الوقت الحالي، تخضع فكرتك لعملية تقييم شاملة. يهدف هذا إلى ضمان استكشاف إمكانياتها بأقصى درجة وتحقيق توافق فعال مع أهدافنا الاستراتيجية. نتبنى فلسفة الكايزن، إذ نلتزم بالتحسين المستمر ونقدر كل اقتراح يصل إلينا.",
    },
  "Once we have fully assessed your idea, we look forward to discussing it further with you. Your involvement doesn't just end with the submission; we believe your insights will be crucial in bringing your idea to life. It's this collaborative effort that transforms good ideas into great innovations.":
    {
      en: "Once we have fully assessed your idea, we look forward to discussing it further with you. Your involvement doesn't just end with the submission; we believe your insights will be crucial in bringing your idea to life. It's this collaborative effort that transforms good ideas into great innovations.",
      ar: "بعد أن نقوم بتقييم فكرتك بشكل كامل، نتطلع إلى مناقشتها معك بمزيد من التفصيل. إن دورك لا ينتهي بمجرد تقديم الفكرة؛ بل نؤمن أن رؤيتك ستكون ذات أهمية كبيرة في تحويل فكرتك إلى واقع. فهذه الجهود التعاونية هي التي تحول الأفكار الجيدة إلى ابتكارات عظيمة.",
    },
  "Your suggestion is more than just an input; it's a stepping stone towards positive change and innovation within our organization. We encourage you, and all our colleagues, to keep sharing your ideas. Each one is a chance to propel us forward, to innovate, and to redefine what's possible.":
    {
      en: "Your suggestion is more than just an input; it's a stepping stone towards positive change and innovation within our organization. We encourage you, and all our colleagues, to keep sharing your ideas. Each one is a chance to propel us forward, to innovate, and to redefine what's possible.",
      ar: "إن اقتراحك يعد أكثر من مجرد مشاركة؛ فهو خطوة نحو التغيير الإيجابي والابتكار داخل منظمتنا. نشجعك أنت وجميع زملائنا على الاستمرار في تقديم أفكاركم. فكل فكرة تعتبر فرصة لتقدمنا، وللابتكار، وإعادة تعريف الممكن.",
    },
  "Thank you once again for your contribution. It's the collective creativity and initiative of individuals like you that drive us forward. Let's continue to work together towards a future of innovation and excellence.":
    {
      en: "Thank you once again for your contribution. It's the collective creativity and initiative of individuals like you that drive us forward. Let's continue to work together towards a future of innovation and excellence.",
      ar: "شكرًا جزيلاً لكم مرة أخرى على مساهمتكم القيمة. إن الإبداع والمبادرة المشتركة للأفراد مثلكم هي التي تقودنا نحو التقدم. دعونا نواصل العمل معًا نحو مستقبل مليء بالابتكار والتميز.",
    },
  "See Report": {
    en: "See Report",
    ar: "عرض التقرير",
  },
  "Thank You For Waiting Your Report is Completed!": {
    en: "Thank You For Waiting Your Report is Completed!",
    ar: "شكرًا لانتظاركم، التقرير الخاص بكم جاهز الآن!",
  },
  "Recurrent Cost": {
    en: "Recurrent Cost",
    ar: "التكلفة المتكررة",
  },
  Recurring: {
    en: "Recurring",
    ar: "متكرر",
  },
  "How many hours per week could your idea save? For instance, if it saves 2 hours weekly for an employee earning ₤50,000 annually, that equates to approximately ₤1,000 in annual savings (based on a 37.5-hour workweek).":
    {
      en: "How many hours per week could your idea save? For instance, if it saves 2 hours weekly for an employee earning ₤50,000 annually, that equates to approximately ₤1,000 in annual savings (based on a 37.5-hour workweek).",
      ar: "كم عدد الساعات الأسبوعية التي يمكن لفكرتك توفيرها؟ على سبيل المثال، إذا كانت توفر ساعتين أسبوعيًا لموظف يتقاضى راتبًا سنويًا قدره 50,000 جنيه إسترليني، فإن ذلك يعادل تقريبًا 1,000 جنيه إسترليني في المدخرات السنوية (اعتمادًا على أسبوع عمل مدته 37.5 ساعة).",
    },
  "Please wait while bots are working on your report...": {
    en: "Please wait while bots are working on your report...",
    ar: "يرجى الانتظار بينما يقوم الروبوت بإعداد تقريرك...",
  },
  "We almost finished preparing it...": {
    en: "We almost finished preparing it...",
    ar: "لقد اقتربنا من استكمال إعدادها...",
  },
  "Almost done...": {
    en: "Almost done...",
    ar: "على وشك الانتهاء...",
  },
  "Report Completed": {
    en: "Report Completed",
    ar: "التقرير مكتمل",
  },
  "Cost vs Benefit": {
    en: "Cost vs Benefit",
    ar: "التكلفة مقابل الفائدة",
  },
  "Project Info": {
    en: "Project Info",
    ar: "معلومات المشروع",
  },
  "A New Project Added!": {
    en: "A New Project Added!",
    ar: "تمت إضافة مشروع جديد!",
  },
  Success: {
    en: "Success",
    ar: "نجاح",
  },
  "Report Edited successfully.": {
    en: "Report Edited successfully.",
    ar: "تم تعديل التقرير بنجاح.",
  },
  Error: {
    en: "Error",
    ar: "خطأ",
  },
  "Internal Server Error.": {
    en: "Internal Server Error.",
    ar: "خطأ داخلي في الخادم.",
  },
  "View Scorecard": {
    en: "View Scorecard",
    ar: "عرض بطاقة الأداء",
  },
  "New Idea": {
    en: "New Idea",
    ar: "الفكرة الجديدة",
  },
  "Detailed Report": {
    en: "Detailed Report",
    ar: "تقرير مفصل",
  },
  "Business Case Summary": {
    en: "Business Case Summary",
    ar: "ملخص الحالة التجارية",
  },
  Introduction: {
    en: "Introduction",
    ar: "مقدمة",
  },
  "Market Research": {
    en: "Market Research",
    ar: "أبحاث السوق",
  },
  "Feasilibity Analysis": {
    en: "Feasilibity Analysis",
    ar: "تحليل الجدوى",
  },
  "Project Timeline": {
    en: "Project Timeline",
    ar: "الجدول الزمني للمشروع",
  },
  "Resource Requirements": {
    en: "Resource Requirements",
    ar: "متطلبات الموارد",
  },
  "Solution Proposal": {
    en: "Solution Proposal",
    ar: "اقتراح الحل",
  },
  "Legal Compliance": {
    en: "Legal Compliance",
    ar: "الامتثال القانوني",
  },
  "Risk Analysis": {
    en: "Risk Analysis",
    ar: "تحليل المخاطر",
  },
  Conclusion: {
    en: "Conclusion",
    ar: "الخاتمة",
  },
  "View Analytics": {
    en: "View Analytics",
    ar: "عرض التحليلات",
  },
  "Add RAID": {
    en: "Add RAID",
    ar: "إضافة RAID",
  },
  "Stage Milestones": {
    en: "Stage Milestones",
    ar: "مراحل الإنجاز",
  },
  "No milestones found!": {
    en: "No milestones found!",
    ar: "لم يتم العثور على مراحل رئيسية!",
  },
  "No Tasks Available for the Milestone": {
    en: "No Tasks Available for the Milestone",
    ar: "لا توجد مهام متاحة لهذه المرحلة",
  },
  "Improvement Opportunity": {
    en: "Improvement Opportunity",
    ar: "فرصة تحسين",
  },
  "Name:": {
    en: "Name:",
    ar: "اسم:",
  },
  "Date:": {
    en: "Date:",
    ar: "التاريخ:",
  },
  "What is the Problem?": {
    en: "What is the Problem?",
    ar: "ما هي المشكلة؟",
  },
  "Why is it happening?": {
    en: "Why is it happening?",
    ar: "لماذا يحدث هذا؟",
  },
  "Potential Solution?": {
    en: "Potential Solution?",
    ar: "الحل المحتمل؟",
  },
  "View Tasks": {
    en: "View Tasks",
    ar: "عرض المهام",
  },
  "View Milestones": {
    en: "View Milestones",
    ar: "عرض المعالم",
  },
  "Relates To:": {
    en: "Relates To:",
    ar: "يتعلق بـ:",
  },
  "Improvement Opportunity Action Tracking": {
    en: "Improvement Opportunity Action Tracking",
    ar: "تتبع إجراءات فرص التحسين",
  },
  "Break down plan?": {
    en: "Break down plan?",
    ar: "خطة التحليل؟",
  },
  "Goal:": {
    en: "Goal:",
    ar: "الهدف:",
  },
  "Target:": {
    en: "Target",
    ar: "هدف",
  },
  "Step 4: Analysis: Top Contributors & Root Cause": {
    en: "Step 4: Analysis: Top Contributors & Root Cause",
    ar: "الخطوة 4: التحليل: المساهمون الرئيسيون وسبب المشكلة الأساسي",
  },
  "Step 5: Refined Problem Statement": {
    en: "5: Refined Problem Statement",
    ar: "بيان المشكلة المُحَسَّن 5:",
  },
  "Step 6: Opportunities & Countermeasures": {
    en: "Step 6: Opportunities & Countermeasures",
    ar: "الخطوة 6: الفرص والإجراءات المضادة",
  },
  "Step 7: Summary Action": {
    en: "Step 7: Summary Action",
    ar: "الخطوة 7: إجراء التلخيص",
  },
  "Step 8: Progress & Follow Up": {
    en: "Step 8: Progress & Follow Up",
    ar: "الخطوة 8: التقدم والمتابعة",
  },
  "Step 9: Insights": {
    en: "Step 9: Insights",
    ar: "الخطوة 9: الرؤى والتحليلات",
  },
  "Edit Report": {
    en: "Edit Report",
    ar: "تحرير التقرير",
  },
  "Idea Evaluation Scorecard": {
    en: "Idea Evaluation Scorecard",
    ar: "بطاقة تقييم الأفكار",
  },
  "Name / Title of Idea": {
    en: "Name / Title of Idea",
    ar: "اسم / عنوان الفكرة",
  },
  "Type of Innovation": {
    en: "Type of Innovation",
    ar: "نوع الابتكار",
  },
  "Project Type": {
    en: "Project Type",
    ar: "نوع المشروع",
  },
  Objective: {
    en: "Objective",
    ar: "الهدف",
  },
  "Benefits or Advantages": {
    en: "Benefits or Advantages",
    ar: "الفوائد أو المزايا",
  },
  Risks: {
    en: "Risks",
    ar: "المخاطر",
  },
  Feasibility: {
    en: "Feasibility",
    ar: "الجدوى",
  },
  "Very High": {
    en: "Very High",
    ar: "مرتفع جدًا",
  },
  High: {
    en: "High",
    ar: "مرتفع",
  },
  Medium: {
    en: "Medium",
    ar: "متوسط",
  },
  Low: {
    en: "Low",
    ar: "منخفض",
  },
  "Very Low": {
    en: "Very Low",
    ar: "منخفض جداً",
  },
  "Market Potential": {
    en: "Market Potential",
    ar: "إمكانات السوق",
  },
  "Necessary Investment": {
    en: "Necessary Investment",
    ar: "الاستثمار الضروري",
  },
  "Strategic Fit": {
    en: "Strategic Fit",
    ar: "التوافق الاستراتيجي",
  },
  "Edit Statement": {
    en: "Edit Statement",
    ar: "تعديل البيان",
  },
  "Edit Here...": {
    en: "Edit Here...",
    ar: "تحرير هنا ...",
  },
  "Overall Evaluation": {
    en: "Overall Evaluation",
    ar: "التقييم العام",
  },
  Create: {
    en: "Create",
    ar: "إنشاء",
  },
  "Send to Team": {
    en: "Send to Team",
    ar: "إرسال إلى الفريق",
  },
  "Create Your Team": {
    en: "Create Your Team",
    ar: "إنشاء فريقك",
  },
  "Choose Existing Team": {
    en: "Choose Existing Team",
    ar: "اختر الفريق الحالي",
  },
  "Title:": {
    en: "Title:",
    ar: "العنوان:",
  },
  "Invite People to your Team:": {
    en: "Invite People to your Team:",
    ar: "دعوة الأعضاء للانضمام إلى الفريق:",
  },
  "Tip: For now, you can add yourself as a team member to proceed.": {
    en: "Tip: For now, you can add yourself as a team member to proceed.",
    ar: "النصيحة: يمكنك إضافة نفسك كعضو في الفريق للاستمرار حاليًا.",
  },
  "Select Your Team": {
    en: "Select Your Team",
    ar: "اختر فريقك",
  },
  "Select Existing Teams": {
    en: "Select Existing Teams",
    ar: "اختر الفرق الحالية",
  },
  "Admin Panel": {
    en: "Admin Panel",
    ar: "لوحة التحكم الإدارة",
  },
  "Admin Dashboard": {
    en: "Admin Dashboard",
    ar: "لوحة تحكم المسؤول",
  },
  "User Management": {
    en: "User Management",
    ar: "إدارة المستخدمين",
  },
  "Theme Management": {
    en: "Theme Management",
    ar: "إدارة الموضوعات",
  },
  "Metrics Management": {
    en: "Metrics Management",
    ar: "إدارة المقاييس",
  },
  "Cost/Benefit Management": {
    en: "Cost/Benefit Management",
    ar: "إدارة التكاليف والفوائد",
  },
  "Division Management": {
    en: "Division Management",
    ar: "إدارة القسم",
  },
  "Department Management": {
    en: "Department Management",
    ar: "إدارة الأقسام",
  },
  "System Requests": {
    en: "System Requests",
    ar: "طلبات النظام",
  },
  "All Users": {
    en: "All Users",
    ar: "جميع المستخدمين",
  },
  "Search user by email...": {
    en: "Search user by email...",
    ar: "البحث عن المستخدم عبر البريد الإلكتروني...",
  },
  "Upload Users CSV": {
    en: "Upload Users CSV",
    ar: "رفع ملف المستخدمين بصيغة CSV",
  },
  Name: {
    en: "Name",
    ar: "الاسم",
  },
  Email: {
    en: "Email",
    ar: "البريد الإلكتروني",
  },
  Team: {
    en: "Team",
    ar: "الفريق",
  },
  Categories: {
    en: "Team",
    ar: "الفريق",
  },
  "Strategic Themes": {
    en: "Strategic Themes",
    ar: "المحاور الاستراتيجية",
  },
  "Add New Theme": {
    en: "Add New Theme",
    ar: "إضافة موضوع جديد",
  },
  "Add New Category": {
    en: "Add New Category",
    ar: "إضافة فئة جديدة",
  },
  "Edit Theme": {
    en: "Edit Theme",
    ar: "تعديل الموضوع",
  },
  "Theme Class": {
    en: "Theme Class",
    ar: "فئة الموضوع",
  },
  "Please enter the strategic theme": {
    en: "Please enter the strategic theme",
    ar: "الرجاء إدخال الموضوع الاستراتيجي",
  },
  "Please enter the description": {
    en: "Please enter the description",
    ar: "يرجى إدخال الوصف",
  },
  "Please select the theme class": {
    en: "Please select the theme class",
    ar: "الرجاء اختيار فئة القالب",
  },
  "Edit Category": {
    en: "Edit Category",
    ar: "تحرير الفئة",
  },
  Ok: {
    en: "Ok",
    ar: "حسنًا",
  },
  "Please enter a category name": {
    en: "Please enter a category name",
    ar: "يرجى إدخال اسم الفئة",
  },
  "Please select a strategic theme": {
    en: "Please enter a category name",
    ar: "يرجى إدخال اسم الفئة",
  },
  "Metric Management": {
    en: "Metric Management",
    ar: "إدارة المؤشرات",
  },
  "Add Metric": {
    en: "Add Metric",
    ar: "إضافة مقياس",
  },
  "Edit Metric": {
    en: "Edit Metric",
    ar: "تحرير المقياس",
  },
  "Please enter the metric name": {
    en: "Please enter the metric name",
    ar: "يرجى إدخال اسم المقياس",
  },
  "Select a theme": {
    en: "Select a theme",
    ar: "اختر سمة",
  },
  "Please select a category": {
    en: "Please select a category",
    ar: "يرجى اختيار فئة",
  },
  "Add Category": {
    en: "Add Category",
    ar: "إضافة فئة",
  },
  "Metric is Better When: ": {
    en: "Metric is Better When: ",
    ar: "المقياس يكون أفضل عندما:",
  },
  Higher: {
    en: "Higher",
    ar: "أعلى",
  },
  Lower: {
    en: "Lower",
    ar: "خفض",
  },
  "Update Metric": {
    en: "Update Metric",
    ar: "تحديث المقياس",
  },
  "Add Theme": {
    en: "Add Theme",
    ar: "إضافة موضوع",
  },
  "Category Name": {
    en: "Category Name",
    ar: "اسم التصنيف",
  },
  "Metric Better When Higher": {
    en: "Metric Better When Higher",
    ar: "المقياس يكون أفضل عند الارتفاع",
  },
  "Is Recurrent": {
    en: "Is Recurrent",
    ar: "متكرر",
  },
  "Is Financial": {
    en: "Is Financial",
    ar: "المالي",
  },
  "Metric Type": {
    en: "Metric Type",
    ar: "نوع المقياس",
  },
  "Manage Subcategories": {
    en: "Manage Subcategories",
    ar: "إدارة الفئات الفرعية",
  },
  "Are you sure you want to delete this category?": {
    en: "Are you sure you want to delete this category?",
    ar: "هل أنت متأكد أنك تريد حذف هذه الفئة؟",
  },
  "Add Cost/Benefit Category": {
    en: "Add Cost/Benefit Category",
    ar: "إضافة فئة التكلفة/الفائدة",
  },
  "Are you sure you want to delete this Subcategory?": {
    en: "Are you sure you want to delete this Subcategory?",
    ar: "هل أنت متأكد أنك تريد حذف هذه الفئة الفرعية؟",
  },
  "Edit Cost/Benefit Category": {
    en: "Edit Cost/Benefit Category",
    ar: "تحرير فئة التكلفة/المنفعة",
  },
  "Please enter the name": {
    en: "Please enter the name",
    ar: "يرجى إدخال الاسم",
  },
  "Please select metric type": {
    en: "Please select metric type",
    ar: "يرجى اختيار نوع المقياس",
  },
  Benefit: {
    en: "Benefit",
    ar: "الفائدة",
  },
  "Edit Subcategory": {
    en: "Edit Subcategory",
    ar: "تحرير الفئة الفرعية",
  },
  "Add Subcategory": {
    en: "Add Subcategory",
    ar: "إضافة فئة فرعية",
  },
  "Subcategory Name": {
    en: "Subcategory Name",
    ar: "اسم الفئة الفرعية",
  },
  "Please enter the subcategory name": {
    en: "Please enter the subcategory name",
    ar: "يرجى إدخال اسم الفئة الفرعية",
  },
  "Divisions Management": {
    en: "Divisions Management",
    ar: "إدارة الأقسام",
  },
  "Add Division": {
    en: "Add Division",
    ar: "إضافة قسم",
  },
  "Edit Division": {
    en: "Edit Division",
    ar: "تحرير القسم",
  },
  "Division name cannot be empty": {
    en: "Division name cannot be empty",
    ar: "اسم القسم لا يمكن أن يكون فارغًا",
  },
  "Division added successfully": {
    en: "Division added successfully",
    ar: "تم إضافة القسم بنجاح",
  },
  "Failed to add division": {
    en: "Failed to add division",
    ar: "فشل في إضافة القسم",
  },
  "Division updated successfully": {
    en: "Division updated successfully",
    ar: "تم تحديث القسم بنجاح",
  },
  "Failed to update division": {
    en: "Failed to update division",
    ar: "فشل في تحديث القسم",
  },
  "Division deleted successfully": {
    en: "Division deleted successfully",
    ar: "تم حذف القسم بنجاح",
  },
  "Failed to delete division": {
    en: "Failed to delete division",
    ar: "فشل في حذف القسم",
  },
  "Are you sure you want to delete this division?": {
    en: "Are you sure you want to delete this division?",
    ar: "هل أنت متأكد من رغبتك في حذف هذا القسم؟",
  },
  ID: {
    en: "ID",
    ar: "معرّف",
  },
  Actions: {
    en: "Actions",
    ar: "الإجراءات",
  },
  "Enter division name": {
    en: "Enter division name",
    ar: "أدخل اسم القسم",
  },
  "Failed to load departments": {
    en: "Failed to load departments",
    ar: "تعذّر تحميل الأقسام",
  },
  "Failed to load divisions": {
    en: "Failed to load divisions",
    ar: "فشل في تحميل الأقسام",
  },
  "Failed to load teams": {
    en: "Failed to load teams",
    ar: "فشل في تحميل الفرق",
  },
  "Failed to load users": {
    en: "Failed to load users",
    ar: "حدث خطأ أثناء تحميل المستخدمين",
  },
  "Team created successfully": {
    en: "Team created successfully",
    ar: "تم إنشاء الفريق بنجاح",
  },
  "Error creating team": {
    en: "Error creating team",
    ar: "خطأ في إنشاء الفريق",
  },
  "Failed to create team": {
    en: "Failed to create team",
    ar: "فشل إنشاء الفريق",
  },
  "Department deleted successfully": {
    en: "Department deleted successfully",
    ar: "تم حذف القسم بنجاح",
  },
  "Failed to delete department": {
    en: "Failed to delete department",
    ar: "فشل في حذف القسم",
  },
  "Team name updated successfully": {
    en: "Team name updated successfully",
    ar: "تم تحديث اسم الفريق بنجاح",
  },
  "Failed to update team name": {
    en: "Failed to update team name",
    ar: "فشل في تحديث اسم الفريق",
  },
  "Team deleted successfully": {
    en: "Team deleted successfully",
    ar: "تم حذف الفريق بنجاح",
  },
  "Failed to delete team": {
    en: "Failed to delete team",
    ar: "فشل في حذف الفريق",
  },
  "Department updated successfully": {
    en: "Department updated successfully",
    ar: "تم تحديث القسم بنجاح",
  },
  "Department added successfully": {
    en: "Department added successfully",
    ar: "تم إضافة القسم بنجاح",
  },
  "Failed to save department": {
    en: "Failed to save department",
    ar: "فشل في حفظ القسم",
  },
  "Team linked to the department successfully": {
    en: "Team linked to the department successfully",
    ar: "تم ربط الفريق بالقسم بنجاح",
  },
  "New team created and linked to the department": {
    en: "New team created and linked to the department",
    ar: "تم إنشاء فريق جديد وربطه بالقسم",
  },
  "The selected team is already linked to a department": {
    en: "The selected team is already linked to a department",
    ar: "الفريق المحدد مرتبط بالفعل بقسم",
  },
  "Failed to save team": {
    en: "Failed to save team",
    ar: "تعذر حفظ الفريق",
  },
  "Error saving team": {
    en: "Error saving team",
    ar: "خطأ في حفظ الفريق",
  },
  "Are you sure you want to delete this department?": {
    en: "Are you sure you want to delete this department?",
    ar: "هل أنت متأكد من رغبتك في حذف هذا القسم؟",
  },
  "Add Teams": {
    en: "Add Teams",
    ar: "إضافة فرق",
  },
  "Link Teams": {
    en: "Link Teams",
    ar: "ربط الفرق",
  },
  "Add Department": {
    en: "Add Department",
    ar: "إضافة قسم",
  },
  "Team Name": {
    en: "Team Name",
    ar: "اسم الفريق",
  },
  "Are you sure you want to delete this team?": {
    en: "Are you sure you want to delete this team?",
    ar: "هل أنت متأكد من رغبتك في حذف هذه الفريق؟",
  },
  "Edit Department": {
    en: "Edit Department",
    ar: "تحرير القسم",
  },
  "Please select division": {
    en: "Please select division",
    ar: "يرجى اختيار القسم",
  },
  "Edit Team": {
    en: "Edit Team",
    ar: "تعديل الفريق",
  },
  "Add Team": {
    en: "Add Team",
    ar: "إضافة فريق",
  },
  "Please select the team name": {
    en: "Please select the team name",
    ar: "يرجى اختيار اسم الفريق",
  },
  "Edit Team Name": {
    en: "Edit Team Name",
    ar: "تحرير اسم الفريق",
  },
  "Please Enter the team name": {
    en: "Please Enter the team name",
    ar: "يرجى إدخال اسم الفريق",
  },
  "Template Saved Successfully!": {
    en: "Template Saved Successfully!",
    ar: "تم حفظ القالب بنجاح!",
  },
  "Please add an Element on Drawing!": {
    en: "Please add an Element on Drawing!",
    ar: "يرجى إضافة عنصر إلى الرسم!",
  },
  "Select Month": {
    en: "Select Month",
    ar: "اختر الشهر",
  },
  "Individual Leaderboard": {
    en: "Individual Leaderboard",
    ar: "لوحة القادة الفردية",
  },
  "Division-Wide Leaderboard": {
    en: "Division-Wide Leaderboard",
    ar: "لوحة المتصدرين على مستوى القسم",
  },
  "Team-Level Leaderboard": {
    en: "Team-Level Leaderboard",
    ar: "لوحة الصدارة على مستوى الفريق",
  },
  "Organisation Wide Leaderboard": {
    en: "Organisation Wide Leaderboard",
    ar: "لوحة الصدارة على مستوى المنظمة",
  },
  "Innovation Champions": {
    en: "Innovation Champions",
    ar: "رواد الابتكار",
  },
  "Innovation Metrics": {
    en: "Innovation Metrics",
    ar: "مؤشرات الابتكار",
  },
  "Ideas Submitted": {
    en: "Ideas Submitted",
    ar: "الأفكار المقدَّمة",
  },
  "Ideas Approved": {
    en: "Ideas Approved",
    ar: "الأفكار المعتمدة",
  },
  "Implementation Rate (%)": {
    en: "Implementation Rate (%)",
    ar: "معدل التنفيذ (%)",
  },
  "Value Creators": {
    en: "Value Creators",
    ar: "صُنَّاع القيمة",
  },
  "Financial Value": {
    en: "Financial Value",
    ar: "القيمة المالية",
  },
  "Cash Savings": {
    en: "Cash Savings",
    ar: "المدخرات النقدية",
  },
  "Efficiency Improvements": {
    en: "Efficiency Improvements",
    ar: "تحسينات الكفاءة",
  },
  "Total Value Delivered": {
    en: "Total Value Delivered",
    ar: "إجمالي القيمة المقدمة",
  },
  "Number of Ideas": {
    en: "Number of Ideas",
    ar: "عدد الأفكار",
  },
  "Total Ideas Submitted": {
    en: "Total Ideas Submitted",
    ar: "إجمالي الأفكار المقدمة",
  },
  "Implemented Ideas": {
    en: "Implemented Ideas",
    ar: "الأفكار المنفذة",
  },
  "Top Innovators (Division)": {
    en: "Top Innovators (Division)",
    ar: "أفضل المبتكرين (القسم)",
  },
  "Division Value Creators": {
    en: "Division Value Creators",
    ar: "صنّاع القيمة في القسم",
  },
  "Value Created": {
    en: "Value Created",
    ar: "القيمة المضافة",
  },
  "Top Idea Generators (Team Level)": {
    en: "Top Idea Generators (Team Level)",
    ar: "أفضل مولدي الأفكار (على مستوى الفريق)",
  },
  Ideas: {
    en: "Ideas",
    ar: "أفكار",
  },
  "Team Value Drivers": {
    en: "Team Value Drivers",
    ar: "محركات قيمة الفريق",
  },
  "Value Metrics": {
    en: "Value Metrics",
    ar: "مؤشرات القيمة",
  },
  "Cost Savings": {
    en: "Cost Savings",
    ar: "توفير التكاليف",
  },
  "Total Value": {
    en: "Total Value",
    ar: "القيمة الإجمالية",
  },
  "Top Collaborators (Team Level)": {
    en: "Top Collaborators (Team Level)",
    ar: "أفضل المتعاونين (على مستوى الفريق)",
  },
  "Collaborative Tasks": {
    en: "Collaborative Tasks",
    ar: "المهام التعاونية",
  },
  "Cross-Team Projects": {
    en: "Cross-Team Projects",
    ar: "مشاريع بين الفرق",
  },
  Collaboration: {
    en: "Collaboration",
    ar: "التعاون",
  },
  "Organisation Innovation Champions": {
    en: "Organisation Innovation Champions",
    ar: "أبطال الابتكار في المؤسسة",
  },
  "Organisation Value Creators": {
    en: "Organisation Value Creators",
    ar: "مبدعو قيمة المنظمة",
  },
  "Organisation Project Excellence": {
    en: "Organisation Project Excellence",
    ar: "تميز مشاريع المؤسسة",
  },
  "Project Metrics": {
    en: "Project Metrics",
    ar: "مؤشرات المشروع",
  },
  "Completed Projects": {
    en: "Completed Projects",
    ar: "المشاريع المُنتهية",
  },
  "Success Rate (%)": {
    en: "Success Rate (%)",
    ar: "نسبة النجاح (%)",
  },
  "Strategic Alignment": {
    en: "Strategic Alignment",
    ar: "التوافق الاستراتيجي",
  },
  "Your vote removed!": {
    en: "Your vote removed!",
    ar: "تمت إزالة تصويتك!",
  },
  "Your Vote added!": {
    en: "Your Vote added!",
    ar: "تم إضافة صوتك بنجاح!",
  },
  "New Task assigned to": {
    en: "New Task assigned to",
    ar: "تم تعيين مهمة جديدة إلى",
  },
  "Task Updates": {
    en: "Task Updates",
    ar: "تحديثات المهام",
  },
  "New Task Assigned!": {
    en: "New Task Assigned!",
    ar: "تم تعيين مهمة جديدة!",
  },
  "Escalated to Seniors!": {
    en: "Escalated to Seniors!",
    ar: "تم التصعيد إلى الفريق الأعلى!",
  },
  "New Task assigned Successfully!": {
    en: "New Task assigned Successfully!",
    ar: "تم إسناد المهمة الجديدة بنجاح!",
  },
  "Project:": {
    en: "Project:",
    ar: "المشروع:",
  },
  "Some Error Occurred, Please Try again.": {
    en: "Some Error Occurred, Please Try again.",
    ar: "حدث خطأ ما، يُرجى المحاولة مجددًا.",
  },
  Dashboard: {
    en: "Dashboard",
    ar: "لوحة التحكم",
  },
  Projects: {
    en: "Projects",
    ar: "المشاريع",
  },
  Sentiment: {
    en: "Sentiment",
    ar: "العاطفة",
  },
  "Tasks Completed": {
    en: "Tasks Completed",
    ar: "المهام المنجزة",
  },
  "Urgency Level": {
    en: "Urgency Level",
    ar: "مستوى الإلحاح",
  },
  "Escalation Reason": {
    en: "Escalation Reason",
    ar: "سبب التصعيد",
  },
  Owner: {
    en: "Owner",
    ar: "المالك",
  },
  "Owner:": {
    en: "Owner:",
    ar: "المالك",
  },
  Discuss: {
    en: "Discuss",
    ar: "مناقشة",
  },
  "View More": {
    en: "View More",
    ar: "عرض المزيد",
  },
  Mandatory: {
    en: "Mandatory",
    ar: "إلزامي",
  },
  Approved: {
    en: "Approved",
    ar: "مقبول",
  },
  "Milestones Completed": {
    en: "Milestones Completed",
    ar: "المعالم المكتملة",
  },
  "Total Milestones": {
    en: "Total Milestones",
    ar: "إجمالي الإنجازات",
  },
  "Escalation Urgency:": {
    en: "Escalation Urgency:",
    ar: "مدى إلحاحية التصعيد:",
  },
  "Escalation Reason:": {
    en: "Escalation Reason:",
    ar: "سبب التصعيد:",
  },
  "Team WorkLoad": {
    en: "Team WorkLoad",
    ar: "حجم العمل للفريق",
  },
  "See WorkLoad": {
    en: "See WorkLoad",
    ar: "عرض عبء العمل",
  },
  Key: {
    en: "Key",
    ar: "مفتاح",
  },
  "Completed tasks": {
    en: "Completed tasks",
    ar: "المهام المُنجزة",
  },
  "In Progress Tasks": {
    en: "In Progress Tasks",
    ar: "المهام الجارية",
  },
  "Start Date": {
    en: "Start Date",
    ar: "تاريخ البدء",
  },
  "End Date": {
    en: "End Date",
    ar: "تاريخ الانتهاء",
  },
  "Cost Amount": {
    en: "Cost Amount",
    ar: "المبلغ المالي",
  },
  "Total projects": {
    en: "Total projects",
    ar: "إجمالي المشاريع",
  },
  "Total tasks": {
    en: "Total tasks",
    ar: "إجمالي المهام",
  },
  "Overdue tasks": {
    en: "Overdue tasks",
    ar: "المهام المتأخرة",
  },
  "Please select a metric first!": {
    en: "Please select a metric first!",
    ar: "يرجى اختيار مقياس أولاً!",
  },
  "Data point added successfully": {
    en: "Data point added successfully",
    ar: "تمت إضافة نقطة البيانات بنجاح",
  },
  "Failed to add data point": {
    en: "Failed to add data point",
    ar: "فشل في إضافة نقطة البيانات",
  },
  "An error occurred while adding data point": {
    en: "An error occurred while adding data point",
    ar: "حدث خطأ أثناء إضافة نقطة البيانات.",
  },
  "Select Filter": {
    en: "Select Filter",
    ar: "اختر الفلتر",
  },
  "Select Constraint": {
    en: "Select Constraint",
    ar: "اختر القيد",
  },
  Is: {
    en: "Is",
    ar: "هل",
  },
  "Is Not": {
    en: "Is Not",
    ar: "غير موجود",
  },
  "Select Option": {
    en: "Select Option",
    ar: "اختر خياراً",
  },
  "Patient Access": {
    en: "Patient Access",
    ar: "الوصول للمريض",
  },
  "Patient Experience": {
    en: "Patient Experience",
    ar: "تجربة المريض",
  },
  "Patient Safety": {
    en: "Patient Safety",
    ar: "سلامة المريض",
  },
  People: {
    en: "People",
    ar: "أشخاص",
  },
  Sustainability: {
    en: "Sustainability",
    ar: "الاستدامة",
  },
  "Systems & Partnership": {
    en: "Systems & Partnership",
    ar: "الأنظمة والشراكات",
  },
  "Project Completion": {
    en: "Project Completion",
    ar: "اكتمال المشروع",
  },
  "View Detailed Analysis": {
    en: "View Detailed Analysis",
    ar: "عرض التحليل المفصل",
  },
  "Positive Sentiment": {
    en: "Positive Sentiment",
    ar: "إيجابي",
  },
  "Negative Sentiment": {
    en: "Negative Sentiment",
    ar: "المشاعر السلبية",
  },
  Sentiments: {
    en: "Sentiments",
    ar: "المشاعر",
  },
  "Top Positive": {
    en: "Top Positive",
    ar: "الأعلى تقييماً إيجابياً",
  },
  "Top Negative": {
    en: "Top Negative",
    ar: "أعلى سلبي",
  },
  Top: {
    en: "Top",
    ar: "أعلى",
  },
  "Show Positive": {
    en: "Show Positive",
    ar: "عرض الإيجابيات",
  },
  "Show Negative": {
    en: "Show Negative",
    ar: "عرض السلبيات",
  },
  "No Data": {
    en: "No Data",
    ar: "عذراً، لا توجد بيانات متاحة حاليًا.",
  },
  "Quarterly Cost and Benefit Realization": {
    en: "Quarterly Cost and Benefit Realization",
    ar: "تحقيق التكاليف والعوائد الفصلية",
  },
  "Patient vs Staff Ideas": {
    en: "Patient vs Staff Ideas",
    ar: "أفكار المرضى مقابل الموظفين",
  },
  "Approved Ideas": {
    en: "Approved Ideas",
    ar: "الأفكار المعتمدة",
  },
  "Ideas in Progress": {
    en: "Ideas in Progress",
    ar: "الأفكار قيد التنفيذ",
  },
  "Parked Ideas": {
    en: "Parked Ideas",
    ar: "الأفكار المؤجلة",
  },
  "Benefit Ratio Ideas": {
    en: "Benefit Ratio Ideas",
    ar: "أفكار نسبة المنفعة",
  },
  "Patient Ideas": {
    en: "Patient Ideas",
    ar: "أفكار المريض",
  },
  "Staff Ideas": {
    en: "Staff Ideas",
    ar: "أفكار الموظفين",
  },
  "New Quick Wins Ideas": {
    en: "New Quick Wins Ideas",
    ar: "أفكار جديدة لتحقيق إنجازات سريعة",
  },
  "New SOLVER Ideas": {
    en: "New SOLVER Ideas",
    ar: "أفكار جديدة لحلول SOLVER",
  },
  "New Improve Ideas": {
    en: "New Improve Ideas",
    ar: "أفكار تحسين جديدة",
  },
  "Staff vs Patient Ideas": {
    en: "Staff vs Patient Ideas",
    ar: "الموظفون مقابل أفكار المرضى",
  },
  "Last Month": {
    en: "Last Month",
    ar: "الشهر الماضي",
  },
  Patient: {
    en: "Patient",
    ar: "مريض",
  },
  Issues: {
    en: "Issues",
    ar: "مشاكل",
  },
  "General Concerns": {
    en: "General Concerns",
    ar: "المخاوف العامة",
  },
  "Avg. Mitigation Rate": {
    en: "Avg. Mitigation Rate",
    ar: "متوسط معدل التخفيف",
  },
  "Avg. Length of Mitigation": {
    en: "Avg. Length of Mitigation",
    ar: "متوسط مدة التخفيف",
  },
  Days: {
    en: "Days",
    ar: "أيام",
  },
  "Project Funnel - Idea to Implementation": {
    en: "Project Funnel - Idea to Implementation",
    ar: "قناة المشروع - من فكرة إلى تنفيذ",
  },
  "Project Funnel": {
    en: "Project Funnel",
    ar: "قمع المشروع",
  },
  "Ideas Captured": {
    en: "Ideas Captured",
    ar: "الأفكار المسجلة",
  },
  "Ideas Under Review": {
    en: "Ideas Under Review",
    ar: "الأفكار قيد المراجعة",
  },
  "Projects in Planning": {
    en: "Projects in Planning",
    ar: "المشاريع قيد التخطيط",
  },
  "Projects in Execution": {
    en: "Projects in Execution",
    ar: "المشاريع قيد التنفيذ",
  },
  "All ideas that have been captured and logged in the system.": {
    en: "All ideas that have been captured and logged in the system.",
    ar: "جميع الأفكار التي تم تسجيلها وتوثيقها في النظام.",
  },
  "Ideas currently being evaluated for feasibility, alignment, and value.": {
    en: "Ideas currently being evaluated for feasibility, alignment, and value.",
    ar: "الأفكار التي يتم تقييمها حاليًا من حيث الجدوى، التوافق، والقيمة.",
  },
  "Ideas that have been approved and are in the planning or design phase.": {
    en: "Ideas that have been approved and are in the planning or design phase.",
    ar: "الأفكار التي تم اعتمادها والتي هي في مرحلة التخطيط أو التصميم.",
  },
  "Projects that are actively being executed with significant progress.": {
    en: "Projects that are actively being executed with significant progress.",
    ar: "المشاريع الجاري تنفيذها بمستوى تقدم ملحوظ.",
  },
  "Ideas that have been fully implemented and are delivering value.": {
    en: "Ideas that have been fully implemented and are delivering value.",
    ar: "الأفكار التي تم تنفيذها بالكامل وتقديمها للقيمة المطلوبة.",
  },
  "Risks Mitigation": {
    en: "Risks Mitigation",
    ar: "تخفيف المخاطر",
  },
  "Issue Mitigation": {
    en: "Issue Mitigation",
    ar: "إدارة ومعالجة المشكلات",
  },
  "Concern Mitigation": {
    en: "Concern Mitigation",
    ar: "تخفيف المخاطر",
  },
  "Risk, Issue, and Concern Heatmap": {
    en: "Risk, Issue, and Concern Heatmap",
    ar: "خريطة حرارة المخاطر والقضايا والمخاوف",
  },
  "Week 1": {
    en: "Week 1",
    ar: "الأسبوع الأول",
  },
  "Week 2": {
    en: "Week 2",
    ar: "الأسبوع الثاني",
  },
  "Week 3": {
    en: "Week 3",
    ar: "الأسبوع الثالث",
  },
  "Week 4": {
    en: "Week 4",
    ar: "الأسبوع الرابع",
  },
  Concern: {
    en: "Concern",
    ar: "قلق",
  },
  "Mitigation Status": {
    en: "Mitigation Status",
    ar: "حالة التخفيف",
  },
  Week: {
    en: "Week ",
    ar: "الأسبوع",
  },
  "Risk Severity Over Time": {
    en: "Risk Severity Over Time",
    ar: "شدة المخاطر على مر الزمن",
  },
  Severity: {
    en: "Severity",
    ar: "الخطورة",
  },
  "Risk Severity": {
    en: "Risk Severity",
    ar: "شدة المخاطر",
  },
  "Time Period": {
    en: "Time Period",
    ar: "الفترة الزمنية",
  },
  "Status Distribution": {
    en: "Status Distribution",
    ar: "توزيع الحالة",
  },
  "Created vs Mitigated": {
    en: "Created vs Mitigated",
    ar: "تم الإنشاء مقابل تم التخفيف",
  },
  Month: {
    en: "Month",
    ar: "شهر",
  },
  Count: {
    en: "Count",
    ar: "عدّ",
  },
  items: {
    en: "items",
    ar: "العناصر",
  },
  "Risk Impact": {
    en: "Risk Impact",
    ar: "تأثير المخاطر",
  },
  "Issue Impact": {
    en: "Issue Impact",
    ar: "تأثير المشكلة",
  },
  "General Concern Impact": {
    en: "General Concern Impact",
    ar: "تأثير القلق العام",
  },
  "No Issues": {
    en: "No Issues",
    ar: "لا توجد مشاكل",
  },
  "No Concerns": {
    en: "No Concerns",
    ar: "لا توجد مخاوف",
  },
  "Recurring and Non-Recurring Costs": {
    en: "Recurring and Non-Recurring Costs",
    ar: "التكاليف المتكررة وغير المتكررة",
  },
  "Recurring Costs": {
    en: "Recurring Costs",
    ar: "التكاليف المتكررة",
  },
  "Non Recurring Costs": {
    en: "Non Recurring Costs",
    ar: "التكاليف غير المتكررة",
  },
  "One Time Costs": {
    en: "One Time Costs",
    ar: "التكاليف لمرة واحدة",
  },
  "Recurrent Costs": {
    en: "Recurrent Costs",
    ar: "التكاليف المتكررة",
  },
  "Time to ROI": {
    en: "Time to ROI",
    ar: "الوقت لتحقيق العائد على الاستثمار",
  },
  Months: {
    en: "Months",
    ar: "الأشهر",
  },
  "Solver Projects": {
    en: "Solver Projects",
    ar: "مشاريع الحلول",
  },
  "Improve Projects": {
    en: "Improve Projects",
    ar: "تحسين المشاريع",
  },
  "Quick Wins Projects": {
    en: "Quick Wins Projects",
    ar: "مشاريع الإنجازات السريعة",
  },
  "No category data available": {
    en: "No category data available",
    ar: "لا توجد بيانات للفئة متوفرة",
  },
  Profits: {
    en: "Profits",
    ar: "الأرباح",
  },
  Reviewing: {
    en: "Reviewing",
    ar: "مراجعة",
  },
  Planning: {
    en: "Planning",
    ar: "التخطيط",
  },
  "In-Progress": {
    en: "In-Progress",
    ar: "قيد الإنجاز",
  },
  Completion: {
    en: "Completion",
    ar: "إتمام",
  },
  "Project Status": {
    en: "Project Status",
    ar: "حالة المشروع",
  },
  Mitigated: {
    en: "Mitigated",
    ar: "تم التخفيف منه",
  },
  Created: {
    en: "Created",
    ar: "تم الإنشاء",
  },
  Resolved: {
    en: "Resolved",
    ar: "تم الحل",
  },
  Pending: {
    en: "Pending",
    ar: "قيد الإنتظار",
  },
  "Risks, Issues, and General Concerns": {
    en: "Risks, Issues, and General Concerns",
    ar: "المخاطر، المشاكل، والاهتمامات العامة",
  },
  "No data available": {
    en: "No data available",
    ar: "لا توجد بيانات متاحة",
  },
  "No data available for the table.": {
    en: "No data available for the table.",
    ar: "لا توجد بيانات متاحة للجدول.",
  },
  "Total Values": {
    en: "Total Values",
    ar: "إجمالي القيم",
  },
  "Total Portfolio": {
    en: "Total Portfolio",
    ar: "إجمالي المحفظة",
  },
  Percentage: {
    en: "Percentage",
    ar: "النسبة المئوية",
  },
  "Last 30 Days": {
    en: "Last 30 Days",
    ar: "آخر 30 يوماً",
  },
  "Top Projects": {
    en: "Top Projects",
    ar: "المشاريع الرائدة",
  },
  "Parked projects": {
    en: "Parked projects",
    ar: "المشاريع المؤجلة",
  },
  "Parked Projects": {
    en: "Parked Projects",
    ar: "المشاريع المؤجلة",
  },
  "No impact description available": {
    en: "No impact description available",
    ar: "الوصف غير متاح",
  },
  AddMetricData: {
    en: "Add Metric Data",
    ar: "إضافة بيانات القياس",
  },
  Role: {
    en: "Role",
    ar: "الدور",
  },
  "Select a project": {
    en: "Select a project",
    ar: "اختر مشروعاً",
  },
  "Select a metric": {
    en: "Select a metric",
    ar: "اختر مؤشرًا",
  },
  "Please select a date!": {
    en: "Please select a date!",
    ar: "يرجى اختيار التاريخ!",
  },
  "Please input the value!": {
    en: "Please input the value!",
    ar: "يرجى إدخال القيمة!",
  },
  "Quick Wins Sentiment": {
    en: "Quick Wins Sentiment",
    ar: "المشاعر حول الإنجازات السريعة",
  },
  "SOLVER Sentiment": {
    en: "SOLVER Sentiment",
    ar: "الحل معاة تحليل المشاعر",
  },
  "IMPROVES Sentiment": {
    en: "IMPROVES Sentiment",
    ar: "تحسين المعنويات",
  },
  "No Data for Sentiment Distribution by Role": {
    en: "No Data for Sentiment Distribution by Role",
    ar: "لا توجد بيانات لتوزيع المشاعر حسب الدور",
  },
  "Sentiment Distribution by Role for Ticket": {
    en: "Sentiment Distribution by Role for Ticket",
    ar: "توزيع المشاعر حسب الدور للتذكرة",
  },
  "Sentiment Count": {
    en: "Sentiment Count",
    ar: "عدد الانطباعات",
  },
  feedback: {
    en: "feedback",
    ar: "ملاحظات",
  },
  "No data available for sentiment trend chart.": {
    en: "No data available for sentiment trend chart.",
    ar: "لا توجد بيانات متاحة لمخطط اتجاه المشاعر.",
  },
  "No week data available for sentiment trend chart.": {
    en: "No week data available for sentiment trend chart.",
    ar: "لا توجد بيانات للأسبوع الحالي في مخطط اتجاه المعنويات.",
  },
  "Sentiment Trend Over Time with Emotion Breakdown": {
    en: "Sentiment Trend Over Time with Emotion Breakdown",
    ar: "اتجاه المشاعر بمرور الوقت مع تحليل العواطف",
  },
  "Time (Weeks)": {
    en: "Time (Weeks)",
    ar: "المدة (بالأسابيع)",
  },
  "Sentiment Score / Feedback Count": {
    en: "Sentiment Score / Feedback Count",
    ar: "مؤشر الانطباع / عدد التعليقات",
  },
  "Votes by Sentiment with Average Sentiment Score": {
    en: "Votes by Sentiment with Average Sentiment Score",
    ar: "الأصوات حسب المشاعر مع متوسط درجة المشاعر",
  },
  "Number of Votes": {
    en: "Number of Votes",
    ar: "عدد الأصوات",
  },
  "Average Sentiment Score": {
    en: "Average Sentiment Score",
    ar: "متوسط درجة الشعور",
  },
  "Positive Votes": {
    en: "Positive Votes",
    ar: "الأصوات الإيجابية",
  },
  "Neutral Votes": {
    en: "Neutral Votes",
    ar: "الأصوات المحايدة",
  },
  "Negative Votes": {
    en: "Negative Votes",
    ar: "التصويتات السلبية",
  },
  "Feedback Themes for": {
    en: "Feedback Themes for",
    ar: "موضوعات التغذية الراجعة لـ",
  },
  "No engagement data available for display.": {
    en: "No engagement data available for display.",
    ar: "لا توجد بيانات تفاعل متاحة للعرض.",
  },
  "Engagement Metrics by Week": {
    en: "Engagement Metrics by Week",
    ar: "مقاييس التفاعل حسب الأسبوع",
  },
  Weeks: {
    en: "Weeks",
    ar: "أسابيع",
  },
  "SPC Chart for Sentiment Score": {
    en: "SPC Chart for Sentiment Score",
    ar: "مخطط SPC لدرجة الشعور",
  },
  "Sentiment Score": {
    en: "Sentiment Score",
    ar: "درجة المشاعر",
  },
  "Upper Process Limit (UCL)": {
    en: "Upper Process Limit (UCL)",
    ar: "الحد الأقصى للعملية (UCL)",
  },
  "Lower Process Limit (LCL)": {
    en: "Lower Process Limit (LCL)",
    ar: "الحد الأدنى لعملية المعالجة (LCL)",
  },
  Mean: {
    en: "Mean",
    ar: "متوسط",
  },
  Quarterly: {
    en: "Quarterly",
    ar: "ربع سنوي",
  },
  "Semi-Yearly": {
    en: "Semi-Yearly",
    ar: "نصف سنوي",
  },
  "Not Found!": {
    en: "Not Found!",
    ar: "غير موجود!",
  },
  Found: {
    en: "Found",
    ar: "تم العثور عليه",
  },
  Filter: {
    en: "Filter",
    ar: "تصفية",
  },
  A3: {
    en: "A3",
    ar: "A3",
  },
  Ticket: {
    en: "Ticket",
    ar: "تذكرة",
  },
  DMAIC: {
    en: "DMAIC",
    ar: "DMAIC",
  },
  "No Projects Under this Strategic Theme!": {
    en: "No Projects Under this Strategic Theme!",
    ar: "لا توجد مشاريع ضمن هذا المحور الاستراتيجي!",
  },
  "No Milestones Under this Project!": {
    en: "No Milestones Under this Project!",
    ar: "لا توجد معالم تحت هذا المشروع!",
  },
  "No Tasks Under this Milestone!": {
    en: "No Tasks Under this Milestone!",
    ar: "لا توجد مهام ضمن هذه المرحلة!",
  },
  "Select a Division": {
    en: "Select a Division",
    ar: "اختر القسم",
  },
  "Select a Department": {
    en: "Select a Department",
    ar: "اختر القسم",
  },
  "Clear Filters": {
    en: "Clear Filters",
    ar: "مسح التصفية",
  },
  votes: {
    en: "votes",
    ar: "الأصوات",
  },
  "No project to show. Please choose one ": {
    en: "No project to show. Please choose one ",
    ar: "لا يوجد مشروع لعرضه. يرجى اختيار أحد المشاريع.",
  },
  "strategic Theme": {
    en: "strategic Themes",
    ar: "المواضيع الاستراتيجية",
  },
  "No Milestone to show. Please choose one ": {
    en: "No Milestone to show. Please choose one ",
    ar: "لا يوجد معلم للعرض. يرجى اختيار واحد.",
  },
  Project: {
    en: "Project",
    ar: "المشروع",
  },
  "No Task to show. Please choose one ": {
    en: "No Task to show. Please choose one ",
    ar: "لا توجد مهمة لعرضها. يرجى اختيار واحدة.",
  },
  Pricing: {
    en: "Pricing",
    ar: "التسعير",
  },
  "1. Introduction": {
    en: "1. Introduction",
    ar: "١. المقدمة",
  },
  "Compelion Ltd. (”Compelion,” “we,” “us,” or “our”) is committed to safeguarding the privacy and security of your personal data. This Privacy Policy outlines how we collect, use, disclose, transfer, and protect your information when you access or use our AI-powered innovation management platform (the “Service”).":
    {
      en: "Compelion Ltd. (”Compelion,” “we,” “us,” or “our”) is committed to safeguarding the privacy and security of your personal data. This Privacy Policy outlines how we collect, use, disclose, transfer, and protect your information when you access or use our AI-powered innovation management platform (the “Service”).",
      ar: "'شركة كمبليون المحدودة ('كمبليون' أو 'نحن') ملتزمة بحماية خصوصية وأمن بياناتك الشخصية. توضح سياسة الخصوصية هذه كيفية جمعنا واستخدامنا والكشف عن ونقل وحماية معلوماتك عندما تصل إلى أو تستخدم منصتنا لإدارة الابتكار القائمة على الذكاء الاصطناعي ('الخدمة').",
    },
  "By accessing or using the Service, you acknowledge that you have read, understood, and agree to be bound by this Privacy Policy and our Terms of Use. If you do not agree with the terms of this Privacy Policy, please refrain from accessing or using the Service.":
    {
      en: "By accessing or using the Service, you acknowledge that you have read, understood, and agree to be bound by this Privacy Policy and our Terms of Use. If you do not agree with the terms of this Privacy Policy, please refrain from accessing or using the Service.",
      ar: "عند الوصول إلى الخدمة أو استخدامها، فإنك تقر بأنك قد قرأت وفهمت وتوافق على الالتزام بسياسة الخصوصية هذه وشروط الاستخدام الخاصة بنا. إذا لم توافق على شروط سياسة الخصوصية هذه، يرجى الامتناع عن الوصول إلى الخدمة أو استخدامها.",
    },
  "2. Scope of this Privacy Policy": {
    en: "2. Scope of this Privacy Policy",
    ar: "٢. نطاق سياسة الخصوصية هذه",
  },
  "This Privacy Policy applies to all individuals and entities (”Users”) who interact with the Service worldwide, including but not limited to users in the United Kingdom (UK), the Kingdom of Saudi Arabia (KSA), the United Arab Emirates (UAE), the State of Qatar, and other jurisdictions where we operate. We are committed to complying with all applicable data protection laws and regulations, including:":
    {
      en: "This Privacy Policy applies to all individuals and entities (”Users”) who interact with the Service worldwide, including but not limited to users in the United Kingdom (UK), the Kingdom of Saudi Arabia (KSA), the United Arab Emirates (UAE), the State of Qatar, and other jurisdictions where we operate. We are committed to complying with all applicable data protection laws and regulations, including:",
      ar: "تنطبق سياسة الخصوصية هذه على جميع الأفراد والكيانات ('المستخدمين') الذين يتفاعلون مع الخدمة على مستوى العالم، بما في ذلك على سبيل المثال لا الحصر المستخدمين في المملكة المتحدة، المملكة العربية السعودية، الإمارات العربية المتحدة، دولة قطر، والولايات القضائية الأخرى التي نعمل بها. نحن ملتزمون بالامتثال لجميع قوانين ولوائح حماية البيانات المعمول بها، بما في ذلك:",
    },
  "Data Protection Act 2018 and UK General Data Protection Regulation (UK GDPR). NHS Data Security and Protection Toolkit requirements (if applicable).":
    {
      en: "Data Protection Act 2018 and UK General Data Protection Regulation (UK GDPR). NHS Data Security and Protection Toolkit requirements (if applicable).",
      ar: "قانون حماية البيانات لعام 2018 ولائحة حماية البيانات العامة في المملكة المتحدة (UK GDPR). متطلبات أداة حماية البيانات والأمن الخاصة بالخدمات الصحية الوطنية (إن وجدت).",
    },
  "European Union:": {
    en: "European Union:",
    ar: "الاتحاد الأوروبي:",
  },
  "General Data Protection Regulation (GDPR).": {
    en: "General Data Protection Regulation (GDPR).",
    ar: "لائحة تنظيم حماية البيانات العامة (GDPR).",
  },
  "United States:": {
    en: "United States:",
    ar: "الولايات المتحدة:",
  },
  "California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA) (if applicable).":
    {
      en: "California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA) (if applicable).",
      ar: "قانون خصوصية المستهلك في كاليفورنيا (CCPA) وقانون حقوق الخصوصية في كاليفورنيا (CPRA) (إذا كان ذلك مناسبًا).",
    },
  "Personal Data Protection Law (PDPL).": {
    en: "Personal Data Protection Law (PDPL).",
    ar: "قانون حماية البيانات الشخصية (PDPL).",
  },
  "3. Information We Collect": {
    en: "3. Information We Collect",
    ar: "٣. المعلومات التي نقوم بجمعها",
  },
  "We collect personal data to provide and improve the Service, to communicate with you, and to comply with legal obligations.":
    {
      en: "We collect personal data to provide and improve the Service, to communicate with you, and to comply with legal obligations.",
      ar: "نجمع البيانات الشخصية بهدف تقديم الخدمة وتحسينها، والتواصل معكم، والامتثال للالتزامات القانونية.",
    },
  "3.1 Personal Data You Provide to Us": {
    en: "3.1 Personal Data You Provide to Us",
    ar: "٣.١ البيانات الشخصية التي تقدمها لنا",
  },
  "We may collect personal data that you voluntarily provide when you:": {
    en: "We may collect personal data that you voluntarily provide when you:",
    ar: "قد نجمع البيانات الشخصية التي تقدمها طوعاً عندما:",
  },
  "Register for an Account: Including your name, email address, telephone number, job title, company name, and password.":
    {
      en: "Register for an Account: Including your name, email address, telephone number, job title, company name, and password.",
      ar: "تسجيل حساب: قم بإدخال اسمك، عنوان بريدك الإلكتروني، رقم هاتفك، مسمّى وظيفيّ، اسم الشركة، وكلمة المرور.",
    },
  "Use the Service: Such as content you upload, information you enter into our platform, and preferences you set.":
    {
      en: "Use the Service: Such as content you upload, information you enter into our platform, and preferences you set.",
      ar: "استخدام الخدمة: مثل المحتوى الذي تقوم بتحميله، والمعلومات التي تدخلها على منصتنا، والتفضيلات التي تقوم بتعيينها.",
    },
  "Communicate with Us: Including records of correspondence, support requests, and feedback.":
    {
      en: "Communicate with Us: Including records of correspondence, support requests, and feedback.",
      ar: "تواصل معنا: يتضمن سجلات المراسلات وطلبات الدعم والتعليقات.",
    },
  "Make a Purchase: Billing information, such as billing address and payment details (processed securely by third-party payment processors).":
    {
      en: "Make a Purchase: Billing information, such as billing address and payment details (processed securely by third-party payment processors).",
      ar: "قم بعملية الشراء: معلومات الفوترة، مثل عنوان الفوترة وتفاصيل الدفع (يتم معالجتها بشكل آمن بواسطة معالجي الدفع من أطراف ثالثة).",
    },
  "3.2 Information Collected Automatically": {
    en: "3.2 Information Collected Automatically",
    ar: "٣.٢ المعلومات التي يتم جمعها تلقائيًا",
  },
  "When you interact with the Service, we may automatically collect certain information about your device and usage, including:":
    {
      en: "When you interact with the Service, we may automatically collect certain information about your device and usage, including:",
      ar: "عند تفاعلك مع الخدمة، قد نقوم تلقائيًا بجمع بعض المعلومات حول جهازك والاستخدام، بما في ذلك:",
    },
  "Usage Data: Details about how you use the Service, such as pages viewed, features used, and actions taken.":
    {
      en: "Usage Data: Details about how you use the Service, such as pages viewed, features used, and actions taken.",
      ar: "بيانات الاستخدام: تفاصيل حول كيفية استخدامك للخدمة، مثل الصفحات التي تم الاطلاع عليها، والميزات المستخدمة، والإجراءات المتخذة.",
    },
  "Technical Data: IP address, browser type and version, time zone setting, operating system, and platform.":
    {
      en: "Technical Data: IP address, browser type and version, time zone setting, operating system, and platform.",
      ar: "البيانات الفنية: عنوان بروتوكول الإنترنت (IP)، نوع المتصفح وإصداره، إعداد المنطقة الزمنية، نظام التشغيل، والمنصة.",
    },
  "Device Information: Device type, unique device identifiers, and mobile network information.":
    {
      en: "Device Information: Device type, unique device identifiers, and mobile network information.",
      ar: "معلومات الجهاز: نوع الجهاز، معرفات الجهاز الفريدة، ومعلومات شبكة الهاتف المحمول.",
    },
  "Location Data: Approximate location based on your IP address.": {
    en: "Location Data: Approximate location based on your IP address.",
    ar: "بيانات الموقع: الموقع التقريبي بناءً على عنوان IP الخاص بك.",
  },
  "3.3 Cookies and Similar Technologies": {
    en: "3.3 Cookies and Similar Technologies",
    ar: "ملفات تعريف الارتباط والتقنيات المماثلة 3.3",
  },
  "We use cookies, pixels, and other tracking technologies to collect information about your interactions with the Service to:":
    {
      en: "We use cookies, pixels, and other tracking technologies to collect information about your interactions with the Service to:",
      ar: "نستخدم ملفات تعريف الارتباط (الكوكيز) وتقنيات البكسل وغيرها لتعقب وتسجيل المعلومات حول تفاعلاتك مع الخدمة من أجل:",
    },
  "Enhance Functionality: Remember your preferences and settings.": {
    en: "Enhance Functionality: Remember your preferences and settings.",
    ar: "تعزيز الوظائف: تذكر تفضيلاتك وإعداداتك.",
  },
  "Analyze Usage: Understand how you use the Service to improve performance.": {
    en: "Analyze Usage: Understand how you use the Service to improve performance.",
    ar: "تحليل الاستخدام: فهم كيفية استخدامك للخدمة لتحسين الأداء.",
  },
  "Personalize Content: Deliver tailored content and recommendations.": {
    en: "Personalize Content: Deliver tailored content and recommendations.",
    ar: "تخصيص المحتوى: تقديم محتوى وتوصيات مخصصة.",
  },
  "Marketing: Provide relevant advertisements.": {
    en: "Marketing: Provide relevant advertisements.",
    ar: "تسويق: تقديم الإعلانات ذات الصلة.",
  },
  "You can manage your cookie preferences through your browser settings. For more details, please refer to our Cookies and Tracking Policy.":
    {
      en: "You can manage your cookie preferences through your browser settings. For more details, please refer to our Cookies and Tracking Policy.",
      ar: "يمكنك إدارة تفضيلات ملفات تعريف الارتباط من خلال إعدادات المتصفح الخاص بك. لمزيد من التفاصيل، يُرجى الرجوع إلى سياسة ملفات تعريف الارتباط والتتبع الخاصة بنا.",
    },
  "3.4 Information from Third Parties": {
    en: "3.4 Information from Third Parties",
    ar: "٣.٤ المعلومات من الأطراف الثالثة",
  },
  "We may receive personal data about you from third parties, such as:": {
    en: "We may receive personal data about you from third parties, such as:",
    ar: "قد نتلقى بيانات شخصية عنك من أطراف ثالثة مثل:",
  },
  "Service Providers: Analytics providers, advertising networks, and payment processors.":
    {
      en: "Service Providers: Analytics providers, advertising networks, and payment processors.",
      ar: "مقدمو الخدمة: مزودو التحليلات، شبكات الإعلانات، ومعالجو الدفع.",
    },
  "Third-Party Integrations: If you link your account with third-party services (e.g., Google, LinkedIn), we may receive certain information from those services.":
    {
      en: "Third-Party Integrations: If you link your account with third-party services (e.g., Google, LinkedIn), we may receive certain information from those services.",
      ar: "التكامل مع الجهات الخارجية: في حال ربط حسابك بخدمات خارجية (مثل جوجل، لينكد إن)، قد نستلم بعض المعلومات من هذه الخدمات.",
    },
  "Public Sources: Public databases and social media platforms, in accordance with applicable laws.":
    {
      en: "Public Sources: Public databases and social media platforms, in accordance with applicable laws.",
      ar: "المصادر العامة: قواعد البيانات العامة ومنصات التواصل الاجتماعي، وفقاً للقوانين المعمول بها.",
    },
  "3.5 Special Categories of Personal Data": {
    en: "3.5 Special Categories of Personal Data",
    ar: "٣.٥ الفئات الخاصة من البيانات الشخصية",
  },
  "We generally do not collect special categories of personal data unless necessary and with your explicit consent or as required by law. This may include:":
    {
      en: "We generally do not collect special categories of personal data unless necessary and with your explicit consent or as required by law. This may include:",
      ar: "بشكل عام، لا نقوم بجمع فئات خاصة من البيانات الشخصية إلا إذا كان ذلك ضرورياً ومع موافقتك الصريحة أو حسبما يتطلبه القانون. وقد يشمل ذلك:",
    },
  "Health Information: For clients like the NHS, we may process patient data in compliance with applicable healthcare laws and regulations.":
    {
      en: "Health Information: For clients like the NHS, we may process patient data in compliance with applicable healthcare laws and regulations.",
      ar: "معلومات الصحة: بالنسبة للعملاء مثل هيئة الخدمات الصحية الوطنية (NHS)، قد نقوم بمعالجة بيانات المرضى بما يتوافق مع القوانين واللوائح الصحية المعمول بها.",
    },
  "Other Sensitive Data: Information related to racial or ethnic origin, political opinions, religious beliefs, or biometric data will only be processed with appropriate safeguards.":
    {
      en: "Other Sensitive Data: Information related to racial or ethnic origin, political opinions, religious beliefs, or biometric data will only be processed with appropriate safeguards.",
      ar: "البيانات الحساسة الأخرى: سيتم معالجة المعلومات المتعلقة بالأصل العرقي أو الإثني، الآراء السياسية، المعتقدات الدينية، أو البيانات البيومترية فقط مع ضمانات مناسبة.",
    },
  "4. How We Use Your Information": {
    en: "4. How We Use Your Information",
    ar: "٤. كيفية استخدامنا لمعلوماتك",
  },
  "We use your personal data for the following purposes:": {
    en: "We use your personal data for the following purposes:",
    ar: "نستخدم بياناتك الشخصية للأغراض التالية:",
  },
  "4.1 Service Delivery": {
    en: "4.1 Service Delivery",
    ar: "تقديم الخدمة 4.1",
  },
  "Account Management: To create, verify, and manage your account.": {
    en: "Account Management: To create, verify, and manage your account.",
    ar: "إدارة الحساب: لإنشاء حسابك والتحقق منه وإدارته.",
  },
  "Provide the Service: To enable you to access and use the features of the Service.":
    {
      en: "Provide the Service: To enable you to access and use the features of the Service.",
      ar: "تقديم الخدمة: لتمكينك من الوصول إلى واستخدام ميزات الخدمة.",
    },
  "Customer Support: To respond to your inquiries, troubleshoot issues, and provide technical assistance.":
    {
      en: "Customer Support: To respond to your inquiries, troubleshoot issues, and provide technical assistance.",
      ar: "خدمة العملاء: للرد على استفساراتكم، وحل المشكلات، وتقديم المساعدة الفنية.",
    },
  "4.2 Service Improvement and Development": {
    en: "4.2 Service Improvement and Development",
    ar: "٤.٢ تحسين وتطوير الخدمة",
  },
  "Enhance User Experience: To personalize your experience and deliver content relevant to your interests.":
    {
      en: "Enhance User Experience: To personalize your experience and deliver content relevant to your interests.",
      ar: "تحسين تجربة المستخدم: لتخصيص تجربتك وتقديم محتوى يتناسب مع اهتماماتك.",
    },
  "Analytics and Research: To analyze usage patterns and improve the functionality and quality of the Service.":
    {
      en: "Analytics and Research: To analyze usage patterns and improve the functionality and quality of the Service.",
      ar: "التحليلات والأبحاث: لتحليل أنماط الاستخدام وتحسين وظائف وجودة الخدمة.",
    },
  "Feedback and Surveys: To solicit feedback and conduct surveys for service improvement.":
    {
      en: "Feedback and Surveys: To solicit feedback and conduct surveys for service improvement.",
      ar: "التغذية الراجعة والاستبانات: لجمع التغذية الراجعة وإجراء الاستبانات لتحسين الخدمة.",
    },
  "4.3 Communication": {
    en: "4.3 Communication",
    ar: "٤.٣ التواصل",
  },
  "Administrative Communications: To send you important information regarding the Service, such as updates, security alerts, and changes to our policies.":
    {
      en: "Administrative Communications: To send you important information regarding the Service, such as updates, security alerts, and changes to our policies.",
      ar: "الاتصالات الإدارية: لإرسال معلومات هامة تتعلق بالخدمة، مثل التحديثات، التنبيهات الأمنية، والتغييرات في سياساتنا.",
    },
  "Marketing Communications: To inform you about promotions, events, or other news related to Compelion, subject to your communication preferences. You may opt-out at any time.":
    {
      en: "Marketing Communications: To inform you about promotions, events, or other news related to Compelion, subject to your communication preferences. You may opt-out at any time.",
      ar: "التواصل التسويقي: لإبلاغكم بالعروض والفعاليات أو الأخبار الأخرى المتعلقة بشركة Compelion، وذلك وفقاً لتفضيلاتكم في التواصل. يمكنكم إلغاء الاشتراك في أي وقت.",
    },
  "4.4 Legal and Regulatory Compliance": {
    en: "4.4 Legal and Regulatory Compliance",
    ar: "٤.٤ الامتثال القانوني والتنظيمي",
  },
  "Compliance: To comply with legal obligations, regulations, and lawful requests from governmental authorities.":
    {
      en: "Compliance: To comply with legal obligations, regulations, and lawful requests from governmental authorities.",
      ar: "الامتثال: للامتثال للالتزامات القانونية والأنظمة والطلبات القانونية من الجهات الحكومية.",
    },
  "Enforcement: To enforce our Terms of Use and other agreements.": {
    en: "Enforcement: To enforce our Terms of Use and other agreements.",
    ar: "التنفيذ: لضمان الامتثال لشروط الاستخدام الخاصة بنا والاتفاقيات الأخرى.",
  },
  "Protection of Rights: To protect the rights, property, or safety of Compelion, our users, or others.":
    {
      en: "Protection of Rights: To protect the rights, property, or safety of Compelion, our users, or others.",
      ar: "حماية الحقوق: لحماية حقوق أو ممتلكات أو سلامة كومبليون أو مستخدمينا أو الآخرين.",
    },
  "4.5 Security and Fraud Prevention": {
    en: "4.5 Security and Fraud Prevention",
    ar: "٤٫٥ الأمان ومنع الاحتيال",
  },
  "Security Measures: To monitor and prevent security breaches, fraud, and unauthorized activities.":
    {
      en: "Security Measures: To monitor and prevent security breaches, fraud, and unauthorized activities.",
      ar: "إجراءات الأمن: لمراقبة ومنع الاختراقات الأمنية، والاحتيال، والأنشطة غير المصرح بها.",
    },
  "Verification: To verify your identity and ensure the integrity of the Service.":
    {
      en: "Verification: To verify your identity and ensure the integrity of the Service.",
      ar: "التحقق: للتحقق من هويتك وضمان سلامة الخدمة.",
    },
  "5. Legal Bases for Processing Personal Data": {
    en: "5. Legal Bases for Processing Personal Data",
    ar: "٥. الأسس القانونية لمعالجة البيانات الشخصية",
  },
  "We process your personal data on the following legal bases, as applicable:":
    {
      en: "We process your personal data on the following legal bases, as applicable:",
      ar: "نعالج بياناتك الشخصية بناءً على الأسس القانونية التالية، حسب ما ينطبق:",
    },
  "Consent: You have provided explicit consent for specific purposes.": {
    en: "Consent: You have provided explicit consent for specific purposes.",
    ar: "الموافقة: لقد قدمت موافقتك الصريحة لأغراض محددة.",
  },
  "Contractual Necessity: Processing is necessary for the performance of a contract with you or to take steps at your request before entering into a contract.":
    {
      en: "Contractual Necessity: Processing is necessary for the performance of a contract with you or to take steps at your request before entering into a contract.",
      ar: "ضرورة تعاقدية: تُعدّ المعالجة ضرورية لأداء العقد المبرم بيننا أو لاتخاذ إجراءات بناءً على طلبك قبل الدخول في العقد.",
    },
  "Legal Obligation: Processing is necessary to comply with legal obligations.":
    {
      en: "Legal Obligation: Processing is necessary to comply with legal obligations.",
      ar: "الالتزام القانوني: تتطلب المعالجة الامتثال للالتزامات القانونية.",
    },
  "Legitimate Interests: Processing is necessary for our legitimate interests or those of a third party, provided your interests and fundamental rights do not override those interests.":
    {
      en: "Legitimate Interests: Processing is necessary for our legitimate interests or those of a third party, provided your interests and fundamental rights do not override those interests.",
      ar: "المصالح المشروعة: تكون المعالجة ضرورية لمصالحنا المشروعة أو لمصالح طرف ثالث، شريطة ألا تطغى مصالحك وحقوقك الأساسية على تلك المصالح.",
    },
  "6. Your Rights and Choices": {
    en: "6. Your Rights and Choices",
    ar: "٦. حقوقك واختياراتك",
  },
  "Subject to applicable laws, you have the following rights regarding your personal data:":
    {
      en: "Subject to applicable laws, you have the following rights regarding your personal data:",
      ar: "بموجب القوانين المعمول بها، لديك الحقوق التالية فيما يتعلق ببياناتك الشخصية:",
    },
  "6.1 Right to Access": {
    en: "6.1 Right to Access",
    ar: "٦.١ حق الوصول",
  },
  "You may request confirmation of whether we process your personal data and access to the data we hold about you.":
    {
      en: "You may request confirmation of whether we process your personal data and access to the data we hold about you.",
      ar: "يمكنك طلب تأكيد ما إذا كنا نعالج بياناتك الشخصية أم لا والوصول إلى البيانات التي نحتفظ بها عنك.",
    },
  "6.2 Right to Rectification": {
    en: "6.2 Right to Rectification",
    ar: "حق التصحيح 6.2",
  },
  "You have the right to request the correction of inaccurate or incomplete personal data.":
    {
      en: "You have the right to request the correction of inaccurate or incomplete personal data.",
      ar: "لديك الحق في طلب تصحيح البيانات الشخصية غير الدقيقة أو غير المكتملة.",
    },
  "6.3 Right to Erasure": {
    en: "6.3 Right to Erasure",
    ar: "6.3 الحق في المسح",
  },
  "You may request the deletion of your personal data, subject to certain conditions.":
    {
      en: "You may request the deletion of your personal data, subject to certain conditions.",
      ar: "يمكنك طلب حذف بياناتك الشخصية، وذلك وفقًا لشروط محددة.",
    },
  "6.4 Right to Restriction of Processing": {
    en: "6.4 Right to Restriction of Processing",
    ar: "٦.٤ الحق في تقييد المعالجة",
  },
  "You may request the restriction of processing your personal data under certain circumstances.":
    {
      en: "You may request the restriction of processing your personal data under certain circumstances.",
      ar: "يمكنك طلب تقييد معالجة بياناتك الشخصية في ظل ظروف معينة.",
    },
  "6.5 Right to Data Portability": {
    en: "6.5 Right to Data Portability",
    ar: "٦.٥ حق نقل البيانات",
  },
  "You have the right to receive your personal data in a structured, commonly used, and machine-readable format.":
    {
      en: "You have the right to receive your personal data in a structured, commonly used, and machine-readable format.",
      ar: "لك الحق في استلام بياناتك الشخصية بتنسيق منظم ومستخدم بشكل شائع ويمكن قراءته آليًا.",
    },
  "6.6 Right to Object": {
    en: "6.6 Right to Object",
    ar: "٦.٦ الحق في الاعتراض",
  },
  "You may object to the processing of your personal data on grounds relating to your particular situation, subject to certain exceptions.":
    {
      en: "You may object to the processing of your personal data on grounds relating to your particular situation, subject to certain exceptions.",
      ar: "يمكنك الاعتراض على معالجة بياناتك الشخصية لأسباب تتعلق بوضعك الخاص، مع مراعاة بعض الاستثناءات.",
    },
  "6.7 Right to Withdraw Consent": {
    en: "6.7 Right to Withdraw Consent",
    ar: "٦.٧ الحق في سحب الموافقة",
  },
  "If we process your personal data based on consent, you have the right to withdraw your consent at any time.":
    {
      en: "If we process your personal data based on consent, you have the right to withdraw your consent at any time.",
      ar: "إذا قمنا بمعالجة بياناتك الشخصية بناءً على موافقتك، يحق لك سحب هذه الموافقة في أي وقت.",
    },
  "6.8 Right to File a Complaint": {
    en: "6.8 Right to File a Complaint",
    ar: "٦.٨ *الحق في تقديم شكوى*",
  },
  "If you believe we have violated your rights regarding your personal data, you have the right to lodge a complaint with a supervisory authority.":
    {
      en: "If you believe we have violated your rights regarding your personal data, you have the right to lodge a complaint with a supervisory authority.",
      ar: "إذا كنت تعتقد أننا قد انتهكنا حقوقك فيما يتعلق ببياناتك الشخصية، فإن لديك الحق في تقديم شكوى لدى السلطة الإشرافية المختصة.",
    },
  "6.9 Exercising Your Rights": {
    en: "6.9 Exercising Your Rights",
    ar: "٦.٩ ممارسة حقوقك",
  },
  "To exercise any of your rights, please contact us using the contact information provided below. We may ask you to verify your identity before responding to your request.":
    {
      en: "To exercise any of your rights, please contact us using the contact information provided below. We may ask you to verify your identity before responding to your request.",
      ar: "لممارسة أي من حقوقك، يُرجى التواصل معنا باستخدام معلومات الاتصال المذكورة أدناه. قد نطلب منك تأكيد هويتك قبل الاستجابة لطلبك.",
    },
  "7. Data Retention": {
    en: "7. Data Retention",
    ar: "٧. الاحتفاظ بالبيانات",
  },
  "We retain your personal data only for as long as necessary to fulfill the purposes for which we collected it, including for the purposes of satisfying any legal, accounting, or reporting requirements. The criteria used to determine our retention periods include:":
    {
      en: "We retain your personal data only for as long as necessary to fulfill the purposes for which we collected it, including for the purposes of satisfying any legal, accounting, or reporting requirements. The criteria used to determine our retention periods include:",
      ar: "نحتفظ ببياناتك الشخصية فقط للمدة اللازمة لتحقيق الأغراض التي جمعناها من أجلها، بما في ذلك من أجل تلبية أي متطلبات قانونية أو محاسبية أو تقارير. تشمل المعايير المستخدمة لتحديد فترات الاحتفاظ لدينا:",
    },
  "The length of time we have an ongoing relationship with you and provide the Service to you.":
    {
      en: "The length of time we have an ongoing relationship with you and provide the Service to you.",
      ar: "مدة استمرار علاقتنا معك وتقديم الخدمة لك.",
    },
  "The existence of a legal obligation to retain the data.": {
    en: "The existence of a legal obligation to retain the data.",
    ar: "وجود التزام قانوني للاحتفاظ بالبيانات.",
  },
  "Our legitimate interests in retaining the data for the purposes outlined in this Privacy Policy.":
    {
      en: "Our legitimate interests in retaining the data for the purposes outlined in this Privacy Policy.",
      ar: "مصالحنا المشروعة في الاحتفاظ بالبيانات للأغراض الموضحة في سياسة الخصوصية هذه.",
    },
  "8. Data Security": {
    en: "8. Data Security",
    ar: "٨. أمن البيانات",
  },
  "We implement reasonable administrative, technical, and physical measures to protect your personal data against unauthorized access, destruction, loss, alteration, or misuse. While we strive to protect your personal data, no method of transmission over the internet or electronic storage is 100% secure. Therefore, we cannot guarantee its absolute security.":
    {
      en: "We implement reasonable administrative, technical, and physical measures to protect your personal data against unauthorized access, destruction, loss, alteration, or misuse. While we strive to protect your personal data, no method of transmission over the internet or electronic storage is 100% secure. Therefore, we cannot guarantee its absolute security.",
      ar: "نقوم بتنفيذ تدابير إدارية وتقنية وفيزيائية معقولة لحماية بياناتك الشخصية من الوصول غير المصرح به أو التدمير أو الفقد أو التعديل أو سوء الاستخدام. بينما نسعى لحماية بياناتك الشخصية، إلا أنه لا توجد طريقة لنقل البيانات عبر الإنترنت أو تخزينها إلكترونيًا تضمن الأمان الكامل بنسبة 100%. ولذلك، لا يمكننا ضمان أمنها بشكل مطلق.",
    },
  "9. Changes to This Privacy Policy": {
    en: "9. Changes to This Privacy Policy",
    ar: "٩. تغييرات في سياسة الخصوصية هذه",
  },
  "We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the":
    {
      en: "We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the",
      ar: "قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنقوم بإعلامك بأي تغييرات من خلال نشر سياسة الخصوصية الجديدة على هذه الصفحة وتحديث",
    },
  "Effective Date": {
    en: "Effective Date",
    ar: "تاريخ السريان",
  },
  "at the top. You are advised to review this Privacy Policy periodically for any changes. Your continued use of the Service after the posting of changes constitutes your acceptance of such changes.":
    {
      en: "at the top. You are advised to review this Privacy Policy periodically for any changes. Your continued use of the Service after the posting of changes constitutes your acceptance of such changes.",
      ar: "في الأعلى، ننصحك بمراجعة سياسة الخصوصية هذه بشكل دوري لمتابعة أي تحديثات. استمرارك في استخدام الخدمة بعد نشر التغييرات يعد قبولاً منك لهذه التغييرات.",
    },
  "10. Contact Us": {
    en: "10. Contact Us",
    ar: "١٠. اتصل بنا",
  },
  "If you have any questions about this Privacy Policy or our privacy practices, please contact us:":
    {
      en: "If you have any questions about this Privacy Policy or our privacy practices, please contact us:",
      ar: "إذا كان لديكم أي أسئلة بخصوص سياسة الخصوصية هذه أو ممارساتنا المتعلقة بالخصوصية، يرجى التواصل معنا:",
    },
  "Email:": {
    en: "Email:",
    ar: "البريد الإلكتروني:",
  },
  "Choose the right plan for your team": {
    en: "Choose the right plan for your team",
    ar: "اختر الخطة المناسبة لفريقك",
  },
  "User Type": {
    en: "User Type",
    ar: "نوع المستخدم",
  },
  Organisation: {
    en: "Organisation",
    ar: "منظمة",
  },
  "Next Billing Date": {
    en: "Next Billing Date",
    ar: "تاريخ الفاتورة القادم",
  },
  "Payment Method": {
    en: "Payment Method",
    ar: "طريقة الدفع",
  },
  "Subscribed On": {
    en: "Subscribed On",
    ar: "مشترك منذ",
  },
  "Manage Subscription": {
    en: "Manage Subscription",
    ar: "إدارة الاشتراك",
  },
  "Needs Improvement": {
    en: "Needs Improvement",
    ar: "يحتاج إلى تحسين",
  },
  Security: {
    en: "Security",
    ar: "الأمان",
  },
  "Security at YourCompany": {
    en: "Security at YourCompany",
    ar: "الأمان في YourCompany",
  },
  "Your trust is our top priority. We employ industry-leading security measures to protect your data and ensure business continuity":
    {
      en: "Your trust is our top priority. We employ industry-leading security measures to protect your data and ensure business continuity",
      ar: "ثقتكم هي أولويتنا القصوى. نحن نعتمد على أحدث التدابير الأمنية في الصناعة لحماية بياناتكم وضمان استمرارية العمل.",
    },
  "Enterprise-Grade Security": {
    en: "Enterprise-Grade Security",
    ar: "أمان بمستوى الشركات الكبرى",
  },
  "We're committed to providing the highest level of security for your data and operations. Our comprehensive approach ensures that your information is protected at every level":
    {
      en: "We're committed to providing the highest level of security for your data and operations. Our comprehensive approach ensures that your information is protected at every level",
      ar: "نحن ملتزمون بتوفير أعلى مستويات الأمان لبياناتك وعملياتك. يضمن نهجنا الشامل حماية معلوماتك على كافة المستويات",
    },
  "Our Security Features": {
    en: "Our Security Features",
    ar: "ميزات الأمان الخاصة بنا",
  },
  "End-to-End Encryption": {
    en: "End-to-End Encryption",
    ar: "التشفير الشامل (End-to-End Encryption)",
  },
  "Your data is encrypted in transit and at rest using AES 256-bit encryption, ensuring that your information remains confidential and secure":
    {
      en: "Your data is encrypted in transit and at rest using AES 256-bit encryption, ensuring that your information remains confidential and secure",
      ar: "بياناتك مُشفرة أثناء النقل وفي حالة الثبات باستخدام تشفير AES 256 بت، مما يضمن بقاء معلوماتك سرية وآمنة.",
    },
  "Regular Audits": {
    en: "Regular Audits",
    ar: "التدقيقات الدورية",
  },
  "We conduct regular security audits and penetration testing to identify and address potential vulnerabilities in our systems":
    {
      en: "We conduct regular security audits and penetration testing to identify and address potential vulnerabilities in our systems",
      ar: "نقوم بإجراء تدقيقات أمنية وفحوص اختراق بانتظام لتحديد ومعالجة الثغرات المحتملة في أنظمتنا.",
    },
  "Secure Infrastructure": {
    en: "Secure Infrastructure",
    ar: "البنية التحتية الآمنة",
  },
  "Our infrastructure is hosted in SOC 2 compliant data centers with 24/7 monitoring, physical security, and redundant power systems":
    {
      en: "Our infrastructure is hosted in SOC 2 compliant data centers with 24/7 monitoring, physical security, and redundant power systems",
      ar: "تُستضاف بنيتنا التحتية في مراكز بيانات متوافقة مع معايير SOC 2، وتتم مراقبتها على مدار الساعة طوال أيام الأسبوع، مدعومة بأنظمة أمن فيزيائي وأنظمة طاقة احتياطية.",
    },
  "Access Controls": {
    en: "Access Controls",
    ar: "التحكم في الوصول",
  },
  "Robust access controls and multi-factor authentication ensure that only authorized personnel can access sensitive data and systems":
    {
      en: "Robust access controls and multi-factor authentication ensure that only authorized personnel can access sensitive data and systems",
      ar: "تضمن ضوابط الوصول القوية والمصادقة متعددة العوامل أن الأفراد المصرح لهم فقط يمكنهم الوصول إلى البيانات والأنظمة الحساسة.",
    },
  "Data Sovereignty": {
    en: "Data Sovereignty",
    ar: "سيادة البيانات",
  },
  "All data is stored within compliant AWS Regions to ensure adherence to GDPR and NHS guidelines":
    {
      en: "All data is stored within compliant AWS Regions to ensure adherence to GDPR and NHS guidelines",
      ar: "جميع البيانات مُخزّنة داخل مناطق AWS المتوافقة لضمان الامتثال لإرشادات GDPR وNHS.",
    },
  "Vulnerability Management": {
    en: "Vulnerability Management",
    ar: "إدارة الثغرات الأمنية",
  },
  "Our dedicated security team continuously monitors and addresses potential vulnerabilities to keep your data safe":
    {
      en: "Our dedicated security team continuously monitors and addresses potential vulnerabilities to keep your data safe",
      ar: "يقوم فريق الأمان المتخصص لدينا بمراقبة ومعالجة الثغرات المحتملة باستمرار لضمان حماية بياناتك.",
    },
  "Compliance and Certifications": {
    en: "Compliance and Certifications",
    ar: "الامتثال والشهادات",
  },
  "We adhere to the highest industry standards and have obtained certifications to ensure our security practices meet or exceed regulatory requirements":
    {
      en: "We adhere to the highest industry standards and have obtained certifications to ensure our security practices meet or exceed regulatory requirements",
      ar: "نحن نلتزم بأعلى معايير الصناعة وقد حصلنا على الشهادات التي تضمن أن ممارساتنا الأمنية تلبي أو تتجاوز المتطلبات التنظيمية.",
    },
  "ISO 27001": {
    en: "ISO 27001",
    ar: "المعيار 27001 لنظام إدارة أمن المعلومات (ISO 27001)",
  },
  "SOC 2 Type II": {
    en: "SOC 2 Type II",
    ar: "تدقيق الامتثال SOC 2 النوع الثاني",
  },
  "GDPR Compliant": {
    en: "GDPR Compliant",
    ar: "متوافق مع اللائحة العامة لحماية البيانات (GDPR)",
  },
  "HIPAA Compliant": {
    en: "HIPAA Compliant",
    ar: "متوافق مع معايير الهيبّا (HIPAA)",
  },
  "PCI DSS": {
    en: "PCI DSS",
    ar: "معيار أمان بيانات صناعة بطاقات الدفع (PCI DSS)",
  },
  "Privacy Shield": {
    en: "Privacy Shield",
    ar: "درع الخصوصية",
  },
  "Data Protection": {
    en: "Data Protection",
    ar: "حماية البيانات",
  },
  "Data Privacy": {
    en: "Data Privacy",
    ar: "خصوصية البيانات",
  },
  "We adhere to strict data privacy policies and never sell your information to third parties. Our privacy-by-design approach ensures that your data is protected at every stage":
    {
      en: "We adhere to strict data privacy policies and never sell your information to third parties. Our privacy-by-design approach ensures that your data is protected at every stage",
      ar: "نلتزم بسياسات صارمة لحماية خصوصية البيانات ولا نقوم أبدًا ببيع معلوماتك لأطراف ثالثة. يضمن نهج الخصوصية عن طريق التصميم حماية بياناتك في كل مرحلة.",
    },
  "Data Redundancy": {
    en: "Data Redundancy",
    ar: "تكرار البيانات",
  },
  "Your data is replicated across multiple secure locations to ensure business continuity and rapid disaster recovery in case of unforeseen events":
    {
      en: "Your data is replicated across multiple secure locations to ensure business continuity and rapid disaster recovery in case of unforeseen events",
      ar: "يتم تكرار بياناتك عبر مواقع آمنة متعددة لضمان استمرارية الأعمال والتعافي السريع من الكوارث في حالة حدوث أحداث غير متوقعة.",
    },
  "Regular Backups": {
    en: "Regular Backups",
    ar: "النسخ الاحتياطي المنتظم",
  },
  "We perform regular backups of your data to prevent loss and ensure quick recovery if needed. Our backup systems are also encrypted and tested regularly":
    {
      en: "We perform regular backups of your data to prevent loss and ensure quick recovery if needed. Our backup systems are also encrypted and tested regularly",
      ar: "نقوم بتنفيذ عمليات نسخ احتياطي منتظمة لبياناتك لمنع فقدانها وضمان استعادتها بسرعة عند الحاجة. كما أن أنظمة النسخ الاحتياطي لدينا مشفرة ويتم اختبارها بانتظام.",
    },
  "Data Isolation": {
    en: "Data Isolation",
    ar: "عزل البيانات",
  },
  "We maintain strict data isolation practices to ensure that your data remains separate and secure from other customers' data":
    {
      en: "We maintain strict data isolation practices to ensure that your data remains separate and secure from other customers' data",
      ar: "نحن نحافظ على ممارسات صارمة لعزل البيانات لضمان بقاء بياناتك منفصلة وآمنة عن بيانات العملاء الآخرين.",
    },
  "Our Security Practices": {
    en: "Our Security Practices",
    ar: "ممارسات الأمان الخاصة بنا",
  },
  "Workload Classification": {
    en: "Workload Classification",
    ar: "تصنيف عبء العمل",
  },
  "We classify workloads based on data sensitivity, availability, and processing needs to ensure appropriate security measures are applied":
    {
      en: "We classify workloads based on data sensitivity, availability, and processing needs to ensure appropriate security measures are applied",
      ar: "نقوم بتصنيف أعباء العمل بناءً على حساسية البيانات، وتوافرها، واحتياجات المعالجة لضمان تطبيق التدابير الأمنية المناسبة.",
    },
  "Employee Security Training": {
    en: "Employee Security Training",
    ar: "تدريب أمني للموظفين",
  },
  "All our employees undergo regular security awareness training to ensure they understand and follow best practices in data protection and security":
    {
      en: "All our employees undergo regular security awareness training to ensure they understand and follow best practices in data protection and security",
      ar: "يتلقى جميع موظفينا تدريبًا منتظمًا على الوعي الأمني لضمان فهمهم واتباعهم لأفضل الممارسات في حماية البيانات والأمن.",
    },
  "Incident Response": {
    en: "Incident Response",
    ar: "الاستجابة للحوادث",
  },
  "We have a comprehensive incident response plan in place to quickly address and mitigate any potential security issues":
    {
      en: "We have a comprehensive incident response plan in place to quickly address and mitigate any potential security issues",
      ar: "لدينا خطة استجابة شاملة للحوادث مُعدة لسرعة التعامل مع أي مشكلات أمنية محتملة وتخفيف آثارها.",
    },
  "Continuous Monitoring": {
    en: "Continuous Monitoring",
    ar: "المراقبة المستمرة",
  },
  "Our security operations center provides 24/7 monitoring of our systems to detect and respond to potential threats in real-time":
    {
      en: "Our security operations center provides 24/7 monitoring of our systems to detect and respond to potential threats in real-time",
      ar: "يقوم مركز عمليات الأمان لدينا بمراقبة أنظمتنا على مدار الساعة للكشف عن التهديدات المحتملة والاستجابة لها في الوقت الفعلي.",
    },
  "Our Commitment to Transparency": {
    en: "Our Commitment to Transparency",
    ar: "التزامنا بالشفافية",
  },
  "We believe in being transparent about our security practices and any incidents that may occur. We provide":
    {
      en: "We believe in being transparent about our security practices and any incidents that may occur. We provide",
      ar: "نحن نؤمن بأهمية الشفافية فيما يتعلق بممارساتنا الأمنية وأي حوادث قد تحدث. نحن نوفر",
    },
  "Regular security updates and notifications": {
    en: "Regular security updates and notifications",
    ar: "تحديثات وإشعارات الأمان الدورية",
  },
  "A public-facing status page for system availability": {
    en: "A public-facing status page for system availability",
    ar: "صفحة حالة عامة لمراقبة توفر النظام",
  },
  "Detailed post-mortems for any security incidents": {
    en: "Detailed post-mortems for any security incidents",
    ar: "تقارير تفصيلية لما بعد الحوادث الأمنية.",
  },
  "Open communication channels for reporting vulnerabilities": {
    en: "Open communication channels for reporting vulnerabilities",
    ar: "فتح قنوات الاتصال للإبلاغ عن الثغرات الأمنية",
  },
  "Ready to secure your business?": {
    en: "Ready to secure your business?",
    ar: "هل أنت مستعد لتأمين أعمالك؟",
  },
  "Contact our sales team to learn more about our enterprise security features and how we can help protect your valuable data":
    {
      en: "Contact our sales team to learn more about our enterprise security features and how we can help protect your valuable data",
      ar: "تواصل مع فريق المبيعات لدينا لمعرفة المزيد عن ميزات الأمان المتقدمة للمؤسسات وكيف يمكننا مساعدتك في حماية بياناتك القيمة.",
    },
  "Contact Sales": {
    en: "Contact Sales",
    ar: "اتصل بفريق المبيعات",
  },
  "Draft Ideas": {
    en: "Draft Ideas",
    ar: "الأفكار المبدئية",
  },
  "Actual Ideas": {
    en: "Actual Ideas",
    ar: "الأفكار الفعلية",
  },
  "Not Approved": {
    en: "Not Approved",
    ar: "غير معتمد",
  },
  "Created on:": {
    en: "Created on:",
    ar: "تاريخ الإنشاء:",
  },
  "Benefit:": {
    en: "Benefit:",
    ar: "الفائدة:",
  },
  "Cost:": {
    en: "Cost:",
    ar: "التكلفة:",
  },
  "Strategic Theme:": {
    en: "Strategic Theme:",
    ar: "الموضوع الاستراتيجي:",
  },
  "Theme not found": {
    en: "Theme not found",
    ar: "الموضوع غير موجود",
  },
  "Idea Status:": {
    en: "Idea Status:",
    ar: "حالة الفكرة:",
  },
  "Idea Type:": {
    en: "Idea Type:",
    ar: "نوع الفكرة:",
  },
  "Report #": {
    en: "Report #",
    ar: "تقرير #",
  },
  "Score card": {
    en: "Score card",
    ar: "بطاقة الأداء",
  },
  "Invite Accepted!": {
    en: "Invite Accepted!",
    ar: "تم قبول الدعوة!",
  },
  "Invite Declined!": {
    en: "Invite Declined!",
    ar: "تم رفض الدعوة!",
  },
  Accept: {
    en: "Accept",
    ar: "قبول",
  },
  Decline: {
    en: "Decline",
    ar: "رفض",
  },
  "Mark as Unread": {
    en: "Mark as Unread",
    ar: "تحديد كغير مقروء",
  },
  "Mark as Read": {
    en: "Mark as Read",
    ar: "تعليم كمقروءة",
  },
  "Project Analytics": {
    en: "Project Analytics",
    ar: "تحليلات المشروع",
  },
  "Metric View": {
    en: "Metric View",
    ar: "عرض المتريكات",
  },
  Metrics: {
    en: "Metrics",
    ar: "المقاييس",
  },
  "Your Session Expired! Please Login Again!": {
    en: "Your Session Expired! Please Login Again!",
    ar: "انتهت جلستك! يرجى تسجيل الدخول مرة أخرى!",
  },
  "Logged out successfully!": {
    en: "Logged out successfully!",
    ar: "تم تسجيل الخروج بنجاح!",
  },
  "Notification marked as read!": {
    en: "Notification marked as read!",
    ar: "تم التعليم كقُرئ!",
  },
  "Now You're a Collaborator in ": {
    en: "Now You're a Collaborator in",
    ar: "أنت الآن مشارك في",
  },
  "Now you can chat with": {
    en: "Now you can chat with",
    ar: "الآن يمكنك الدردشة مع",
  },
  "from your inbox!": {
    en: "from your inbox!",
    ar: "من بريدك الوارد!",
  },
  "Enter Reason to decline": {
    en: "Enter Reason to decline",
    ar: "أدخل سبب الرفض",
  },
  "All Notifications marked as read!": {
    en: "All Notifications marked as read!",
    ar: "!تم وضع علامة على جميع الإشعارات كمقروءة",
  },
  "Try Again": {
    en: "Try Again",
    ar: "يرجى المحاولة مجددًا",
  },
  "Go to Home!": {
    en: "Go to Home!",
    ar: "الانتقال إلى الصفحة الرئيسية!",
  },
  "Feature request submitted successfully!": {
    en: "Feature request submitted successfully!",
    ar: "تم تقديم طلب الميزة بنجاح!",
  },
  "Error submitting the feature request!": {
    en: "Error submitting the feature request!",
    ar: "خطأ في إرسال طلب الميزة!",
  },
  "Feature Request": {
    en: "Feature Request",
    ar: "طلب ميزة جديدة",
  },
  "Please select a category!": {
    en: "Please select a category!",
    ar: "يرجى اختيار فئة!",
  },
  "Bug or Issue": {
    en: "Bug or Issue",
    ar: "خلل أو مشكلة",
  },
  "User Experience Improvement": {
    en: "User Experience Improvement",
    ar: "تحسين تجربة المستخدم",
  },
  "Small Enhancement": {
    en: "Small Enhancement",
    ar: "تحسين بسيط",
  },
  "Big Ideas": {
    en: "Big Ideas",
    ar: "الأفكار الكبرى",
  },
  "Tool Integration": {
    en: "Tool Integration",
    ar: "تكامل الأدوات",
  },
  "Performance Improvement": {
    en: "Performance Improvement",
    ar: "تحسين الأداء",
  },
  "Learning and Support": {
    en: "Learning and Support",
    ar: "التعلم والدعم",
  },
  "Team Collaboration": {
    en: "Team Collaboration",
    ar: "التعاون بين الفريق",
  },
  "Other Suggestions": {
    en: "Other Suggestions",
    ar: "اقتراحات أخرى",
  },
  "Please enter a title!": {
    en: "Please enter a title!",
    ar: "يرجى إدخال العنوان!",
  },
  "Describe the feature briefly (e.g., 'Add calendar integration')": {
    en: "Describe the feature briefly (e.g., 'Add calendar integration')",
    ar: "إضافة تكامل مع التقويم",
  },
  "Please provide a description!": {
    en: "Please provide a description!",
    ar: "يرجى تقديم الوصف!",
  },
  "Explain how this feature would work and why it would benefit users.": {
    en: "Explain how this feature would work and why it would benefit users.",
    ar: "يرجى توضيح كيفية عمل هذه الميزة والفائدة التي ستعود على المستخدمين من خلالها.",
  },
  Tags: {
    en: "Tags",
    ar: "التصنيفات",
  },
  "Submit Request": {
    en: "Submit Request",
    ar: "إرسال الطلب",
  },
  "Failed to load features": {
    en: "Failed to load features",
    ar: "فشل تحميل الميزات",
  },
  "Failed to cast vote": {
    en: "Failed to cast vote",
    ar: "فشل في تسجيل التصويت",
  },
  Successfully: {
    en: "Successfully",
    ar: "بنجاح",
  },
  upvoted: {
    en: "upvoted",
    ar: "تم التصويت بالإيجاب",
  },
  downvoted: {
    en: "downvoted",
    ar: "مرفوض",
  },
  "the feature": {
    en: "the feature",
    ar: "الميزة",
  },
  "Added New Comment Successfully!": {
    en: "Added New Comment Successfully!",
    ar: "تمت إضافة التعليق بنجاح!",
  },
  "Idea Requests": {
    en: "Idea Requests",
    ar: "طلبات الأفكار",
  },
  "Sort By": {
    en: "Sort By",
    ar: "ترتيب حسب",
  },
  "Most Popular": {
    en: "Most Popular",
    ar: "الأكثر شيوعاً",
  },
  "Least Popular": {
    en: "Least Popular",
    ar: "الأقل شيوعًا",
  },
  "Most Discussed": {
    en: "Most Discussed",
    ar: "الأكثر مناقشة",
  },
  "Least Discussed": {
    en: "Least Discussed",
    ar: "الأقل تناولاً",
  },
  "Most Recent": {
    en: "Most Recent",
    ar: "الأحدث",
  },
  Oldest: {
    en: "Oldest",
    ar: "الأقدم",
  },
  "Add Feature Request": {
    en: "Add Feature Request",
    ar: "إضافة طلب ميزة جديدة",
  },
  "No Feature found!": {
    en: "No Feature found!",
    ar: "لم يتم العثور على ميزة!",
  },
  "Upvote?": {
    en: "Upvote?",
    ar: "إعجاب؟",
  },
  "Downvote?": {
    en: "Downvote?",
    ar: "خفض التقييم؟",
  },
  Comment: {
    en: "Comment",
    ar: "تعليق",
  },
  "Close Comments?": {
    en: "Close Comments?",
    ar: "إغلاق التعليقات؟",
  },
  "Enter your comment...": {
    en: "Enter your comment...",
    ar: "أدخل تعليقك...",
  },
  "No Comments!": {
    en: "No Comments!",
    ar: "لا توجد تعليقات!",
  },
  "No Projects Under": {
    en: "No Projects Under",
    ar: "لا توجد مشاريع تحت",
  },
  "View Details?": {
    en: "View Details?",
    ar: "عرض التفاصيل؟",
  },
  "Approve Project?": {
    en: "Approve Project?",
    ar: "هل تريد الموافقة على المشروع؟",
  },
  "Driver Project Count": {
    en: "Driver Project Count",
    ar: "عدد مشاريع السائق",
  },
  "Watcher Project Count": {
    en: "Watcher Project Count",
    ar: "عدد مشاريع المراقبة",
  },
  Catchball: {
    en: "Catchball",
    ar: "تبادل الأفكار",
  },
  "All Tags": {
    en: "All Tags",
    ar: "كافة العلامات",
  },
  "No Tags": {
    en: "No Tags",
    ar: "بدون وسوم",
  },
  "Project Earnings in": {
    en: "Project Earnings in",
    ar: "أرباح المشروع في",
  },
  "Top Risks": {
    en: "Top Risks",
    ar: "المخاطر الرئيسية",
  },
  "Risk Title": {
    en: "Risk Title",
    ar: "عنوان المخاطر",
  },
  Achievements: {
    en: "Achievements",
    ar: "الإنجازات",
  },
  "Risk Mitigated": {
    en: "Risk Mitigated",
    ar: "المخاطر المُخفَّفة",
  },
  "Risk Resolved": {
    en: "Risk Resolved",
    ar: "تم حل المخاطر",
  },
  "Project Overview": {
    en: "Project Overview",
    ar: "نظرة عامة على المشروع",
  },
  "Total Members": {
    en: "Total Members",
    ar: "إجمالي الأعضاء",
  },
  "Chart Sections": {
    en: "Chart Sections",
    ar: "أقسام المخطط",
  },
  "SPC Chart": {
    en: "SPC Chart",
    ar: "مخطط SPC",
  },
  "Benefit Forecasting": {
    en: "Benefit Forecasting",
    ar: "توقع الفوائد",
  },
  "Project Duration": {
    en: "Project Duration",
    ar: "مدة المشروع",
  },
  "Estimated Project Duration Distribution": {
    en: "Estimated Project Duration Distribution",
    ar: "توزيع مدة المشروع المقدرة",
  },
  "Project Cost": {
    en: "Project Cost",
    ar: "تكلفة المشروع",
  },
  "Estimated Project Cost Distribution": {
    en: "Estimated Project Cost Distribution",
    ar: "توزيع التكلفة التقديرية للمشروع",
  },
  "See Workload": {
    en: "See Workload",
    ar: "عرض عبء العمل",
  },
  "Project Workload": {
    en: "Project Workload",
    ar: "عبء العمل الخاص بالمشروع",
  },
  "eCommerce Project": {
    en: "eCommerce Project",
    ar: "مشروع التجارة الإلكترونية",
  },
  "Project Team Workload": {
    en: "Project Team Workload",
    ar: "عبء العمل لفريق المشروع",
  },
  "Team Progress": {
    en: "Team Progress",
    ar: "تقدُّم الفريق",
  },
  "Password reset email sent successfully.": {
    en: "Password reset email sent successfully.",
    ar: "تم إرسال بريد إعادة تعيين كلمة المرور بنجاح.",
  },
  "Failed to send password reset email. Please try again.": {
    en: "Failed to send password reset email. Please try again.",
    ar: "فشل في إرسال بريد إعادة تعيين كلمة المرور. الرجاء المحاولة مرة أخرى.",
  },
  "Logged in successfully!": {
    en: "Logged in successfully!",
    ar: "تم تسجيل الدخول بنجاح!",
  },
  "Google Registration Failed. Please try again.": {
    en: "Google Registration Failed. Please try again.",
    ar: "فشل التسجيل عبر جوجل. يُرجى المحاولة مرة أخرى.",
  },
  "Google Sign-In Failed. Please try again.": {
    en: "Google Sign-In Failed. Please try again.",
    ar: "فشل تسجيل الدخول عبر جوجل. يرجى المحاولة مرة أخرى.",
  },
  "Microsoft Sign-In Failed. Please try again.": {
    en: "Microsoft Sign-In Failed. Please try again.",
    ar: "فشل تسجيل الدخول إلى مايكروسوفت. يرجى المحاولة مرة أخرى.",
  },
  "Remember Me": {
    en: "Remember Me",
    ar: "تذكرني",
  },
  "New Member?": {
    en: "New Member?",
    ar: "عضو جديد؟",
  },
  "Forgot Password?": {
    en: "Forgot Password?",
    ar: "نسيت كلمة المرور؟",
  },
  "Send Reset Link": {
    en: "Send Reset Link",
    ar: "إرسال رابط إعادة التعيين",
  },
  "Please enter your email address to receive a password reset link.": {
    en: "Please enter your email address to receive a password reset link.",
    ar: "يرجى إدخال عنوان بريدك الإلكتروني لتلقي رابط إعادة تعيين كلمة المرور.",
  },
  "Login with Google": {
    en: "Login with Google",
    ar: "تسجيل الدخول باستخدام حساب Google",
  },
  "Login with Microsoft": {
    en: "Login with Microsoft",
    ar: "تسجيل الدخول باستخدام مايكروسوفت",
  },
  Or: {
    en: "Or",
    ar: "أو",
  },
  "User Registered successfully!": {
    en: "User Registered successfully!",
    ar: "!تم تسجيل المستخدم بنجاح",
  },
  "You can now login with your new account!": {
    en: "You can now login with your new account!",
    ar: "يمكنك الآن تسجيل الدخول باستخدام حسابك الجديد!",
  },
  "Microsoft Registration Failed. Please try again.": {
    en: "Microsoft Registration Failed. Please try again.",
    ar: "فشل تسجيل مايكروسوفت. يرجى المحاولة مرة أخرى.",
  },
  "Compelion Analytics": {
    en: "Compelion Analytics",
    ar: "تحليلات كمبليون",
  },
  "Organisation Analytics": {
    en: "Organisation Analytics",
    ar: "تحليلات المنظمة",
  },
  "Phone Number": {
    en: "Phone Number",
    ar: "رقم الهاتف",
  },
  Message: {
    en: "Message",
    ar: "رسالة",
  },
  "Submitted At": {
    en: "Submitted At",
    ar: "تم الإرسال في",
  },
  "Failed to fetch organisations": {
    en: "Failed to fetch organisations",
    ar: "فشل في جلب المؤسسات",
  },
  "Organisation Management": {
    en: "Organisation Management",
    ar: "إدارة المؤسسة",
  },
  "Deleted Successfully!": {
    en: "Deleted Successfully!",
    ar: "تم الحذف بنجاح!",
  },
  "Delete Drawing?": {
    en: "Delete Drawing?",
    ar: "هل ترغب في حذف الرسم؟",
  },
  "Delete Template?": {
    en: "Delete Template?",
    ar: "حذف القالب؟",
  },
  "Failed to load categories": {
    en: "Failed to load categories",
    ar: "تعذر تحميل الفئات",
  },
  "Category deleted successfully": {
    en: "Category deleted successfully",
    ar: "تم حذف الفئة بنجاح",
  },
  "Failed to delete category": {
    en: "Failed to delete category",
    ar: "فشل في حذف الفئة",
  },
  "Subcategory deleted successfully": {
    en: "Subcategory deleted successfully",
    ar: "تم حذف الفئة الفرعية بنجاح",
  },
  "Failed to delete subcategory": {
    en: "Failed to delete subcategory",
    ar: "فشل في حذف الفئة الفرعية",
  },
  "Category updated successfully": {
    en: "Category updated successfully",
    ar: "تم تحديث التصنيف بنجاح",
  },
  "Category added successfully": {
    en: "Category added successfully",
    ar: "تمت إضافة الفئة بنجاح",
  },
  "Failed to save category": {
    en: "Failed to save category",
    ar: "فشل في حفظ الفئة.",
  },
  "Subcategory updated successfully": {
    en: "Subcategory updated successfully",
    ar: "تم تحديث الفئة الفرعية بنجاح",
  },
  "Subcategory added successfully": {
    en: "Subcategory added successfully",
    ar: "تمت إضافة الفئة الفرعية بنجاح",
  },
  "Failed to save subcategory": {
    en: "Failed to save subcategory",
    ar: "فشل في حفظ الفئة الفرعية",
  },
  "Failed to fetch themes": {
    en: "Failed to fetch themes",
    ar: "تعذّر جلب الموضوعات",
  },
  "Failed to fetch metrics.": {
    en: "Failed to fetch metrics.",
    ar: "فشل في جلب المقاييس.",
  },
  "Failed to fetch categories.": {
    en: "Failed to fetch categories.",
    ar: "فشل في جلب الفئات.",
  },
  "Metric deleted successfully": {
    en: "Metric deleted successfully",
    ar: "تم حذف المقياس بنجاح",
  },
  "Failed to delete metric.": {
    en: "Failed to delete metric.",
    ar: "فشل في حذف المؤشر.",
  },
  "Metric updated successfully": {
    en: "Metric updated successfully",
    ar: "تم تحديث المقياس بنجاح",
  },
  "Metric added successfully": {
    en: "Metric added successfully",
    ar: "تمت إضافة المقياس بنجاح",
  },
  "Failed to save metric.": {
    en: "Failed to save metric.",
    ar: "فشل في حفظ المعيار.",
  },
  "Are you sure you want to delete this Metric?": {
    en: "Are you sure you want to delete this Metric?",
    ar: "هل أنت متأكد من رغبتك في حذف هذه المعيار؟",
  },
  "Theme added successfully": {
    en: "Theme added successfully",
    ar: "تمت إضافة السمة بنجاح",
  },
  "Failed to save theme": {
    en: "Failed to save theme",
    ar: "فشل في حفظ السمة",
  },
  "Failed to fetch categories": {
    en: "Failed to fetch categories",
    ar: "فشل في جلب الفئات",
  },
  "Warning: Please remove associated categories before deleting this theme.": {
    en: "Warning: Please remove associated categories before deleting this theme.",
    ar: "تحذير: يرجى إزالة الفئات المرتبطة قبل حذف هذا الموضوع.",
  },
  "Theme deleted successfully": {
    en: "Theme deleted successfully",
    ar: "تم حذف الموضوع بنجاح",
  },
  "Failed to delete theme": {
    en: "Failed to delete theme",
    ar: "فشل في حذف السمة",
  },
  "Theme updated successfully": {
    en: "Theme updated successfully",
    ar: "تم تحديث السمة بنجاح",
  },
  "Theme Categories": {
    en: "Theme Categories",
    ar: "فئات الموضوعات",
  },
  "Are you sure you want to delete this Theme Category?": {
    en: "Are you sure you want to delete this Theme Category?",
    ar: "هل أنت متأكد من رغبتك في حذف فئة هذا الموضوع؟",
  },
  "Are you sure you want to delete this Theme?": {
    en: "Are you sure you want to delete this Theme?",
    ar: "هل أنت متأكد أنك تريد حذف هذا المحور؟",
  },
  "CSV file uploaded successfully": {
    en: "CSV file uploaded successfully",
    ar: "تم تحميل ملف CSV بنجاح",
  },
  "Failed to upload CSV file": {
    en: "Failed to upload CSV file",
    ar: "فشل في تحميل ملف CSV",
  },
  None: {
    en: "None",
    ar: "لا شيء",
  },
  Upload: {
    en: "Upload",
    ar: "رفع الملفات",
  },
  Uploading: {
    en: "Uploading",
    ar: "تحميل",
  },
  "Select CSV File": {
    en: "Select CSV File",
    ar: "اختر ملف CSV",
  },
  "Upload Result": {
    en: "Upload Result",
    ar: "تحميل النتيجة",
  },
  "Created Users": {
    en: "Created Users",
    ar: "المستخدمون المُنشأون",
  },
  Errors: {
    en: "Errors",
    ar: "الأخطاء",
  },
  "updated successfully!": {
    en: "updated successfully!",
    ar: "تم التحديث بنجاح!",
  },
  "Subtask cannot be Empty": {
    en: "Subtask cannot be Empty",
    ar: "Subtask لا يمكن أن يكون فارغًا",
  },
  "Deleted from boards!": {
    en: "Deleted from boards!",
    ar: "تم الحذف من اللوحات!",
  },
  "Subtask added successfully": {
    en: "Subtask added successfully",
    ar: "تمت إضافة المهمة الفرعية بنجاح",
  },
  "Some Error Occurred": {
    en: "Some Error Occurred",
    ar: "حدث خطأ ما",
  },
  "Information Requested from the user!": {
    en: "Information Requested from the user!",
    ar: "المعلومات المطلوبة من المستخدم!",
  },
  "Project Moved to Higher Ups For Approval!": {
    en: "Project Moved to Higher Ups For Approval!",
    ar: "تم إرسال المشروع للإدارة العليا للموافقة!",
  },
  "Project Moved to": {
    en: "Project Moved to",
    ar: "تم نقل المشروع إلى",
  },
  "Sub Task Status Updated!": {
    en: "Sub Task Status Updated!",
    ar: "تم تحديث حالة المهمة الفرعية!",
  },
  "Task Status Updated!": {
    en: "Task Status Updated!",
    ar: "تم تحديث حالة المهمة!",
  },
  Day: {
    en: "Day",
    ar: "يوم",
  },
  Agenda: {
    en: "Agenda",
    ar: "الأجندة",
  },
  "Sub Tasks generated successfully!": {
    en: "Sub Tasks generated successfully!",
    ar: "تم إنشاء المهام الفرعية بنجاح!",
  },
  "Project Parked Successfully!": {
    en: "Project Parked Successfully!",
    ar: "تم إيقاف المشروع بنجاح!",
  },
  "Super Task Sent Successfully!": {
    en: "Super Task Sent Successfully!",
    ar: "تم إرسال المهمة بنجاح!",
  },
  "Invite sent successfully!": {
    en: "Invite sent successfully!",
    ar: "تم إرسال الدعوة بنجاح!",
  },
  "Please select a division!": {
    en: "Please select a division!",
    ar: "يرجى اختيار القسم!",
  },
  "Please select a department!": {
    en: "Please select a department!",
    ar: "يرجى اختيار القسم!",
  },
  "Select Department": {
    en: "Select Department",
    ar: "اختر القسم",
  },
  "Select Division": {
    en: "Select Division",
    ar: "اختر القسم",
  },
  "Enter Task Title here...": {
    en: "Enter Task Title here...",
    ar: "أدخل عنوان المهمة هنا...",
  },
  "Enter Task description here...": {
    en: "Enter Task description here...",
    ar: "يرجى إدخال وصف المهمة هنا...",
  },
  "Select Date": {
    en: "Select Date",
    ar: "اختر التاريخ",
  },
  "Staff Member": {
    en: "Staff Member",
    ar: "عضو الفريق",
  },
  "Choose Division: ": {
    en: "Choose Division: ",
    ar: "اختر القسم:",
  },
  "Choose Department/Team": {
    en: "Choose Department/Team",
    ar: "اختر القسم/الفريق",
  },
  "Enter user email to Send Task: ": {
    en: "Enter user email to Send Task: ",
    ar: "أدخل البريد الإلكتروني للمستخدم لإرسال المهمة:",
  },
  "e.g. john@compellion": {
    en: "e.g. john@compellion",
    ar: "على سبيل المثال: john@compellion.com",
  },
  "Why do you want to send this project to Seniors?": {
    en: "Why do you want to send this project to Seniors?",
    ar: "لماذا ترغب في إرسال هذا المشروع إلى كبار الموظفين؟",
  },
  "Describe reason to move to seniors here...": {
    en: "Describe reason to move to seniors here...",
    ar: "وصف سبب الانتقال إلى كبار السن هنا...",
  },
  "Enter Reason to Park:": {
    en: "Enter Reason to Park:",
    ar: "يرجى إدخال سبب الإيقاف:",
  },
  "e.g. Already implemented the solution": {
    en: "e.g. Already implemented the solution",
    ar: "على سبيل المثال: تم تنفيذ الحل بالفعل",
  },
  "Enter Details:": {
    en: "Enter Details:",
    ar: "أدخل التفاصيل:",
  },
  "e.g. Need further information about the quality of the solution": {
    en: "e.g. Need further information about the quality of the solution",
    ar: "على سبيل المثال: هل تحتاج إلى مزيد من المعلومات حول جودة الحل?",
  },
  "Mark as Incomplete?": {
    en: "Mark as Incomplete?",
    ar: "تمييز كغير مكتمل؟",
  },
  "Mark as Completed?": {
    en: "Mark as Completed?",
    ar: "وضع علامة كمكتمل؟",
  },
  "Sub Tasks": {
    en: "Sub Tasks",
    ar: "المهام الفرعية",
  },
  Manually: {
    en: "Manually",
    ar: "يدوياً",
  },
  AI: {
    en: "AI",
    ar: "الذكاء الاصطناعي",
  },
  "No Sub-Tasks": {
    en: "No Sub-Tasks",
    ar: "لا توجد مهام فرعية",
  },
  "Task Title": {
    en: "Task Title",
    ar: "عنوان المهمة",
  },
  "Project Name": {
    en: "Project Name",
    ar: "اسم المشروع",
  },
  "Please enter the last name!": {
    en: "Please enter the last name!",
    ar: "يرجى إدخال اسم العائلة!",
  },
  "No Project Found": {
    en: "No Project Found",
    ar: "لا يوجد مشروع مكتمل",
  },
  "uploaded successfully": {
    en: "uploaded successfully",
    ar: "تم التحميل بنجاح",
  },
  "Milestone Updated Successfully!": {
    en: "Milestone Updated Successfully!",
    ar: "تم تحديث المرحلة بنجاح!",
  },
  "Project Updated Successfully!": {
    en: "Project Updated Successfully!",
    ar: "تم تحديث المشروع بنجاح!",
  },
  "Status Updated successfully!": {
    en: "Status Updated successfully!",
    ar: "تم تحديث الحالة بنجاح!",
  },
  "Note Updated Successfully!": {
    en: "Note Updated Successfully!",
    ar: "تم تحديث الملاحظة بنجاح!",
  },
  "Milestone Deleted Successfully!": {
    en: "Milestone Deleted Successfully!",
    ar: "تم حذف المرحلة الأساسية بنجاح!",
  },
  "Note Deleted Successfully!": {
    en: "Note Deleted Successfully!",
    ar: "تم حذف الملاحظة بنجاح!",
  },
  "Do you want to Delete this Note?": {
    en: "Do you want to Delete this Note?",
    ar: "هل تريد حذف هذه الملاحظة؟",
  },
  "Task Added Successfully!": {
    en: "Task Added Successfully!",
    ar: "!تمت إضافة المهمة بنجاح",
  },
  "Due Date Updated successfully": {
    en: "Due Date Updated successfully",
    ar: "تم تحديث تاريخ الاستحقاق بنجاح",
  },
  "Failed to update metric": {
    en: "Failed to update metric",
    ar: "فشل في تحديث المقياس",
  },
  "An error occurred while updating the metric": {
    en: "An error occurred while updating the metric",
    ar: "حدث خطأ أثناء تحديث المؤشر",
  },
  "Failed to add metric": {
    en: "Failed to add metric",
    ar: "فشل في إضافة المقياس",
  },
  "An error occurred while adding metric": {
    en: "An error occurred while adding metric",
    ar: "وقع خطأ أثناء إضافة المقياس",
  },
  "No Projects found to add task!": {
    en: "No Projects found to add task!",
    ar: "لم يتم العثور على مشاريع لإضافة مهمة!",
  },
  "Task moved to": {
    en: "Task moved to",
    ar: "تم نقل المهمة إلى",
  },
  "board!": {
    en: "board!",
    ar: "لوحة التحكم",
  },
  "Subtask Deleted successfully!": {
    en: "Subtask Deleted successfully!",
    ar: "تم حذف المهمة الفرعية بنجاح!",
  },
  "added to boards!": {
    en: "added to boards!",
    ar: "تمت الإضافة إلى اللوحات!",
  },
  "Request Sent for New Conversation!": {
    en: "Request Sent for New Conversation!",
    ar: "تم إرسال الطلب لبدء محادثة جديدة!",
  },
  "No Messages": {
    en: "No Messages",
    ar: "لا توجد رسائل",
  },
  "Well done, You're Right!": {
    en: "Well done, You're Right!",
    ar: "أحسنت، أنت محق!",
  },
  "Sorry, It's a wrong answer!": {
    en: "Sorry, It's a wrong answer!",
    ar: "عذرًا، الإجابة غير صحيحة!",
  },
  "Save As Template": {
    en: "Save As Template",
    ar: "حفظ كقالب",
  },
  "Save to Dashboard": {
    en: "Save to Dashboard",
    ar: "حفظ إلى لوحة التحكم",
  },
  "Remaining counts for the organisation:": {
    en: "Remaining counts for the organisation:",
    ar: "الأرصدة المتبقية للمنظمة:",
  },
  "Draw with AI": {
    en: "Draw with AI",
    ar: "الرسم باستخدام الذكاء الاصطناعي",
  },
  "Save as Drawing": {
    en: "Save as Drawing",
    ar: "حفظ كرسمة",
  },
  "Save as Template": {
    en: "Save as Template",
    ar: "حفظ كقالب",
  },
  "e.g. Fishbone Diagram": {
    en: "e.g. Fishbone Diagram",
    ar: "مخطط السبب والأثر",
  },
  "Select Project:": {
    en: "Select Project:",
    ar: "اختر المشروع:",
  },
  "Make Private": {
    en: "Make Private",
    ar: "خاص",
  },
  "Your Prompt:": {
    en: "Your Prompt:",
    ar: "طلبك",
  },
  "Enter your prompt here...": {
    en: "Enter your prompt here...",
    ar: "يرجى إدخال التعليمات الخاصة بك هنا...",
  },
  "Select Project": {
    en: "Select Project",
    ar: "اختر المشروع",
  },
  "Select Diagram Type:": {
    en: "Select Diagram Type:",
    ar: "اختر نوع المخطط:",
  },
  "Select Diagram Type": {
    en: "Select Diagram Type",
    ar: "اختر نوع المخطط",
  },
  "Please fill in all required fields before proceeding.": {
    en: "Please fill in all required fields before proceeding.",
    ar: "يرجى تعبئة جميع الحقول المطلوبة قبل المتابعة.",
  },
  "Personal Information": {
    en: "Personal Information",
    ar: "المعلومات الشخصية",
  },
  "Please input your first name!": {
    en: "Please input your first name!",
    ar: "يرجى إدخال اسمك الأول!",
  },
  "Enter your first name": {
    en: "Enter your first name",
    ar: "أدخل اسمك الأول",
  },
  "Please input your last name!": {
    en: "Please input your last name!",
    ar: "يرجى إدخال اسم العائلة الخاص بك!",
  },
  "Enter your last name": {
    en: "Enter your last name",
    ar: "أدخل اسم العائلة",
  },
  "Please input your email!": {
    en: "Please input your email!",
    ar: "الرجاء إدخال بريدك الإلكتروني!",
  },
  "Please enter a valid email address!": {
    en: "Please enter a valid email address!",
    ar: "يرجى إدخال عنوان بريد إلكتروني صالح!",
  },
  "Enter your email": {
    en: "Enter your email",
    ar: "أدخل بريدك الإلكتروني",
  },
  "Please input your contact number!": {
    en: "Please input your contact number!",
    ar: "يرجى إدخال رقم الاتصال الخاص بك!",
  },
  "e.g. +19992999292": {
    en: "e.g. +19992999292",
    ar: "مثال: +١٩٩٩٢٩٩٩٢٩٢",
  },
  "Site Location Visited": {
    en: "Site Location Visited",
    ar: "موقع الموقع الذي تم زيارته",
  },
  "Please input the site location visited!": {
    en: "Please input the site location visited!",
    ar: "يرجى إدخال موقع الموقع الذي تم زيارته!",
  },
  "Enter site location visited": {
    en: "Enter site location visited",
    ar: "أدخل موقع الزيارة للموقع",
  },
  "Department or Ward": {
    en: "Department or Ward",
    ar: "القسم أو الجناح",
  },
  "Please input the department or ward!": {
    en: "Please input the department or ward!",
    ar: "يرجى إدخال القسم أو الجناح!",
  },
  "Enter department or ward": {
    en: "Enter department or ward",
    ar: "أدخل القسم أو الوحدة",
  },
  "In a few sentences, Please Describe what the project is about and how it will help improve MTW as an organisation. Be specific, focus on the What not the Why.":
    {
      en: "In a few sentences, Please Describe what the project is about and how it will help improve MTW as an organisation. Be specific, focus on the What not the Why.",
      ar: "يركز المشروع بشكل أساسي على تطوير وتنفيذ نظام إدارة متكامل يهدف إلى تحسين الكفاءة التشغيلية في MTW. سيمكن النظام الجديد من رقمنة العمليات الرئيسية، مثل إدارة المستندات وتتبع الموارد وتحليل البيانات، مما يسهم في تحسين دقة المعاملات وسرعة استجابة الأعمال. من خلال تعزيز القدرات التقنية، سيتيح النظام للمنظمة تحسين مراقبة الأداء واتخاذ قرارات مستنيرة بناءً على بيانات دقيقة ومحدثة.",
    },
  "Generate Your Idea": {
    en: "Generate Your Idea",
    ar: "ابتكر فكرتك",
  },
  "Submit & Next": {
    en: "Submit & Next",
    ar: "إرسال ومتابعة",
  },
  "Please Select Your Role": {
    en: "Please Select Your Role",
    ar: "يرجى تحديد وظيفتك",
  },
  "No Reports Found!": {
    en: "No Reports Found!",
    ar: "لم يتم العثور على تقارير!",
  },
  "Build a culture that drives innovation": {
    en: "Build a culture that drives innovation",
    ar: "بنوا ثقافة تحفز الابتكار",
  },
  "Align innovation efforts with strategic goals": {
    en: "Align innovation efforts with strategic goals",
    ar: "مواءمة جهود الابتكار مع الأهداف الاستراتيجية",
  },
  "Empower teams across the organization to innovate": {
    en: "Empower teams across the organization to innovate",
    ar: "تمكين الفرق عبر المؤسسة من الابتكار",
  },
  "Streamline idea development with agile processes": {
    en: "Streamline idea development with agile processes",
    ar: "تبسيط تطوير الأفكار باستخدام العمليات الرشيقة",
  },
  "Track progress and measure the impact of initiatives": {
    en: "Track progress and measure the impact of initiatives",
    ar: "تتبع التقدم وقم بقياس تأثير المبادرات",
  },
  "Foster engagement and creativity across teams": {
    en: "Foster engagement and creativity across teams",
    ar: "تحفيز التفاعل والإبداع بين الفرق",
  },
  "Access workshops tailored to solve complex challenges": {
    en: "Access workshops tailored to solve complex challenges",
    ar: "الوصول إلى ورش العمل المصممة لحل التحديات المعقدة",
  },
  "Manual tracking (spreadsheets, documents)": {
    en: "Manual tracking (spreadsheets, documents)",
    ar: "التتبع اليدوي (جداول البيانات، المستندات)",
  },
  "Using general project management tools": {
    en: "Using general project management tools",
    ar: "استخدام أدوات إدارة المشاريع العامة",
  },
  "Team meetings and brainstorming": {
    en: "Team meetings and brainstorming",
    ar: "الاجتماعات الفرعية وجلسات العصف الذهني",
  },
  "Dedicated innovation platform": {
    en: "Dedicated innovation platform",
    ar: "منصة الابتكار المخصصة",
  },
  "No formal process": {
    en: "No formal process",
    ar: "لا توجد عملية رسمية",
  },
  "Managed by a specific team (e.g., PMO/Transformation)": {
    en: "Managed by a specific team (e.g., PMO/Transformation)",
    ar: "تتم الإدارة بواسطة فريق محدد (مثل: مكتب إدارة المشاريع / التحول)",
  },
  "Employee suggestion programs": {
    en: "Employee suggestion programs",
    ar: "برامج اقتراحات الموظفين",
  },
  "Failed to submit your request. Please try again.": {
    en: "Failed to submit your request. Please try again.",
    ar: "فشل في إرسال طلبك. يُرجى المحاولة مرة أخرى.",
  },
  "Company/Organization": {
    en: "Company/Organization",
    ar: "شركة/مؤسسة",
  },
  "Please enter Company/Organization name": {
    en: "Please enter Company/Organization name",
    ar: "يرجى إدخال اسم الشركة/المؤسسة",
  },
  "Job Title/Position": {
    en: "Job Title/Position",
    ar: "المسمى الوظيفي/المنصب",
  },
  "Your Job Title": {
    en: "Your Job Title",
    ar: "المسمى الوظيفي الخاص بك",
  },
  "Department/Function": {
    en: "Department/Function",
    ar: "القسم/الوظيفة",
  },
  "Please enter your department": {
    en: "Please enter your department",
    ar: "يرجى إدخال القسم الخاص بك",
  },
  "Your Department or Function": {
    en: "Your Department or Function",
    ar: "قسمك أو وظيفتك",
  },
  "Company Size": {
    en: "Company Size",
    ar: "حجم الشركة",
  },
  "Please select your company size": {
    en: "Please select your company size",
    ar: "يرجى اختيار حجم شركتكم",
  },
  "1–50 employees": {
    en: "1–50 employees",
    ar: "1-50 موظفاً",
  },
  "51–200 employees": {
    en: "51–200 employees",
    ar: "٥١-٢٠٠ موظف",
  },
  "201–500 employees": {
    en: "201–500 employees",
    ar: "٢٠١–٥٠٠ موظف",
  },
  "501–1,000 employees": {
    en: "501–1,000 employees",
    ar: "٥٠١-١٠٠٠ موظف",
  },
  "1,001+ employees": {
    en: "1,001+ employees",
    ar: "أكثر من 1,001 موظف",
  },
  "Select Company Size": {
    en: "Select Company Size",
    ar: "اختر حجم الشركة",
  },
  "Industry Sector": {
    en: "Industry Sector",
    ar: "قطاع الصناعة",
  },
  "Please select your industry sector!": {
    en: "Please select your industry sector!",
    ar: "يرجى اختيار قطاع الصناعة الخاص بك!",
  },
  Healthcare: {
    en: "Healthcare",
    ar: "الرعاية الصحية",
  },
  Technology: {
    en: "Technology",
    ar: "التقنية",
  },
  Manufacturing: {
    en: "Manufacturing",
    ar: "التصنيع",
  },
  Education: {
    en: "Education",
    ar: "التعليم",
  },
  "Financial Services": {
    en: "Financial Services",
    ar: "الخدمات المالية",
  },
  "Government/Public Sector": {
    en: "Government/Public Sector",
    ar: "القطاع الحكومي / القطاع العام",
  },
  "Energy and Utilities": {
    en: "Energy and Utilities",
    ar: "الطاقة والمرافق",
  },
  "Retail and Consumer Goods": {
    en: "Retail and Consumer Goods",
    ar: "تجارة التجزئة والسلع الاستهلاكية",
  },
  "Transportation and Logistics": {
    en: "Transportation and Logistics",
    ar: "النقل واللوجستيات",
  },
  "Other (Please specify)": {
    en: "Other (Please specify)",
    ar: "أخرى (يرجى التحديد)",
  },
  "Please specify": {
    en: "Please specify",
    ar: "يرجى التحديد",
  },
  "Please specify your industry!": {
    en: "Please specify your industry!",
    ar: "يرجى تحديد مجال عملك!",
  },
  "specify your industry": {
    en: "specify your industry",
    ar: "يرجى تحديد مجال عملك",
  },
  "What are your primary goals for using Compelion?": {
    en: "What are your primary goals for using Compelion?",
    ar: "ما هي الأهداف الرئيسية لاستخدامك منصة كومبيليون؟",
  },
  "What challenges are you facing?": {
    en: "What challenges are you facing?",
    ar: "ما هي التحديات التي تواجهها؟",
  },
  "e.g. Difficulty in capturing and evaluating ideas effectively": {
    en: "e.g. Difficulty in capturing and evaluating ideas effectively",
    ar: "صعوبة في استيعاب وتقييم الأفكار بفعالية",
  },
  "Please provide a valid phone number": {
    en: "Please provide a valid phone number",
    ar: "يرجى تقديم رقم هاتف صالح",
  },
  "How do you currently manage ideas and innovation processes?": {
    en: "How do you currently manage ideas and innovation processes?",
    ar: "كيف تقوم حالياً بإدارة الأفكار وعمليات الابتكار؟",
  },
  "e.g., +44 7700 900456": {
    en: "e.g., +44 7700 900456",
    ar: "مثال: +44 7700 900456",
  },
  "Are you a decision-maker?": {
    en: "Are you a decision-maker?",
    ar: "هل أنت صاحب قرار؟",
  },
  "Strategic Planning Frameworks (e.g., Clear Plan)": {
    en: "Strategic Planning Frameworks (e.g., Clear Plan)",
    ar: "أطر التخطيط الاستراتيجي (مثل: خطة واضحة)",
  },
  "Are you currently using any innovation management tools or platforms?": {
    en: "Are you currently using any innovation management tools or platforms?",
    ar: "هل تستخدم حالياً أي أدوات أو منصات لإدارة الابتكار؟",
  },
  "Which features of Compelion interest you the most? (Select all that apply)":
    {
      en: "Which features of Compelion interest you the most? (Select all that apply)",
      ar: "ما الميزات التي تهمك أكثر في Compelion؟ (اختر جميع ما ينطبق)",
    },
  "Would you like to invite the appropriate person to also receive early access to Compelion?":
    {
      en: "Would you like to invite the appropriate person to also receive early access to Compelion?",
      ar: "هل ترغب في دعوة الشخص المناسب للحصول على الوصول المبكر إلى منصة Compelion؟",
    },
  "Participation Preferences": {
    en: "Participation Preferences",
    ar: "تفضيلات المشاركة",
  },
  "User Feedback Sessions": {
    en: "User Feedback Sessions",
    ar: "جلسات تغذية راجع المستخدمين",
  },
  "Receive Updates and Newsletters": {
    en: "Receive Updates and Newsletters",
    ar: "استلام التحديثات والنشرات الإخبارية",
  },
  "Beta Testing": {
    en: "Beta Testing",
    ar: "الاختبار التجريبي",
  },
  "Webinars and Training Sessions": {
    en: "Webinars and Training Sessions",
    ar: "الندوات عبر الإنترنت وجلسات التدريب",
  },
  "Is there anything else you’d like us to know?": {
    en: "Is there anything else you’d like us to know?",
    ar: "هل هناك أي معلومات إضافية تودون منا معرفتها؟",
  },
  "e.g. We have an upcoming project and are interested in how Compelion can support us.":
    {
      en: "e.g. We have an upcoming project and are interested in how Compelion can support us.",
      ar: "لدينا مشروع قادم ونحن مهتمون بكيفية دعم Compelion لنا.",
    },
  "I have read and agree to the": {
    en: "I have read and agree to the",
    ar: "لقد قرأت وأوافق على الشروط والأحكام",
  },
  and: {
    en: "and",
    ar: "و",
  },
  "Your Confirmed Password do not match with Original Password!": {
    en: "Your Confirmed Password do not match with Original Password!",
    ar: "!كلمة المرور المؤكدة لا تتطابق مع كلمة المرور الأصلية",
  },
  "No User Id Found!": {
    en: "No User Id Found!",
    ar: "لم يتم العثور على معرف المستخدم!",
  },
  "Thank you! Your profile info updated!": {
    en: "Thank you! Your profile info updated!",
    ar: "شكرًا لك! تم تحديث معلومات ملفك الشخصي بنجاح!",
  },
  "Explore Compelion with us!": {
    en: "Explore Compelion with us!",
    ar: "استكشف Compelion معنا!",
  },
  "To help determine your designation and role, please provide the following details.":
    {
      en: "To help determine your designation and role, please provide the following details.",
      ar: "لتحديد التعيين والدور الخاص بك، يُرجى تقديم التفاصيل التالية.",
    },
  Password: {
    en: "Password",
    ar: "كلمة المرور",
  },
  "Please enter your password": {
    en: "Please enter your password",
    ar: "يرجى إدخال كلمة المرور الخاصة بك",
  },
  "Create a Password": {
    en: "Create a Password",
    ar: "إنشاء كلمة مرور",
  },
  "Confirm Password": {
    en: "Confirm Password",
    ar: "تأكيد كلمة المرور",
  },
  "Please confirm your password": {
    en: "Please confirm your password",
    ar: "يرجى تأكيد كلمة المرور الخاصة بك",
  },
  "Role Categories": {
    en: "Role Categories",
    ar: "فئات الأدوار",
  },
  "Your strategic vision is the driving force behind every innovation, project, and success.":
    {
      en: "Your strategic vision is the driving force behind every innovation, project, and success.",
      ar: "رؤيتك الاستراتيجية هي القوة الدافعة وراء كل ابتكار ومشروع ونجاح.",
    },
  "Core Strategic Themes": {
    en: "Core Strategic Themes",
    ar: "المحاور الاستراتيجية الأساسية",
  },
  "Custom Strategic Themes": {
    en: "Custom Strategic Themes",
    ar: "المواضيع الاستراتيجية المخصصة",
  },
  "Please enter a theme": {
    en: "Please enter a theme",
    ar: "يرجى إدخال محور الموضوع",
  },
  "Please select a theme class": {
    en: "Please select a theme class",
    ar: "يرجى اختيار فئة السمة",
  },
  "Select Theme Class": {
    en: "Select Theme Class",
    ar: "اختر تصنيف الموضوع",
  },
  "+ Add Custom Theme": {
    en: "+ Add Custom Theme",
    ar: "+ إضافة تصميم مخصص",
  },
  "Would you like to Add Strategic Themes Info?": {
    en: "Would you like to Add Strategic Themes Info?",
    ar: "هل تود إضافة معلومات مواضيع استراتيجية؟",
  },
  "Skip For Now!": {
    en: "Skip For Now!",
    ar: "تخطى الآن",
  },
  "Yes, Let's Do It!": {
    en: "Yes, Let's Do It!",
    ar: "نعم، لنقم بذلك!",
  },
  "Thank you for your submission!": {
    en: "Thank you for your submission!",
    ar: "شكرًا لتقديمك!",
  },
  "Please Login to your account now to explore Compelion!": {
    en: "Please Login to your account now to explore Compelion!",
    ar: "يرجى تسجيل الدخول إلى حسابك الآن لاستكشاف Compelion!",
  },
  "Failed to create checkout session": {
    en: "Failed to create checkout session",
    ar: "فشل في إنشاء جلسة الدفع",
  },
  "Failed to retrieve the Stripe checkout URL": {
    en: "Failed to retrieve the Stripe checkout URL",
    ar: "فشل في استرجاع رابط الدفع لسترايب",
  },
  "Payment process failed": {
    en: "Payment process failed",
    ar: "فشل عملية الدفع",
  },
  INSIGHT: {
    en: "INSIGHT",
    ar: "البصيرة",
  },
  Remarks: {
    en: "Remarks",
    ar: "ملاحظات",
  },
  "View History": {
    en: "View History",
    ar: "عرض السجل",
  },
  "No rules have been triggered.": {
    en: "No rules have been triggered.",
    ar: "لم يتم تفعيل أي قواعد.",
  },
  "No rules have been applied.": {
    en: "No rules have been applied.",
    ar: "لم يتم تطبيق أي قواعد.",
  },
  "The process is operating within acceptable limits.": {
    en: "The process is operating within acceptable limits.",
    ar: "العملية تعمل ضمن الحدود المقبولة.",
  },
  "No Tasks": {
    en: "No Tasks",
    ar: "عذرًا، لا توجد مهام حاليًا.",
  },
  "Loading more tasks...": {
    en: "Loading more tasks...",
    ar: "جاري تحميل المزيد من المهام...",
  },
  PDSA: {
    en: "PDSA",
    ar: "خطط - نفذ - راجع - عدّل",
  },
  "Approval Info": {
    en: "Approval Info",
    ar: "معلومات الموافقة",
  },
  "Chat Invitation": {
    en: "Chat Invitation",
    ar: "دعوة الدردشة",
  },
  Info: {
    en: "Info",
    ar: "معلومات",
  },
  Guidance: {
    en: "Guidance",
    ar: "إرشادات",
  },
  "Select a Date": {
    en: "Select a Date",
    ar: "اختر التاريخ",
  },
  "Please enter the designation!": {
    en: "Please enter the designation!",
    ar: "يرجى إدخال المسمى الوظيفي!",
  },
  "e.g. Project Manager": {
    en: "e.g. Project Manager",
    ar: "مثال: مدير مشروع",
  },
  "For CEOs, COOs, Strategy Directors": {
    en: "For CEOs, COOs, Strategy Directors",
    ar: "للرؤساء التنفيذيين، ومديري العمليات، ومديري الاستراتيجيات",
  },
  "For Divisional Heads, Theme Leaders": {
    en: "For Divisional Heads, Theme Leaders",
    ar: "لرؤساء الأقسام وقادة المبادرات",
  },
  "For Department Heads, Team Leaders": {
    en: "For Department Heads, Team Leaders",
    ar: "لرؤساء الإدارات وقادة الفرق",
  },
  "For All Team Members": {
    en: "For All Team Members",
    ar: "لجميع أعضاء الفريق",
  },
  "L1 Executive Access": {
    en: "L1 Executive Access",
    ar: "صلاحية تنفيذية مستوى 1",
  },
  "L2 Director Access": {
    en: "L2 Director Access",
    ar: "صلاحية مدير مستوى 2",
  },
  "L3 Manager Access": {
    en: "L3 Manager Access",
    ar: "صلاحية مدير مستوى 3",
  },
  "L4 Standard Access": {
    en: "L4 Standard Access",
    ar: "صلاحية قياسية مستوى 4",
  },
  "e.g. John": {
    en: "e.g. John",
    ar: "مثال: أحمد",
  },
  "e.g. Doe": {
    en: "e.g. Doe",
    ar: "مثال: علي",
  },
  "e.g. john@compelion.com": {
    en: "e.g. john@compelion.com",
    ar: "مثال: john@compelion.com",
  },
  "e.g. Work on Documentation": {
    en: "e.g. Work on Documentation",
    ar: "مثال: العمل على التوثيق",
  },
  "Revenue Breakdown": {
    en: "Revenue Breakdown",
    ar: "تفصيل الإيرادات",
  },
  Open: {
    en: "Open",
    ar: "مفتوح",
  },
  Closed: {
    en: "Closed",
    ar: "مغلق",
  },
  "Initiation and Business Case Development": {
    en: "Initiation and Business Case Development",
    ar: "بدء وتطوير حالة العمل",
  },
  "Plan and Organize": {
    en: "Plan and Organize",
    ar: "التخطيط والتنظيم",
  },
  Implementation: {
    en: "Implementation",
    ar: "التنفيذ",
  },
  "Review and Standardize": {
    en: "Review and Standardize",
    ar: "المراجعة والتوحيد",
  },
  Celebration: {
    en: "Celebration",
    ar: "الاحتفال",
  },
  Initiate: {
    en: "Initiate",
    ar: "البدء",
  },
  Measure: {
    en: "Measure",
    ar: "القياس",
  },
  Pinpoint: {
    en: "Pinpoint",
    ar: "التحديد الدقيق",
  },
  Recommend: {
    en: "Recommend",
    ar: "التوصية",
  },
  Optimize: {
    en: "Optimize",
    ar: "التحسين",
  },
  Validate: {
    en: "Validate",
    ar: "التحقق",
  },
  Execute: {
    en: "Execute",
    ar: "التنفيذ",
  },
  Sustain: {
    en: "Sustain",
    ar: "الاستدامة",
  },
  Setup: {
    en: "Setup",
    ar: "الإعداد",
  },
  Observe: {
    en: "Observe",
    ar: "المراقبة",
  },
  Locate: {
    en: "Locate",
    ar: "التحديد",
  },
  Visualize: {
    en: "Visualize",
    ar: "التصور",
  },
  Reinforce: {
    en: "Reinforce",
    ar: "التعزيز",
  },
  "Select Due Date": {
    en: "Select Due Date",
    ar: "اختر تاريخ الاستحقاق",
  },
  "Select Stage": {
    en: "Select Stage",
    ar: "اختر المرحلة",
  },
  "Enter title here": {
    en: "Enter title here",
    ar: "أدخل العنوان هنا",
  },
  "Enter Description here": {
    en: "Enter Description here",
    ar: "أدخل الوصف هنا",
  },
  "Step 1: Problem Statement": {
    en: "Step 1: Problem Statement",
    ar: "الخطوة الأولى: بيان المشكلة",
  },
  "Step 2: Current Condition": {
    en: "Step 2: Current Condition",
    ar: "الخطوة 2: الوضع الحالي",
  },
  "Step 3: Goal & Target": {
    en: "Step 3: Goal & Target",
    ar: "الخطوة 3: الهدف والغاية",
  },

  Show: {
    en: "Show",
    ar: "عرض",
  },
  Report: {
    en: "Report",
    ar: "تقرير ",
  },
  Daily: {
    en: "Daily",
    ar: "يوميًّا",
  },
  Weekly: {
    en: "Weekly",
    ar: "أسبوعيًّا",
  },
  Monthly: {
    en: "Monthly",
    ar: "شهرياً",
  },

  "Please select the frequency!": {
    en: "Please select the frequency!",
    ar: "يرجى اختيار التكرار!",
  },
  "Select frequency": {
    en: "Select frequency",
    ar: "اختر التكرار",
  },
  Target: {
    en: "Target",
    ar: "الهدف",
  },
  "Please enter the target value!": {
    en: "Please enter the target value!",
    ar: "يرجى إدخال القيمة المستهدفة!",
  },
  "Please Enter the target.": {
    en: "Please Enter the target.",
    ar: "يرجى إدخال الهدف.",
  },
  Value: {
    en: "Value",
    ar: "قيمة",
  },
  "Add Remarks": {
    en: "Add Remarks",
    ar: "إضافة ملاحظات",
  },
  "Please Enter your remark.": {
    en: "Please Enter your remark.",
    ar: "يرجى إدخال ملاحظتك.",
  },
  "Full Report": {
    en: "Full Report",
    ar: "تقرير كامل",
  },
  "Do you want to Delete this subtask?": {
    en: "Do you want to Delete this subtask?",
    ar: "هل تريد حذف هذه المهمة الفرعية؟",
  },
  "Do you want to move task in": {
    en: "Do you want to move task in",
    ar: "هل تريد حذف هذه المهمة الفرعية؟",
  },
  "Board?": {
    en: "Board?",
    ar: "سبورة؟",
  },
  "Task:": {
    en: "Task:",
    ar: "مهمة:",
  },
  Task: {
    en: "Task",
    ar: "مهمة",
  },
  "Subtask:": {
    en: "Subtask:",
    ar: "مهمة فرعية:",
  },
  "Do you want Update task status as": {
    en: "Do you want Update task status as",
    ar: "هل تريد تحديث حالة المهمة كـ",
  },
  "Please empty": {
    en: "Please empty",
    ar: "من فضلك فارغة",
  },
  "board before deleting it!": {
    en: "board before deleting it!",
    ar: "من فضلك فارغة",
  },
  "Super Task": {
    en: "Super Task",
    ar: "مهمة فائقة",
  },
  more: {
    en: "more",
    ar: "أكثر",
  },
  "Delete board?": {
    en: "Delete board?",
    ar: "حذف اللوحة؟",
  },
  "Task Loading...": {
    en: "Task Loading...",
    ar: "جاري تحميل المهمة...",
  },

  SubTasks: {
    en: "SubTasks",
    ar: "المهام الفرعية",
  },
  "Enter Subtask": {
    en: "Enter Subtask",
    ar: "أدخل مهمة فرعية",
  },
  "Board Title:": {
    en: "Board Title:",
    ar: "عنوان المجلس:",
  },
  "Enter board title here...": {
    en: "Enter board title here...",
    ar: "أدخل عنوان اللوحة هنا...",
  },
  "Remaining:": {
    en: "Remaining:",
    ar: "متبقي:",
  },
  "Not Resolved": {
    en: "Not Resolved",
    ar: "لم يتم حلها",
  },
  "Risk Details": {
    en: "Risk Details",
    ar: "تفاصيل المخاطر",
  },
  "Risk Mitigation": {
    en: "Risk Mitigation",
    ar: "تخفيف المخاطر",
  },
  "Risk Resolution": {
    en: "Risk Resolution",
    ar: "حل المخاطر",
  },
  "Resolved By": {
    en: "Resolved By",
    ar: "تم الحل بواسطة",
  },
  "Escalation Status:": {
    en: "Escalation Status:",
    ar: "حالة التصعيد:",
  },
  Escalated: {
    en: "Escalated",
    ar: "تصاعدت",
  },
  "Assigned To:": {
    en: "Assigned To:",
    ar: "تم تعيينه إلى:",
  },
  "Issue Details": {
    en: "Issue Details",
    ar: "تفاصيل المشكلة",
  },
  "Mitigation Effort": {
    en: "Mitigation Effort",
    ar: "جهود التخفيف",
  },
  "Manager Attention Required": {
    en: "Manager Attention Required",
    ar: "مطلوب اهتمام المدير",
  },
  "Issue Resolution": {
    en: "Issue Resolution",
    ar: "حل المشكلة",
  },
  "No Result!": {
    en: "No Result!",
    ar: "لا توجد نتيجة!",
  },
  "Concern Details": {
    en: "Concern Details",
    ar: "تفاصيل القلق",
  },
  "Need to Be Added in Agenda": {
    en: "Need to Be Added in Agenda",
    ar: "يجب إضافتها إلى جدول الأعمال",
  },
  "Concern Resolution": {
    en: "Concern Resolution",
    ar: "حل القلق",
  },

  "Escalation Status": {
    en: "Escalation Status",
    ar: "حالة التصعيد",
  },

  "Assigned To": {
    en: "Assigned To",
    ar: "تم التعيين إلى",
  },
  "Impact of The Risk:": {
    en: "Impact of The Risk:",
    ar: "تأثير المخاطرة:",
  },
  "Risk Level:": {
    en: "Risk Level:",
    ar: "مستوى المخاطر:",
  },
  "Urgency:": {
    en: "Urgency:",
    ar: "الاستعجال:",
  },
  "Upload File": {
    en: "Upload File",
    ar: "تحميل الملف",
  },
  "Resources to Mitigate Risk": {
    en: "Resources to Mitigate Risk",
    ar: "موارد لتخفيف المخاطر",
  },

  "Steps to Mitigate Risk": {
    en: "Steps to Mitigate Risk",
    ar: "خطوات لتخفيف المخاطر",
  },
  "Deadline For Mitigation of Risk": {
    en: "Deadline For Mitigation of Risk",
    ar: "الموعد النهائي لتخفيف المخاطر",
  },
  "Resources to Mitigate Issue": {
    en: "Resources to Mitigate Issue",
    ar: "الموارد لتخفيف المشكلة",
  },
  "Steps to Mitigate Issue": {
    en: "Steps to Mitigate Issue",
    ar: "خطوات لتخفيف المشكلة",
  },
  "Deadline For Mitigation of Issue": {
    en: "Deadline For Mitigation of Issue",
    ar: "الموعد النهائي لتخفيف المشكلة",
  },
  "Resources to Mitigate Concern": {
    en: "Resources to Mitigate Concern",
    ar: "الموارد لتخفيف القلق",
  },
  "Steps to Mitigate Concern": {
    en: "Steps to Mitigate Concern",
    ar: "خطوات لتخفيف القلق",
  },
  "Deadline For Mitigation of Concern": {
    en: "Deadline For Mitigation of Concern",
    ar: "الموعد النهائي لتخفيف القلق",
  },
  "Delegated To:": {
    en: "Delegated To:",
    ar: "مفوض إلى:",
  },

  "Enter details here...": {
    en: "Enter details here...",
    ar: "أدخل التفاصيل هنا...",
  },
  "Describe reason to delegate here...": {
    en: "Describe reason to delegate here...",
    ar: "قم بوصف سبب التفويض هنا...",
  },
  "Escalation Info": {
    en: "Escalation Info",
    ar: "معلومات التصعيد",
  },
  "SubCategory:": {
    en: "SubCategory:",
    ar: "الفئة الفرعية:",
  },
  "Not Linked to any Department": {
    en: "Not Linked to any Department",
    ar: "غير مرتبط بأي قسم",
  },
  "Not Linked to any Division": {
    en: "Not Linked to any Division",
    ar: "غير مرتبط بأي قسم",
  },
  "Filter By SubCategory:": {
    en: "Filter By SubCategory:",
    ar: "التصفية حسب الفئة الفرعية:",
  },
  "No Escalations!": {
    en: "No Escalations!",
    ar: "لا للتصعيد!",
  },
  "Select Date and Time": {
    en: "Select Date and Time",
    ar: "اختر التاريخ والوقت",
  },

  Stage: {
    en: "Stage",
    ar: "منصة",
  },
  "No Milestones": {
    en: "No Milestones",
    ar: "لا المعالم",
  },
  "Add Milestone": {
    en: "Add Milestone",
    ar: "إضافة معلم",
  },
  "No resources uploaded yet": {
    en: "No resources uploaded yet",
    ar: "لم يتم تحميل أي موارد حتى الآن",
  },
  "Do you want to Delete": {
    en: "Do you want to Delete",
    ar: "هل تريد حذف",
  },
  "Milestone?": {
    en: "Milestone?",
    ar: "منعطف؟",
  },
  "Not Available": {
    en: "Not Available",
    ar: "غير متوفر",
  },
  "Download?": {
    en: "Download?",
    ar: "تحميل؟",
  },
  "Add Subtask": {
    en: "Add Subtask",
    ar: "إضافة مهمة فرعية",
  },
  "Search here...": {
    en: "Search here...",
    ar: "إبحث هنا...",
  },

  "No data": {
    en: "No data",
    ar: "لا توجد بيانات",
  },
  Roles: {
    en: "Roles",
    ar: "الأدوار",
  },
  Escalate: {
    en: "Escalate",
    ar: "تصعيد",
  },
  "Note:": {
    en: "Note:",
    ar: "ملحوظة:",
  },
  "Do you want to move Project in": {
    en: "Do you want to move Project in",
    ar: "هل تريد نقل المشروع إلى",
  },
  "Reset Password": {
    en: "Reset Password",
    ar: "إعادة تعيين كلمة المرور",
  },
  "Create Organisation": {
    en: "Create Organisation",
    ar: "إنشاء منظمة",
  },
  "Select a Theme": {
    en: "Select a Theme",
    ar: "اختر موضوعًا",
  },
  "e.g. john@gmail.com": {
    en: "e.g. john@gmail.com",
    ar: "على سبيل المثال جون@gmail.com",
  },
  "e.g. CEO": {
    en: "e.g. CEO",
    ar: "على سبيل المثال المدير التنفيذي",
  },
  "Select a Strategic Theme": {
    en: "Select a Strategic Theme",
    ar: "اختر موضوعًا استراتيجيًا",
  },
  "Edit Due Date": {
    en: "Edit Due Date",
    ar: "تعديل تاريخ الاستحقاق",
  },
  "Please enter the Remark!": {
    en: "Please enter the Remark!",
    ar: "الرجاء إدخال الملاحظة!",
  },
  "Please input the metric title": {
    en: "Please input the metric title",
    ar: "الرجاء إدخال عنوان المقياس",
  },
  "Enter description": {
    en: "Enter description",
    ar: "أدخل الوصف",
  },
  Expand: {
    en: "Expand",
    ar: "يوسع",
  },
  Collapse: {
    en: "Collapse",
    ar: "ينهار",
  },
  "No Data Points Available": {
    en: "No Data Points Available",
    ar: "لا توجد نقاط بيانات متاحة",
  },
  "See Less": {
    en: "See Less",
    ar: "انظر أقل",
  },
  "See More": {
    en: "See More",
    ar: "شاهد المزيد",
  },
  "Please input the metric name!": {
    en: "Please input the metric name!",
    ar: "الرجاء إدخال اسم المقياس!",
  },
  "Please select a metric": {
    en: "Please select a metric",
    ar: "يُرجى تحديد مقياس",
  },
  "Please select a start date!": {
    en: "Please select a start date!",
    ar: "الرجاء تحديد تاريخ البدء!",
  },
  "Metric is Better When:": {
    en: "Metric is Better When:",
    ar: "يكون المقياس أفضل عندما:",
  },
  "e.g. Debugging Team": {
    en: "e.g. Debugging Team",
    ar: "على سبيل المثال فريق تصحيح الأخطاء",
  },
  "e.g. React Dev Team": {
    en: "e.g. React Dev Team",
    ar: "على سبيل المثال، فريق تطوير React",
  },
  "Loading...": {
    en: "Loading...",
    ar: "تحميل...",
  },
  SubCategory: {
    en: "SubCategory",
    ar: "الفئة الفرعية",
  },

  "Escalate To Seniors": {
    en: "Escalate To Seniors",
    ar: "تصعيد إلى الكبار",
  },
  "Escalation Comments": {
    en: "Escalation Comments",
    ar: "تعليقات التصعيد",
  },
  Reply: {
    en: "Reply",
    ar: "رد",
  },
  "Select the urgency level for this escalation.": {
    en: "Select the urgency level for this escalation.",
    ar: "حدد مستوى الإلحاح لهذا التصعيد.",
  },
  "Select Benefits": {
    en: "Select Benefits",
    ar: "حدد المزايا",
  },
  "Type your reply here...": {
    en: "Type your reply here...",
    ar: "اكتب ردك هنا...",
  },
  Replies: {
    en: "Replies",
    ar: "الردود",
  },
  See: {
    en: "See",
    ar: "يرى",
  },
  "Personal Details": {
    en: "Personal Details",
    ar: "التفاصيل الشخصية",
  },
  "e.g. +919992999292": {
    en: "e.g. +919992999292",
    ar: "على سبيل المثال +919992999292 ",
  },
  Arabic: {
    en: "Arabic",
    ar: "عربي",
  },
  English: {
    en: "English",
    ar: "إنجليزي",
  },
  Assurance: {
    en: "Assurance",
    ar: "الضمان",
  },
  Variance: {
    en: "Variance",
    ar: "التباين",
  },
  "Select Language:": {
    en: "Select Language:",
    ar: "اختر اللغة:",
  },
  "Limit for the organisation has been reached under the plan": {
    en: "Limit for the organisation has been reached under the plan",
    ar: "تم الوصول إلى الحد الأقصى للمنظمة بموجب الخطة",
  },

  "What is it happening?": {
    en: "What is it happening?",
    ar: "لماذا تحدث؟",
  },
  "View Full Report": {
    en: "View Full Report",
    ar: "عرض التقرير الكامل",
  },

  "Radical Innovation": {
    en: "Radical Innovation",
    ar: "ابتكار جذري",
  },
  "Improvement Innovation": {
    en: "Improvement Innovation",
    ar: "ابتكار تحسيني",
  },
  "Routine Innovation": {
    en: "Routine Innovation",
    ar: "ابتكار روتيني",
  },
  "My Drawing": {
    en: "My Drawing",
    ar: "الرسم الخاص بي",
  },
  "RACI Matrix": {
    en: "RACI Matrix",
    ar: "مصفوفة RACI",
  },
  "No Task Specified": {
    en: "No Task Specified",
    ar: "لم يتم تحديد مهمة",
  },
  "Invalid data provided.": {
    en: "Invalid data provided.",
    ar: "تم تقديم بيانات غير صالحة.",
  },
  "Project Task Status": {
    en: "Project Task Status",
    ar: "حالة مهمة المشروع",
  },
  "Project Invite": {
    en: "Project Invite",
    ar: "دعوة مشروع",
  },
  "project approval": {
    en: "Project Invite",
    ar: "الموافقة على المشروع",
  },
  "Filter by Month": {
    en: "Filter by Month",
    ar: "التصفية حسب الشهر",
  },
  "Selected Benefit": {
    en: "Selected Benefit",
    ar: "فائدة مختارة",
  },
  "Forecasted Benefits": {
    en: "Forecasted Benefits",
    ar: "الفوائد المتوقعة",
  },
  "Optimistic Completion": {
    en: "Optimistic Completion",
    ar: "الانتهاء المتفائل",
  },
  "Most Likely Completion": {
    en: "Most Likely Completion",
    ar: "الانتهاء على الأرجح",
  },
  "Pessimistic Completion": {
    en: "Pessimistic Completion",
    ar: "الانتهاء المتشائم",
  },
  "Benefits Forecasting": {
    en: "Benefits Forecasting",
    ar: "التنبؤ بالفوائد",
  },
  Optimistic: {
    en: "Optimistic",
    ar: "مستبشر",
  },
  "Most Likely": {
    en: "Most Likely",
    ar: "على الأغلب",
  },
  Pessimistic: {
    en: "Pessimistic",
    ar: "متشائم",
  },
  "Actual Values Per Frequency": {
    en: "Actual Values Per Frequency",
    ar: "القيم الفعلية لكل تردد",
  },
  Baseline: {
    en: "Baseline",
    ar: "خط الأساس",
  },
  "SPC Icon": {
    en: "SPC Icon",
    ar: "رمز SPC",
  },
  "Pass/Fail": {
    en: "Pass/Fail",
    ar: "النجاح/الفشل",
  },
  "CC/Variation": {
    en: "CC/Variation",
    ar: "CC / الاختلاف",
  },
  "Forecast Position": {
    en: "Forecast Position",
    ar: "توقعات الموقف",
  },
  Date: {
    en: "Date",
    ar: "تاريخ",
  },
  "Benefits (%)": {
    en: "Benefits (%)",
    ar: "فوائد (٪)",
  },
  "100% Target": {
    en: "100% Target",
    ar: "الهدف 100%",
  },
  "No Pending Approvals!": {
    en: "No Pending Approvals!",
    ar: "لا توجد موافقات معلقة!",
  },
  "Project Breakdown - Idea to Implementation": {
    en: "Project Breakdown - Idea to Implementation",
    ar: "انهيار المشروع - الفكرة للتنفيذ",
  },
};
